<template>
  <div id="question" class="page-container">
    <div class="page-content">
      <div class="flex-row-center mt-16">
        <img
          src="../assets/images/navbar/ic_questions.webp"
          class="icon-pages"
        />
        <span class="page-title">{{ $t("page.questions") }}</span>
        <span class="page-des page-des-line-button">{{
          $t("page.questions_description")
        }}</span>
        <div class="button-title">
          <div
            @click="openCalendarModal()"
            class="flex-mid bd-r-3 mr-14 cursor-pointer calendar-modal"
          >
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M19 19H5V8h14m-3-7v2H8V1H6v2H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1V1m-1 11h-5v5h5z"/></svg>
          </div>
          <el-button
            class="btnAddQuestion"
            type="primary"
            @click="addQuestion"
            >{{ $t("questions.add_a_question") }}</el-button
          >
        </div>
      </div>

      <el-tabs class="style-bar" v-model="activeName">
        <el-tab-pane name="standard">
          <span slot="label" class="title-bar">{{ $t("page.standard") }}</span>
          <standard
            v-if="shouldRenderTab('standard')"
            :view-ready="tabReady.standard"
          ></standard>
        </el-tab-pane>
        <el-tab-pane name="custom">
          <span slot="label" class="title-bar">{{ $t("page.custom") }}</span>
          <custom
            v-if="shouldRenderTab('custom')"
            :view-ready="tabReady.custom"
          ></custom>
        </el-tab-pane>
      </el-tabs>

      <!-- create question -->
      <div id="questions_form_modal">
        <el-dialog
          width="1050px"
          top="5vh"
          :visible.sync="dialogFormVisible"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          @close="cancelDialog"
        >
          <div class="grid-2-section">
            <div class="grid-left">
              <div class="header flex-center">
                <img
                  :src="$utils('icons', 'ic_preview')"
                  style="height: 24px; margin-top: -2px"
                  class="mr-12"
                />
                <span>{{ $t("questions.preview_of_daily") }}</span>
              </div>
              <div class="body center fc-FFFFFF">
                <div class="flex-mid">
                  <div
                    v-if="!dynamicValidateForm.category"
                    class="bg-FFFFFF opa-02 image-type"
                  ></div>
                  <div v-else>
                    <img
                      :src="retrunTypName(dynamicValidateForm.category)"
                      style="height: 52px"
                    />
                  </div>
                  <div
                    v-if="!dynamicValidateForm.category"
                    class="bg-FFFFFF bd-r-7 opa-02 ml-18"
                    style="height: 39px; width: 120px"
                  ></div>
                </div>
                <div class="flex-mid mt-12">
                  <div
                    v-if="!dynamicValidateForm.category"
                    class="bg-FFFFFF bd-r-7 opa-02"
                    style="height: 19px; width: 270px"
                  ></div>
                  <div v-else fs-14 class="fc-EAEAEA opa-058">
                    {{ $t("questions.summary_of_insights") }}
                  </div>
                </div>
                <div class="flex-mid">
                  <div
                    v-if="dynamicValidateForm.type === 'Text Area Field'"
                    style="margin-top: 88px"
                  >
                    <div
                      v-if="
                        !dynamicValidateForm.question_en ||
                        !dynamicValidateForm.showResultsInDaily
                      "
                    >
                      <div
                        class="bg-FFFFFF mx-auto mt-4 bd-r-7 opa-02"
                        style="height: 23px; width: 345px"
                      ></div>
                      <div
                        class="bg-FFFFFF mx-auto mt-4 bd-r-7 opa-02"
                        style="height: 23px; width: 303px"
                      ></div>
                    </div>
                    <div v-else class="fs-20 fw-700 px-24 word-break">
                      {{ dynamicValidateForm.question_en }}
                    </div>
                    <div
                      class="mt-20"
                      v-for="index in ['1id', '2id', '3id']"
                      :key="index"
                    >
                      <div
                        class="bg-FFFFFF mx-auto bd-r-7 opa-02"
                        style="height: 16px; width: 269px"
                      ></div>
                      <div
                        class="bg-FFFFFF mx-auto mt-4 bd-r-7 opa-02"
                        style="height: 16px; width: 201px"
                      ></div>
                    </div>
                  </div>
                  <div v-else class="question-card">
                    <div
                      class="
                        card-header
                        pt-14
                        pb-10
                        px-16
                        fw-700
                        fs-15
                        word-break
                        left
                      "
                    >
                      <div
                        v-if="
                          dynamicValidateForm.questions.en &&
                          dynamicValidateForm.showResultsInDaily
                        "
                      >
                        {{ dynamicValidateForm.questions.en }}
                      </div>
                      <div v-else>
                        <div
                          class="bg-000000 bd-r-7 opa-02"
                          style="height: 19px; width: 167px"
                        ></div>
                        <div
                          class="bg-000000 bd-r-7 opa-02 mt-4"
                          style="height: 19px; width: 130px"
                        ></div>
                      </div>
                    </div>
                    <div
                      class="card-body fc-000000 pt-18 pb-10 px-20 word-break"
                    >
                      <div
                        v-if="
                          dynamicValidateForm.type ===
                            'Multiple Choice(other)' &&
                          dynamicValidateForm.questions.en &&
                          dynamicValidateForm.showResultsInDaily
                        "
                      >
                        <div class="fs-24 fw-900">80%</div>
                        <div class="fs-13">
                          {{ $t("questions.responded") }}
                          {{ previewOptionsText(dynamicValidateForm.options) }}
                        </div>
                        <div class="fs-13 fc-B7B7B7 mt-6">
                          {{ $t("questions.of_ten_direct") }}
                        </div>
                      </div>
                      <div
                        v-else-if="
                          dynamicValidateForm.type === 'Multiple Choice' &&
                          dynamicValidateForm.questions.en &&
                          dynamicValidateForm.showResultsInDaily
                        "
                      >
                        <div class="fs-24 fw-900">80%</div>
                        <div class="fs-13">
                          {{ $t("questions.responded") }} "{{
                            $t("questions.yes")
                          }}"
                        </div>
                        <div class="fs-13 fc-B7B7B7 mt-6">
                          {{ $t("questions.of_ten_direct") }}
                        </div>
                      </div>
                      <div
                        class="fc-3B3B3B"
                        v-else-if="
                          dynamicValidateForm.type === 'Scale' &&
                          dynamicValidateForm.questions.en &&
                          dynamicValidateForm.showResultsInDaily
                        "
                      >
                        <div class="fs-24 fw-900">8.3</div>
                        <div class="fs-13">
                          {{ $t("questions.average_rating_out") }}
                        </div>
                        <div class="fs-13 fc-B7B7B7 mt-6">
                          {{ $t("questions.of_ten_direct") }}
                        </div>
                      </div>
                      <div v-else>
                        <div
                          class="bg-000000 bd-r-7 opa-02 mx-auto"
                          style="height: 28px; width: 68px"
                        ></div>
                        <div
                          class="bg-000000 bd-r-3 opa-02 mx-auto mt-5"
                          style="height: 14px; width: 135px"
                        ></div>
                        <div
                          class="bg-000000 bd-r-3 opa-01 mx-auto mt-8"
                          style="height: 14px; width: 107px"
                        ></div>
                      </div>
                      <div
                        class="flex-mid mt-30"
                        v-if="
                          dynamicValidateForm.type &&
                          dynamicValidateForm.questions.en &&
                          dynamicValidateForm.showResultsInDaily
                        "
                      >
                        <div
                          class="bg-27BC6C mr-4"
                          style="height: 12px; width: 12px; border-radius: 12px"
                        ></div>
                        <div class="fs-12 mt-2 fc-3B3B3B">
                          <span class="fw-900">9.2</span> of 50 overall
                        </div>
                      </div>
                      <div v-else class="flex-mid mt-30">
                        <div
                          class="bg-000000 opa-02 ml-auto mr-4"
                          style="height: 12px; width: 12px; border-radius: 12px"
                        ></div>
                        <div
                          class="bg-000000 bd-r-3 opa-02 mr-auto"
                          style="height: 14px; width: 107px"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid-right fc-000000">
              <div class="fs-20 fw-700">{{ title_dialog }}</div>

              <div style="margin-top:24px">
                <div style="position: relative;">
                <el-input
                      type="textarea"
                      style="width: 584px;height: 104px;"
                      v-model="questions_text"
                      auto-complete="off"
                      class="custom-textarea"
                      placeholder="I want to understand how well people understand our #excellence value"
                    >
                    
                  </el-input>
                  <div style="position: absolute;top:65px;left: 446px;">  
                    <el-button
                      class="generate-question "
                      type="primary"
                      @click="genQuestion"
                      >Generate Question</el-button>
                  </div>
                </div>
                  
              </div>

              <div style="display: flex;justify-content: center;margin-top: 30px;" v-if="getquestionLoading"> 
                <loading-even></loading-even>
              </div>
              <div v-else>
              <el-form
                :model="dynamicValidateForm"
                ref="dynamicValidateForm"
                style="margin-left: 30%; margin-right: 32px"
              >
              <el-menu
                  style
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
              >
              <el-menu-item
                v-for="(item, index) in language"
                :key="index"
                :index="item.code" 
                style="padding-left: 0" >
                {{
                  item.text
                }}
              </el-menu-item>
              </el-menu>




                <!-- <el-menu
                  style
                  :default-active="activeIndex"
                  class="el-menu-demo"
                  mode="horizontal"
                  @select="handleSelect"
                >
                  <el-menu-item style="padding-left: 0" index="1">{{
                    $t("global.english")
                  }}</el-menu-item>
                  <el-menu-item index="2" v-if="!engonly">{{
                    $t("global.thai")
                  }}</el-menu-item>
                </el-menu> -->
                <br />
                <div style="margin-left: -130px">
                  <el-form-item :label-width="formLabelWidthF">
                    <div class="ml-auto recipients-count">
                      <span
                        class="top-header cursor-pointer"
                        @click="openRecipientsDialog"
                        >{{
                          dynamicValidateForm.recipients
                            ? dynamicValidateForm.recipients.length
                            : allUsers.length
                        }}
                        recipients</span
                      >
                    </div>
                  </el-form-item>
                </div>
                <div style="margin-left: -130px">
                  <el-form-item
                    label="Send to"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-cascader
                      style="width: 100%"
                      class="defaulttags"
                      :placeholder="$t('powerUp.Name_of_Recipient_s')"
                      v-model="dynamicValidateForm.cascaderTo"
                      :options="option_To"
                      :props="propsCofig"
                      :disabled="!refreshInput"
                      @change="changeDataToCascader"
                      :collapse-tags="
                        dynamicValidateForm.cascaderTo
                          ? dynamicValidateForm.cascaderTo.length > 8
                          : dynamicValidateForm.cascaderTo
                      "
                      :debounce="500"
                      :filter-method="filterToFunction"
                      filterable
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <template slot-scope="{ data }">
                        <span :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ data.label }}</span>
                      </template>
                    </el-cascader>
                  </el-form-item>
                </div>

                





                <div  style="margin-left: -130px">
                  <el-form-item
                    :label="$t('global.type')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <div class="flex">
                      <div class="mr-6">
                        <el-select
                          v-model="dynamicValidateForm.category"
                          style="width: 100%"
                          placeholder="Select Dimension"
                        >
                          <el-option
                            v-for="item in optionsCategory"
                            :key="item.key"
                            :label="item.category"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="ml-6">
                        <el-select
                          v-model="dynamicValidateForm.type"
                          style="width: 100%"
                          :placeholder="$t('questions.Question_Format')"
                          @change="onChangeQuestionsType(dynamicValidateForm.type)"
                        >
                          <el-option
                            :label="$t('questions.open_ended')"
                            value="Text Area Field"
                          ></el-option>
                          <el-option
                            :label="$t('questions.yes_or_no')"
                            value="Multiple Choice"
                          ></el-option>
                          <el-option
                            :label="$t('questions.multiple_choice')"
                            value="Multiple Choice(other)"
                          ></el-option>
                          <el-option label="Scale" value="Scale"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item
                    :label="$t('questions.question')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-input
                      v-model="dynamicValidateForm.questions[activeIndex]"
                      auto-complete="off"
                      :placeholder="
                        questionPlaceholder(dynamicValidateForm.type, '')
                      "
                    ></el-input>
                  </el-form-item>
                  <div v-if="dynamicValidateForm.type == 'Multiple Choice'">


                    <el-form-item
                    v-for="(options, index) in getActiveOptions()"
                    :key="options.key"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                    :label="options.placeholder + ' ' + $t('questions.option')"
                    class="title-input-form"
                    :prop="activeIndex === 'en' || activeIndex === 'th' 
                      ? `options_${activeIndex}.` + index + '.value' 
                      : `options_YN.${activeIndex}.` + index + '.value'"
                  >
                 
                    <div class="flex">
                      <div class="mr-6">
                        <el-input
                          v-model="options.value"
                          auto-complete="off"
                          @input="updateOptionValue(index, $event)"
                          :readonly="isReadonly()"
                          :key="isReadonly() ? 'readonly-input' : 'editable-input'"
                        ></el-input>
                      </div>
                      <div class="ml-6">
                        <div v-if="index == 0">
                          <el-select
                            v-model="dynamicValidateForm.feelingY"
                            style="width:95%"
                            @change="onChangeY(dynamicValidateForm.feelingY)"
                          >
                            <el-option
                              :label="$t('questions.positive')"
                              value="Positive"
                            ></el-option>
                            <el-option
                              :label="$t('questions.neutral')"
                              value="Neutral"
                            ></el-option>
                            <el-option
                              :label="$t('questions.negative')"
                              value="Negative"
                            ></el-option>
                          </el-select>
                        </div>
                        <div v-else>
                          <el-select
                            v-model="dynamicValidateForm.feelingN"
                            style="width:95%"
                            @change="onChangeN(dynamicValidateForm.feelingN)"
                          >
                            <el-option
                              :label="$t('questions.positive')"
                              value="Positive"
                            ></el-option>
                            <el-option
                              :label="$t('questions.neutral')"
                              value="Neutral"
                            ></el-option>
                            <el-option
                              :label="$t('questions.negative')"
                              value="Negative"
                            ></el-option>
                          </el-select>
                        </div>
                      </div>
                      <div>
                        <el-button
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index, options)"
                        >
                          O->
                        </el-button>
                      </div>
                    </div>
                  </el-form-item>
                    <!-- <el-form-item
                      v-if="activeIndex=='en'||activeIndex=='th'"
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      v-for="(options, index) in dynamicValidateForm[`options_${activeIndex}`]"
                      :label="
                        options.placeholder + ' ' + $t('questions.option')
                      "
                      class="title-input-form"
                      :key="options.key"
                      :prop="`options_${activeIndex}.` + index + '.value'"
                    >
                      <div class="flex">
                        <div class="mr-6">
                          <el-input
                            v-model="options.value"
                            auto-complete="off"
                            readonly
                             :key="'readonly-input'"
                          ></el-input>
                         
                        </div>
                        <div class="ml-6">
                          <div v-if="index == 0">
                            <el-select
                              v-model="dynamicValidateForm.feelingY"
                              style="width:95%"
                              @change="onChangeY(dynamicValidateForm.feelingY)"
                            >
                              <el-option
                                :label="$t('questions.positive')"
                                value="Positive"
                              ></el-option>
                              <el-option
                                :label="$t('questions.neutral')"
                                value="Neutral"
                              ></el-option>
                              <el-option
                                :label="$t('questions.negative')"
                                value="Negative"
                              ></el-option>
                            </el-select>
                          </div>
                          <div v-else>
                            <el-select
                              v-model="dynamicValidateForm.feelingN"
                              style="width:95%"
                              @change="onChangeN(dynamicValidateForm.feelingN)"
                            >
                              <el-option
                                :label="$t('questions.positive')"
                                value="Positive"
                              ></el-option>
                              <el-option
                                :label="$t('questions.neutral')"
                                value="Neutral"
                              ></el-option>
                              <el-option
                                :label="$t('questions.negative')"
                                value="Negative"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                        <div>
                          <el-button 
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index,options)">
                            O->
                          </el-button>
                        </div>
                      </div>
                    </el-form-item> -->
                  

                  </div>
                  <div
                    v-if="dynamicValidateForm.type == 'Multiple Choice(other)'"
                  >
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      v-for="(options, index) in dynamicValidateForm.options"
                      :label="$t('questions.option') + ' ' + increase(index)"
                      class="title-input-form"
                      :key="options.key"
                    >
                      <div class="flex">
                        <div class="mr-6">
                          <div v-if="index < 2">
                            <el-input
                              auto-complete="off"
                              v-model="options[activeIndex]"
                              :placeholder="'Option ' + increase(index)"
                            >
                            </el-input>
                          </div>
                          <div v-else style="width: 172.2px">
                            <el-input
                              auto-complete="off"
                              v-model="options[activeIndex]"
                              :placeholder="'Option ' + increase(index)"
                            >
                              <i
                                slot="suffix"
                                class="el-icon-remove-outline"
                                @click="deleteOptions(options)"
                              ></i>
                            </el-input>
                          </div>
                        </div>
                        <div class="ml-6">
                          <el-select
                            v-model="options.feeling"
                            style="width:95%"
                            placeholder="Assign a Sentiment"
                          >
                            <el-option
                              :label="$t('questions.positive')"
                              value="Positive"
                            ></el-option>
                            <el-option
                              :label="$t('questions.neutral')"
                              value="Neutral"
                            ></el-option>
                            <el-option
                              :label="$t('questions.negative')"
                              value="Negative"
                            ></el-option>
                          </el-select>
                        </div>

                        
                        <div>
                          <el-button 
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index,options)">
                            O->
                          </el-button>
                        </div>
                      </div>

                    </el-form-item>
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                    >
                      <el-button class="btnAddOption" @click="addOptions">{{
                        $t("questions.add_option")
                      }}</el-button>
                    </el-form-item>
                  </div>
                  <div v-if="dynamicValidateForm.type == 'Scale'">
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      :label="$t('questions.min_label')"
                      class="title-input-form"
                    >
                      <el-col :span="13">
                        <el-input
                          auto-complete="off"
                          v-model="dynamicValidateForm.less_txts[activeIndex]"
                          placeholder="Not at all"
                        >
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input
                          auto-complete="off"
                          :disabled="true"
                          v-model="dynamicValidateForm.min"
                        >
                        </el-input>
                      </el-col>
                    </el-form-item>
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      :label="$t('questions.max_label')"
                      class="title-input-form"
                    >
                      <el-col :span="13">
                        <el-input
                          auto-complete="off"
                          placeholder="Very important"
                          v-model="dynamicValidateForm.max_txts[activeIndex]"
                        >
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input
                          auto-complete="off"
                          :disabled="true"
                          v-model="dynamicValidateForm.max"
                        >
                        </el-input>
                      </el-col>
                    </el-form-item>
                  </div>
                  <el-form-item
                    :label="$t('questions.reward')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-input
                      v-model="dynamicValidateForm.coins"
                      type="number"
                      :min="0"
                      auto-complete="off"
                      style="width: 100%"
                      placeholder="Coins"
                    >
                      <template slot="append">Coins</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.type == 'Text Area Field'"
                    :label="$t('questions.power_skill')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.powerSkill"
                      style="width: 100%"
                      :placeholder="$t('questions.select_power_skill')"
                      clearable
                    >
                      <el-option
                        :label="$t('category.power_skill.empathy')"
                        value="ps_empathy"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.self_awareness')"
                        value="ps_self_awareness"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.leadership')"
                        value="ps_leadership"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.initiative_making')"
                        value="ps_initiative_making"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.optimism')"
                        value="ps_optimism"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.critical_thinking')"
                        value="ps_critical_thinking"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="$t('questions.frequency')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.frequency"
                      style="width: 100%"
                      @change="scheduleChange"
                      :placeholder="$t('questions.how_often_do')"
                    >
                      <el-option
                        :label="$t('category.frequency.one_time')"
                        value="onetime"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.weekly')"
                        value="weekly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.monthly')"
                        value="monthly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.quarterly')"
                        value="quarterly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.biannually')"
                        value="biannually"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.yearly')"
                        value="yearly"
                      ></el-option>
                      <el-option
                        label="Follow up"
                        value="Follow-up"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency!='Follow-up'"
                    class="title-input-form"
                    :label="$t('questions.day_of_week')"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.dayofweek"
                      style="width: 100%"
                      @change="scheduleChange"
                      :placeholder="$t('questions.what_day_of')"
                    >
                      <el-option
                        :label="$t('category.day_of_week.monday')"
                        value="monday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.tuesday')"
                        value="tuesday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.wednesday')"
                        value="wednesday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.thursday')"
                        value="thursday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.friday')"
                        value="friday"
                      ></el-option>
                      <el-option
                        v-if="dataCompany && dataCompany.alldays == true"
                        :label="$t('category.day_of_week.saturday')"
                        value="saturday"
                      ></el-option>
                      <el-option
                        v-if="dataCompany && dataCompany.alldays == true"
                        :label="$t('category.day_of_week.sunday')"
                        value="sunday"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == ''"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      :no-data-text="$t('questions.please_select_frequency')"
                      style="width: 100%"
                      :placeholder="$t('questions.and_when')"
                    ></el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'onetime'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in optionsScheduleOnetime"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                      <div class="styleMoreOption" @click="moreOptionClick">
                        <span>{{ $t("questions.more") }}...</span>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'weekly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        :label="`Every ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        }`"
                        :value="dynamicValidateForm.dayofweek"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'monthly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        :label="`First ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week1"
                      ></el-option>
                      <el-option
                        :label="`Second ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week2"
                      ></el-option>
                      <el-option
                        :label="`Third ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week3"
                      ></el-option>
                      <el-option
                        :label="`Fourth ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week4"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'quarterly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_quarterly"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'biannually'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_biannually"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'yearly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_yearly"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </div>







                <!-- <div v-if="activeIndex == '1'" style="margin-left: -130px">
                  <el-form-item
                    :label="$t('global.type')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <div class="flex">
                      <div class="mr-6">
                        <el-select
                          v-model="dynamicValidateForm.category"
                          style="width: 100%"
                          placeholder="Select Dimension"
                        >
                          <el-option
                            v-for="item in optionsCategory"
                            :key="item.key"
                            :label="item.category"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="ml-6">
                        <el-select
                          v-model="dynamicValidateForm.type"
                          style="width: 100%"
                          :placeholder="$t('questions.Question_Format')"
                          @change="onChangeQuestionsType(dynamicValidateForm.type)"
                        >
                          <el-option
                            :label="$t('questions.open_ended')"
                            value="Text Area Field"
                          ></el-option>
                          <el-option
                            :label="$t('questions.yes_or_no')"
                            value="Multiple Choice"
                          ></el-option>
                          <el-option
                            :label="$t('questions.multiple_choice')"
                            value="Multiple Choice(other)"
                          ></el-option>
                          <el-option label="Scale" value="Scale"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item
                    :label="$t('questions.question')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-input
                      v-model="dynamicValidateForm.question_en"
                      auto-complete="off"
                      :placeholder="
                        questionPlaceholder(dynamicValidateForm.type, '')
                      "
                    ></el-input>
                  </el-form-item>
                  <div v-if="dynamicValidateForm.type == 'Multiple Choice'">
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      v-for="(options, index) in dynamicValidateForm.options_en"
                      :label="
                        options.placeholder + ' ' + $t('questions.option')
                      "
                      class="title-input-form"
                      :key="options.key"
                      :prop="'options_en.' + index + '.value'"
                    >
                      <div class="flex">
                        <div class="mr-6">
                          <el-input
                            v-model="options.value"
                            auto-complete="off"
                            readonly
                          ></el-input>
                        </div>
                        <div class="ml-6">
                          <div v-if="index == 0">
                            <el-select
                              v-model="dynamicValidateForm.feelingY"
                              style="width:95%"
                              @change="onChangeY(dynamicValidateForm.feelingY)"
                            >
                              <el-option
                                :label="$t('questions.positive')"
                                value="Positive"
                              ></el-option>
                              <el-option
                                :label="$t('questions.neutral')"
                                value="Neutral"
                              ></el-option>
                              <el-option
                                :label="$t('questions.negative')"
                                value="Negative"
                              ></el-option>
                            </el-select>
                          </div>
                          <div v-else>
                            <el-select
                              v-model="dynamicValidateForm.feelingN"
                              style="width:95%"
                              @change="onChangeN(dynamicValidateForm.feelingN)"
                            >
                              <el-option
                                :label="$t('questions.positive')"
                                value="Positive"
                              ></el-option>
                              <el-option
                                :label="$t('questions.neutral')"
                                value="Neutral"
                              ></el-option>
                              <el-option
                                :label="$t('questions.negative')"
                                value="Negative"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                        <div>
                          <el-button 
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index,options)">
                            O->
                          </el-button>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div
                    v-if="dynamicValidateForm.type == 'Multiple Choice(other)'"
                  >
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      v-for="(options, index) in dynamicValidateForm.options"
                      :label="$t('questions.option') + ' ' + increase(index)"
                      class="title-input-form"
                      :key="options.key"
                    >
                      <div class="flex">
                        <div class="mr-6">
                          <div v-if="index < 2">
                            <el-input
                              auto-complete="off"
                              v-model="options.en"
                              :placeholder="'Option ' + increase(index)"
                            >
                            </el-input>
                          </div>
                          <div v-else style="width: 172.2px">
                            <el-input
                              auto-complete="off"
                              v-model="options.en"
                              :placeholder="'Option ' + increase(index)"
                            >
                              <i
                                slot="suffix"
                                class="el-icon-remove-outline"
                                @click="deleteOptions(options)"
                              ></i>
                            </el-input>
                          </div>
                        </div>
                        <div class="ml-6">
                          <el-select
                            v-model="options.feeling"
                            style="width:95%"
                            placeholder="Assign a Sentiment"
                          >
                            <el-option
                              :label="$t('questions.positive')"
                              value="Positive"
                            ></el-option>
                            <el-option
                              :label="$t('questions.neutral')"
                              value="Neutral"
                            ></el-option>
                            <el-option
                              :label="$t('questions.negative')"
                              value="Negative"
                            ></el-option>
                          </el-select>
                        </div>

                        
                        <div>
                          <el-button 
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index,options)">
                            O->
                          </el-button>
                        </div>
                      </div>

                    </el-form-item>
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                    >
                      <el-button class="btnAddOption" @click="addOptions">{{
                        $t("questions.add_option")
                      }}</el-button>
                    </el-form-item>
                  </div>
                  <div v-if="dynamicValidateForm.type == 'Scale'">
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      :label="$t('questions.min_label')"
                      class="title-input-form"
                    >
                      <el-col :span="13">
                        <el-input
                          auto-complete="off"
                          v-model="dynamicValidateForm.less_txt_en"
                          placeholder="Not at all"
                        >
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input
                          auto-complete="off"
                          :disabled="true"
                          v-model="dynamicValidateForm.min"
                        >
                        </el-input>
                      </el-col>
                    </el-form-item>
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      :label="$t('questions.max_label')"
                      class="title-input-form"
                    >
                      <el-col :span="13">
                        <el-input
                          auto-complete="off"
                          placeholder="Very important"
                          v-model="dynamicValidateForm.max_txt_en"
                        >
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input
                          auto-complete="off"
                          :disabled="true"
                          v-model="dynamicValidateForm.max"
                        >
                        </el-input>
                      </el-col>
                    </el-form-item>
                  </div>
                  <el-form-item
                    :label="$t('questions.reward')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-input
                      v-model="dynamicValidateForm.coins"
                      type="number"
                      :min="0"
                      auto-complete="off"
                      style="width: 100%"
                      placeholder="Coins"
                    >
                      <template slot="append">Coins</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.type == 'Text Area Field'"
                    :label="$t('questions.power_skill')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.powerSkill"
                      style="width: 100%"
                      :placeholder="$t('questions.select_power_skill')"
                      clearable
                    >
                      <el-option
                        :label="$t('category.power_skill.empathy')"
                        value="ps_empathy"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.self_awareness')"
                        value="ps_self_awareness"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.leadership')"
                        value="ps_leadership"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.initiative_making')"
                        value="ps_initiative_making"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.optimism')"
                        value="ps_optimism"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.critical_thinking')"
                        value="ps_critical_thinking"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="$t('questions.frequency')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.frequency"
                      style="width: 100%"
                      @change="scheduleChange"
                      :placeholder="$t('questions.how_often_do')"
                    >
                      <el-option
                        :label="$t('category.frequency.one_time')"
                        value="onetime"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.weekly')"
                        value="weekly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.monthly')"
                        value="monthly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.quarterly')"
                        value="quarterly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.biannually')"
                        value="biannually"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.yearly')"
                        value="yearly"
                      ></el-option>
                      <el-option
                        label="Follow up"
                        value="Follow-up"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency!='Follow-up'"
                    class="title-input-form"
                    :label="$t('questions.day_of_week')"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.dayofweek"
                      style="width: 100%"
                      @change="scheduleChange"
                      :placeholder="$t('questions.what_day_of')"
                    >
                      <el-option
                        :label="$t('category.day_of_week.monday')"
                        value="monday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.tuesday')"
                        value="tuesday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.wednesday')"
                        value="wednesday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.thursday')"
                        value="thursday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.friday')"
                        value="friday"
                      ></el-option>
                      <el-option
                        v-if="dataCompany && dataCompany.alldays == true"
                        :label="$t('category.day_of_week.saturday')"
                        value="saturday"
                      ></el-option>
                      <el-option
                        v-if="dataCompany && dataCompany.alldays == true"
                        :label="$t('category.day_of_week.sunday')"
                        value="sunday"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == ''"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      :no-data-text="$t('questions.please_select_frequency')"
                      style="width: 100%"
                      :placeholder="$t('questions.and_when')"
                    ></el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'onetime'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in optionsScheduleOnetime"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                      <div class="styleMoreOption" @click="moreOptionClick">
                        <span>{{ $t("questions.more") }}...</span>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'weekly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        :label="`Every ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        }`"
                        :value="dynamicValidateForm.dayofweek"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'monthly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        :label="`First ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week1"
                      ></el-option>
                      <el-option
                        :label="`Second ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week2"
                      ></el-option>
                      <el-option
                        :label="`Third ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week3"
                      ></el-option>
                      <el-option
                        :label="`Fourth ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week4"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'quarterly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_quarterly"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'biannually'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_biannually"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'yearly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_yearly"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-if="activeIndex == '2'" style="margin-left: -130px">
                  <el-form-item
                    :label="$t('global.type')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <div class="flex">
                      <div class="mr-6">
                        <el-select
                          v-model="dynamicValidateForm.category"
                          style="width: 100%"
                          placeholder="Select Dimension"
                        >
                          <el-option
                            v-for="item in optionsCategory"
                            :key="item.key"
                            :label="item.category"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="ml-6">
                        <el-select
                          v-model="dynamicValidateForm.type"
                          style="width: 100%"
                          :placeholder="$t('questions.Question_Format')"
                          @change="onChangeQuestionsType(dynamicValidateForm.type)"
                        >
                          <el-option
                            :label="$t('questions.open_ended')"
                            value="Text Area Field"
                          ></el-option>
                          <el-option
                            :label="$t('questions.yes_or_no')"
                            value="Multiple Choice"
                          ></el-option>
                          <el-option
                            :label="$t('questions.multiple_choice')"
                            value="Multiple Choice(other)"
                          ></el-option>
                          <el-option label="Scale" value="Scale"></el-option>
                        </el-select>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item
                    class="title-input-form"
                    :label="$t('questions.question')"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-input
                      v-model="dynamicValidateForm.question_th"
                      auto-complete="off"
                      :placeholder="
                        questionPlaceholder(dynamicValidateForm.type, '(Thai)')
                      "
                    ></el-input>
                  </el-form-item>
                  <div v-if="dynamicValidateForm.type == 'Multiple Choice'">
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      v-for="(options, index) in dynamicValidateForm.options_th"
                      :label="options.placeholder + ' Option'"
                      class="title-input-form"
                      :key="options.key"
                      :prop="'options_th.' + index + '.value'"
                    >
                      <div class="flex">
                        <div class="mr-6" :span="12">
                          <el-input
                            v-model="options.value"
                            auto-complete="off"
                            readonly
                          ></el-input>
                        </div>
                        <div class="ml-6">
                          <div class="ml-6"></div>
                          <div v-if="index == 0">
                            <el-select
                              v-model="dynamicValidateForm.feelingY"
                              style="width: 95%"
                              @change="onChangeY(dynamicValidateForm.feelingY)"
                            >
                              <el-option
                                :label="$t('questions.positive')"
                                value="Positive"
                              ></el-option>
                              <el-option
                                :label="$t('questions.neutral')"
                                value="Neutral"
                              ></el-option>
                              <el-option
                                :label="$t('questions.negative')"
                                value="Negative"
                              ></el-option>
                            </el-select>
                          </div>
                          <div v-else>
                            <el-select
                              v-model="dynamicValidateForm.feelingN"
                              style="width: 95%"
                              @change="onChangeN(dynamicValidateForm.feelingN)"
                            >
                              <el-option
                                :label="$t('questions.positive')"
                                value="Positive"
                              ></el-option>
                              <el-option
                                :label="$t('questions.neutral')"
                                value="Neutral"
                              ></el-option>
                              <el-option
                                :label="$t('questions.negative')"
                                value="Negative"
                              ></el-option>
                            </el-select>
                          </div>
                        </div>
                        <div>
                          <el-button 
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index,options)">
                            O->
                          </el-button>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                  <div
                    v-if="dynamicValidateForm.type == 'Multiple Choice(other)'"
                  >
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      v-for="(options, index) in dynamicValidateForm.options"
                      :label="$t('questions.option') + ' ' + increase(index)"
                      class="title-input-form"
                      :key="options.key"
                    >
                      <div class="flex">
                        <div class="mr-6">
                          <div v-if="index < 2">
                            <el-input
                              auto-complete="off"
                              v-model="options.th"
                              :placeholder="
                                $t('questions.option') + ' ' + increase(index)
                              "
                            >
                            </el-input>
                          </div>
                          <div v-else style="width: 172.2px">
                            <el-input
                              auto-complete="off"
                              v-model="options.th"
                              :placeholder="
                                $t('questions.option') + ' ' + increase(index)
                              "
                            >
                              <i
                                slot="suffix"
                                class="el-icon-remove-outline"
                                @click="deleteOptions(options)"
                              ></i>
                            </el-input>
                          </div>
                        </div>
                        <div class="ml-6">
                          <el-select
                            v-model="options.feeling"
                            style="width: 95%"
                            :placeholder="$t('questions.assign_a_sentiment')"
                          >
                            <el-option
                              :label="$t('questions.positive')"
                              value="Positive"
                            ></el-option>
                            <el-option
                              :label="$t('questions.neutral')"
                              value="Neutral"
                            ></el-option>
                            <el-option
                              :label="$t('questions.negative')"
                              value="Negative"
                            ></el-option>
                          </el-select>
                        </div>

                        <div>
                          <el-button 
                          :style="`width:40px;padding: 12px 3px;${getstylefollowUp(options)}`"
                          @click="getfollow_up_question(index,options)">
                            O->
                          </el-button>
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                    >
                      <el-button class="btnAddOption" @click="addOptions">{{
                        $t("questions.add_option")
                      }}</el-button>
                    </el-form-item>
                  </div>
                  <div v-if="dynamicValidateForm.type == 'Scale'">
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      :label="$t('questions.min_label')"
                      class="title-input-form"
                    >
                      <el-col :span="13">
                        <el-input
                          auto-complete="off"
                          v-model="dynamicValidateForm.less_txt"
                          placeholder="Not at all"
                        >
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input
                          auto-complete="off"
                          :disabled="true"
                          v-model="dynamicValidateForm.min"
                        >
                        </el-input>
                      </el-col>
                    </el-form-item>
                    <el-form-item
                      :label-width="formLabelWidthF"
                      style="margin-bottom: 12px"
                      :label="$t('questions.max_label')"
                      class="title-input-form"
                    >
                      <el-col :span="13">
                        <el-input
                          auto-complete="off"
                          v-model="dynamicValidateForm.max_txt"
                          placeholder="Very important"
                        >
                        </el-input>
                      </el-col>
                      <el-col :span="1">&nbsp;</el-col>
                      <el-col :span="10">
                        <el-input
                          auto-complete="off"
                          :disabled="true"
                          v-model="dynamicValidateForm.max"
                        >
                        </el-input>
                      </el-col>
                    </el-form-item>
                  </div>
                  <el-form-item
                    :label="$t('questions.reward')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-input
                      v-model="dynamicValidateForm.coins"
                      type="number"
                      :min="0"
                      auto-complete="off"
                      style="width: 100%"
                      placeholder="Coins"
                      :label="$t('questions.coins')"
                    >
                      <template slot="append">{{
                        $t("questions.coins")
                      }}</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.type == 'Text Area Field'"
                    :label="$t('questions.power_skill')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.powerSkill"
                      style="width: 100%"
                      :placeholder="$t('questions.select_power_skill')"
                      clearable
                    >
                      <el-option
                        :label="$t('category.power_skill.empathy')"
                        value="ps_empathy"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.self_awareness')"
                        value="ps_self_awareness"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.leadership')"
                        value="ps_leadership"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.initiative_making')"
                        value="ps_initiative_making"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.optimism')"
                        value="ps_optimism"
                      ></el-option>
                      <el-option
                        :label="$t('category.power_skill.critical_thinking')"
                        value="ps_critical_thinking"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="$t('questions.frequency')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.frequency"
                      style="width: 100%"
                      @change="scheduleChange"
                      :placeholder="$t('questions.how_often_do')"
                    >
                      <el-option
                        :label="$t('category.frequency.one_time')"
                        value="onetime"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.weekly')"
                        value="weekly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.monthly')"
                        value="monthly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.quarterly')"
                        value="quarterly"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.biannually')"
                        value="biannually"
                      ></el-option>
                      <el-option
                        :label="$t('category.frequency.yearly')"
                        value="yearly"
                      ></el-option>
                      <el-option
                        label="Follow up"
                        value="Follow-up"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency!='Follow-up'"
                    :label="$t('questions.day_of_week')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.dayofweek"
                      style="width: 100%"
                      @change="scheduleChange"
                      :placeholder="$t('questions.what_day_of')"
                    >
                      <el-option
                        :label="$t('category.day_of_week.monday')"
                        value="monday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.tuesday')"
                        value="tuesday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.wednesday')"
                        value="wednesday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.thursday')"
                        value="thursday"
                      ></el-option>
                      <el-option
                        :label="$t('category.day_of_week.friday')"
                        value="friday"
                      ></el-option>
                      <el-option
                        v-if="dataCompany && dataCompany.alldays == true"
                        :label="$t('category.day_of_week.saturday')"
                        value="saturday"
                      ></el-option>
                      <el-option
                        v-if="dataCompany && dataCompany.alldays == true"
                        :label="$t('category.day_of_week.sunday')"
                        value="sunday"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == ''"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      :no-data-text="$t('questions.please_select_frequency')"
                      style="width: 100%"
                      :placeholder="$t('questions.and_when')"
                    ></el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'onetime'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in optionsScheduleOnetime"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                      <div class="styleMoreOption" @click="moreOptionClick">
                        <span>{{ $t("questions.more") }}...</span>
                      </div>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'weekly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        :label="`Every ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        }`"
                        :value="dynamicValidateForm.dayofweek"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'monthly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option
                        :label="`First ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week1"
                      ></el-option>
                      <el-option
                        :label="`Second ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week2"
                      ></el-option>
                      <el-option
                        :label="`Third ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week3"
                      ></el-option>
                      <el-option
                        :label="`Fourth ${
                          dynamicValidateForm.dayofweek
                            .charAt(0)
                            .toUpperCase() +
                          dynamicValidateForm.dayofweek.slice(1)
                        } of each month`"
                        value="week4"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'quarterly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_quarterly"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'biannually'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_biannually"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-if="dynamicValidateForm.frequency == 'yearly'"
                    :label="$t('questions.schedule')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <el-select
                      v-model="dynamicValidateForm.schedule"
                      style="width: 100%"
                    >
                      <el-option-group
                        v-for="group in options_yearly"
                        :key="group.label"
                        :label="group.label"
                      >
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                </div> -->



                <div v-if="dynamicValidateForm.frequency!='Follow-up'">

                <!-- Response Settings Section (only show header if there will be a Report Card Analytics section) -->
                <div v-if="dynamicValidateForm.type === 'Multiple Choice' || dynamicValidateForm.type === 'Multiple Choice(other)' || !disabledRowHeader" class="fs-13 fw-700 fc-000000 opa-05 mb-16" style="margin-left: -24px; letter-spacing: 0.5px; text-transform: uppercase;">Response Settings</div>

                <div class="flex mb-16" style="margin-left: -24px">
                  <div
                    class="relative switch-contrainer"
                  >
                    <input
                      type="checkbox"
                      id="rolling"
                      class="input-checkbox"
                      v-model="dynamicValidateForm.rolling"
                    />
                    <label for="rolling" class="lable-checkbox">{{
                      dynamicValidateForm.rolling
                    }}</label>
                  </div>
                  <div class="fs-14 fw-700 fc-000000 opa-07 mt-5 ml-12" style="position: relative">
                    Rolling Response
                    <el-tooltip class="header-table-tooltip" placement="top">
                      <div slot="content" class="p-5">
                        <div style="max-width: 250px">
                          Persist until the next occurrence of this question, delivering it until a response is provided
                        </div>
                      </div>
                      <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer" style="position: absolute; top: 1px;"
                alt="icons_ic_help_outline-16px" />
                    </el-tooltip>
                  </div>
                </div>

                <div class="flex mb-16" style="margin-left: -24px">
                  <div
                    class="relative switch-contrainer"
                  >
                    <input
                      type="checkbox"
                      id="showResultsInDaily"
                      class="input-checkbox"
                      v-model="dynamicValidateForm.showResultsInDaily"
                    />
                    <label for="showResultsInDaily" class="lable-checkbox">{{
                      dynamicValidateForm.showResultsInDaily
                    }}</label>
                  </div>
                  <div class="fs-14 fw-700 fc-000000 opa-07 mt-5 ml-12">
                    {{ dynamicValidateForm.showResultsInDaily ? 'Submit Responses to Managers' : 'Private Feedback Mode' }}
                  </div>
                </div>
                <div class="mb-16" style="padding: 12px; background: rgba(0, 0, 0, 0.05); margin-left: -24px; margin-top: -16px; border-radius: 8px;" v-if="!dynamicValidateForm.showResultsInDaily">
                    Responses are hidden from managers and can only be viewed as anonymous feedback
                </div>

                <!-- Report Card Analytics Section (only show header if there are multiple sections) -->
                <div v-if="dynamicValidateForm.type === 'Multiple Choice' || dynamicValidateForm.type === 'Multiple Choice(other)' || !disabledRowHeader" class="fs-13 fw-700 fc-000000 opa-05 mb-16 mt-32" style="margin-left: -24px; letter-spacing: 0.5px; text-transform: uppercase;">Report Card Analytics</div>

                <div class="flex mb-16" style="margin-left: -24px" v-if="!disabledRowHeader">
                  <div
                    class="relative switch-contrainer"
                  >
                    <input
                      type="checkbox"
                      id="report_card"
                      class="input-checkbox"
                      v-model="dynamicValidateForm.report_card"
                      @change="generateRowHeader(dynamicValidateForm)"
                      :disabled="disabledRowHeader"
                    />
                    <label for="report_card" class="lable-checkbox">{{
                      dynamicValidateForm.report_card
                    }}</label>
                  </div>
                  <div class="fs-14 fw-700 fc-000000 opa-07 mt-5 ml-12">
                    Include in Insights → Report Card
                  </div>
                </div>
                
                <div style="margin-left: -130px" class="mb-16" v-if="!disabledRowHeader && dynamicValidateForm.report_card">
                  <el-form-item
                    :label="$t('questions.Row_Header')"
                    class="title-input-form"
                    :label-width="formLabelWidthF"
                    style="margin-bottom: 12px"
                  >
                    <div class="" v-if="loadingRowHeader">
                      <loading-even></loading-even>
                    </div>
                    <el-input
                      v-else
                      auto-complete="off"
                      :placeholder="$t('questions.Row_Header_Placeholder')"
                      v-model="row_header"
                    ></el-input>

                  </el-form-item>
                </div>

                <div class="flex mb-16" style="margin-left: -24px" v-if="dynamicValidateForm.type === 'Multiple Choice' || dynamicValidateForm.type === 'Multiple Choice(other)' || dynamicValidateForm.type === 'Scale'">
                  <div
                    class="relative switch-contrainer"
                  >
                    <input
                      type="checkbox"
                      id="culture_index"
                      class="input-checkbox"
                      v-model="dynamicValidateForm.culture_index"
                    />
                    <label for="culture_index" class="lable-checkbox">{{
                      dynamicValidateForm.culture_index
                    }}</label>
                  </div>
                  <div class="fs-14 fw-700 fc-000000 opa-07 mt-5 ml-12" style="position: relative">
                    Include in Culture Index
                    <el-tooltip class="header-table-tooltip" placement="top">
                      <div slot="content" class="p-5">
                        <div style="max-width: 250px">
                          Include this question in the Culture Index calculation shown in Insights Dashboard
                        </div>
                      </div>
                      <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer" style="position: absolute; top: 1px;"
                alt="icons_ic_help_outline-16px" />
                    </el-tooltip>
                  </div>
                </div>



                </div>

              </el-form>
              <span
                slot="footer"
                class="dialog-footer"
                style="margin-right: 32px; margin-left: 150px"
              >
                <el-button
                  class="btn-add bigger"
                  type="primary"
                  @click="saveQuestion"
                  :disabled="loadingRowHeader"
                  >{{ $t("global.ADD") }}</el-button
                >
                <el-button class="btn-cancel bigger" @click="cancelDialog">{{
                  $t("global.CANCEL")
                }}</el-button>
              </span>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>

      <div id="calendarModal">
        <el-dialog
          class="txtHeaderModal"
          :title="$t('questions.CALENDAR_VIEW')"
          width="960px"
          :visible.sync="calendarModal"
          top="5vh"
        >
          <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingCalendar">
            <loading-even></loading-even>
          </div>
          <div v-else>
            <div class="body mt-26 fs-18 fw-700 fc-000000">
              <div class="flex">
                <div style="min-width: 120px">
                  <span class="mr-12"
                    >{{ calendarShowing.monthLabel }}
                    {{ calendarShowing.year }}</span
                  >
                </div>
                <img
                  @click="anotherMonthData(-1)"
                  src="../assets/images/questions/chevron_left@2x.png"
                  class="cursor-pointer mr-6"
                  style="height: 24px; width: 24px"
                />
                <img
                  @click="anotherMonthData(1)"
                  src="../assets/images/questions/chevron_right@2x.png"
                  class="cursor-pointer"
                  style="height: 24px; width: 24px"
                />
                <div
                  @click="refreshCalendar()"
                  :class="['ml-12', 'refresh-calendar-btn', { 'refreshing': isRefreshingCalendar, 'cursor-pointer': !isRefreshingCalendar }]"
                  style="height: 24px; width: 24px"
                  :title="isRefreshingCalendar ? 'Refreshing...' : 'Refresh calendar and select today'"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"/>
                  </svg>
                </div>
                <div class="legend-container">
                  <div class="legend-item more-than-five">
                    <div class="legend-box"></div>
                    <div class="legend-item-label">Heavy load (>5 questions)</div>
                  </div>
                  <div class="legend-item less-than-four">
                    <div class="legend-box"></div>
                    <div class="legend-item-label">Light load (<4 questions)</div>
                  </div>
                  <div class="legend-item open-ended-count">
                    <div class="legend-count-badge">
                      <img src="../assets/images/questions/ic_gray_openended@2x.png" class="legend-badge-icon" alt="" />
                      <span class="legend-badge-count">1</span>
                    </div>
                    <div class="legend-item-label">Open-ended questions</div>
                  </div>
                </div>
              </div>
              <div class="calendar-container">
                <div class="day-of-week-title">
                  {{ $t("category.day_of_week_m.mon") }}
                </div>
                <div class="day-of-week-title">
                  {{ $t("category.day_of_week_m.tue") }}
                </div>
                <div class="day-of-week-title">
                  {{ $t("category.day_of_week_m.wed") }}
                </div>
                <div class="day-of-week-title">
                  {{ $t("category.day_of_week_m.thu") }}
                </div>
                <div class="day-of-week-title">
                  {{ $t("category.day_of_week_m.fri") }}
                </div>
                <div class="day-of-week-title">
                  {{ $t("category.day_of_week_m.sat") }}
                </div>
                <div class="day-of-week-title">
                  {{ $t("category.day_of_week_m.sun") }}
                </div>
                <div
                  v-for="(data, index) in calendarData"
                  :key="`${data.dayOfMonth}${index}_card`"
                  class="day-card"
                >
                  <input
                    type="radio"
                    :id="`${data.dayOfMonth}_${data.id}`"
                    :value="`${data.dayOfMonth}_${data.id}`"
                    v-model="selectedDay"
                  />
                  <label :for="`${data.dayOfMonth}_${data.id}`">
                    <div class="day-box" :class="{ 'more-than-five': data.questionsShowing && data.questionsShowing.length > 5, 'less-than-four': data.questionsShowing && data.questionsShowing.length < 4 }">
                      <div v-if="data.openEndedCount > 0" class="open-ended-count-badge" :class="{ 'count-warning': data.openEndedCount > 1 }">
                        <img
                          v-if="selectedDay == `${data.dayOfMonth}_${data.id}`"
                          src="../assets/images/questions/ic_white_openended@2x.png"
                          class="badge-icon"
                          alt=""
                        />
                        <img
                          v-else
                          src="../assets/images/questions/ic_gray_openended@2x.png"
                          class="badge-icon"
                          alt=""
                        />
                        <span class="badge-count">{{ data.openEndedCount }}</span>
                      </div>
                      <div class="title mb-4">{{ data.dayOfMonth }}</div>
                      <div
                        v-for="(question, index) in data.questionsShowing"
                        :key="question.id"
                      >
                        <div v-if="index < 3">
                          <div
                            v-if="
                              selectedDay == `${data.dayOfMonth}_${data.id}`
                            "
                            class="questions-card ellipsis flex-center"
                          >
                            <img
                              v-if="question.questionsType == 'Scale'"
                              src="../assets/images/questions/ic_white_scale@2x.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <img
                              v-else-if="question.questionsType == 'Yes/No'"
                              src="../assets/images/questions/ic_white_yesno@2x.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <img
                              v-else-if="question.questionsType == 'Open-ended'"
                              src="../assets/images/questions/ic_white_openended@2x.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <img
                              v-else
                              src="../assets/images/questions/ic_white_multichoice@2x.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <span class="opa-06 ellipsis">
                              {{ question.category }} {{ question.powerskill }}
                            </span>
                          </div>
                          <div
                            v-else
                            class="questions-card ellipsis flex-center"
                          >
                            <img
                              v-if="question.questionsType == 'Scale'"
                              src="../assets/images/questions/ic_gray_scale@2x.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <img
                              v-else-if="
                                question.questionsType == 'Yes/No'
                              "
                              src="../assets/images/questions/ic_gray_yesno@2x.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <img
                              v-else-if="
                                question.questionsType == 'Open-ended'
                              "
                              src="../assets/images/questions/ic_gray_openended@2x.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <img
                              v-else
                              src="../assets/images/questions/ic_gray_multichoice@2x.png"
                              style="width: 10px; height: 10px"
                              alt=""
                            />
                            <span class="opa-06 ellipsis">
                              {{ question.category }} {{ question.powerskill }}
                            </span>
                          </div>
                        </div>
                        <div
                          v-else-if="index == 3"
                          class="questions-card ellipsis"
                        >
                          <span class="opa-06">
                            + {{ data.questionsShowing.length - 3 }}
                            {{ $t("questions.more") }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
              <div class="line-shadow"></div>
              <div class="fc-000000 fs-18 fw-700 mt-24 mb-6">
                {{ questionPreviewText }}
              </div>
              <div>
                <div class="flex-row" style="margin-top: 25px;margin-bottom: 10px;">
                  <div  style="width: 30px"></div>
                  <div class="flex-column fw-700 fs-14 fc-4A4A4A" style="width: 70px">Status</div>
                  <div class="flex-column fw-700 fs-14 fc-4A4A4A" style="width: 440px">Question</div>
                  <div class="flex-column fw-700 fs-14 fc-4A4A4A" style="width: 140px">Dimension</div>
                  <div class="flex-column fw-700 fs-14 fc-4A4A4A" style="width: 140px">Delivery</div>
                  <div class="flex-column fw-700 fs-14 fc-4A4A4A" style="width: 100px">Action</div>
                </div>
                <draggable v-model="tableSelectedDay" group="people" @start="drag=true" @end="drag=false" class="list-group" @update="updateCradList">
                    <div class="list-group-item" style="width: 100%"
                      v-for="(item, index) in tableSelectedDay"
                      :key="item.id">
                        <div class='flex-row' style="min-height:50px;padding-top:15px;">
                          <div class="opa-08 pt-2 mr-8" style="cursor: grab; cursor: move;">
                              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M9 19.23q-.508 0-.87-.36T7.77 18t.36-.87t.87-.36t.87.36t.36.87t-.36.87t-.87.36m6 0q-.508 0-.87-.36t-.36-.87t.36-.87t.87-.36t.87.36t.36.87t-.36.87t-.87.36m-6-6q-.508 0-.87-.36T7.77 12t.36-.87t.87-.36t.87.36t.36.87t-.36.87t-.87.36m6 0q-.508 0-.87-.36t-.36-.87t.36-.87t.87-.36t.87.36t.36.87t-.36.87t-.87.36m-6-6q-.508 0-.87-.36T7.77 6t.36-.87t.87-.36t.87.36t.36.87t-.36.87t-.87.36m6 0q-.508 0-.87-.36T13.77 6t.36-.87t.87-.36t.87.36t.36.87t-.36.87t-.87.36"/></svg>
                            </div>
                            <div style="width: 70px; padding-top: 4px;">
                                <el-tooltip
                                  :content="item.notblock ? 'This is an essential question for our analytics and reports. It can be disabled in the Question List view but will require a confirmation.' : 'Toggle off to remove this question from the daily question set (will affect recurring)'"
                                  placement="top"
                                >
                                  <el-switch
                                    v-model="item.status"
                                    active-color="#13ce66"
                                    inactive-color="#ff4949"
                                    :disabled="item.notblock"
                                    @change="handleBlock(item)"
                                  ></el-switch>
                                </el-tooltip>
                            </div>
                            <div class="fs-14 flex-column fw-700 fc-000000" style="width: 440px;">
                              <span style="padding-right:16px; word-break: keep-all; margin-bottom: 6px; display: block;">{{ item.question_en }}
                                <el-tooltip v-if="hasFollowUpQuestions(item)" effect="dark" placement="top">
                                  <div slot="content">
                                    <div v-for="(followUp, index) in getFollowUpQuestionsText(item)" :key="index" style="margin-bottom: 8px;">
                                      <strong>{{ followUp.options.join(', ') }}:</strong><br>
                                      {{ followUp.text }}
                                    </div>
                                  </div>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="9" viewBox="0 0 21.5 9.121" style="display: inline-block; vertical-align: middle; margin-left: 8px;">
                                    <g transform="translate(-1.25 -7.439)">
                                      <circle cx="3" cy="3" r="3" transform="translate(2 9)" fill="none" stroke="#6C30CC" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                      <path d="M22,12H12m10,0c0,.562-.438.99-1.314,1.844L19.029,15.5M22,12c0-.562-.438-.99-1.314-1.844L19.03,8.5" fill="none" stroke="#6C30CC" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                                    </g>
                                  </svg>
                                </el-tooltip>
                              </span>
                              <div class="question-meta-badges">
                                <span class="question-type-badge" :class="getQuestionTypeBadgeClass(item.type)">
                                  {{ item.questionsType }}
                                </span>
                                <span v-if="item.power_skill" class="power-skill-badge">
                                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: middle; margin-right: 2px;">
                                    <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" fill="currentColor"/>
                                  </svg>
                                  {{ item.power_skill }}
                                </span>
                              </div>
                            </div>
                            <div style="width: 140px; line-height: 16px;">
                              <div class="fs-14 fw-600" style="color: #000000; margin-bottom: 6px;">{{ item.category }} </div>
                              <span v-if="item.repeats && !item.repeats.toLowerCase().includes('follow')" 
                                    class="frequency-tag" 
                                    :class="getFrequencyTagClass(item.repeats)">
                                {{ item.repeats =='Weekly'&&(item.repeat_every?Number(item.repeat_every) >1:false) ? 'Bi-weekly' : item.repeats }}
                              </span>
                            </div>
                            
                            <div style="width: 140px; line-height: 16px;">
                              <el-tooltip v-if="( !blurMode )"
                              :content="item.delivery" placement="top">
                                <div class="fs-14 fw-600 ellipsis" style="color: #4A4A4A; margin-bottom: 6px;">{{ item.delivery }} </div>
                              </el-tooltip>
                              <span class="frequency-tag tag-default">{{ item.audience }}</span>
                            </div>

                            <div>
                              <el-button
                                v-if="
                                  (item.type == 'Multiple Choice' &&
                                    item.m_choice !== undefined &&
                                    item.m_choice.en.length === 2) ||
                                  item.type == 'Text Area Field' ||
                                  item.type == 'Multiple Choice(other)' ||
                                  item.custom_type == 'multiple_choice' ||
                                  item.type == 'Scale'
                                "
                                class="btnActionView fs-15 btn-gray-outline"
                                @click="openModal(item)"
                                >{{ $t("questions.View") }}</el-button
                                >
                              <el-button v-else disabled style="background: #f4f4f5">{{
                                $t("questions.View")
                              }}</el-button>


                            </div>

                            
                        </div>

                    </div>
                    <!-- <div v-for="element in tableSelectedDay" :key="element.id">{{element.question_en}}</div> -->
                </draggable>



                <!-- <el-table
                  :data="tableSelectedDay"
                  :cell-style="{ padding: '6px 0' }"
                  fixed
                  empty-text=" "
                  style="width: 100%"
                >
                  <el-table-column
                    class="headerCenter"
                    :label="$t('questions.Status')"
                    prop="block"
                    width="100"
                    min-width="50"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-switch
                        @change="handleBlock(scope.row)"
                        v-model="scope.row.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :disabled="scope.row.notblock"
                      ></el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('questions.Question')"
                    prop="question_en"
                  >
                    <template slot-scope="scope">
                      <div class="flex-column">
                        <span
                          class="fw-700 fs-14 fc-4A4A4A"
                          style="word-break: normal"
                          >{{ scope.row.question_en }}</span
                        >
                        <span class="fw-400 fs-14 fc-9D9D9D">{{
                          scope.row.questionsType
                        }} {{ scope.row.power_skill }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('questions.Category')"
                    prop="category"
                    width="130"
                  >
                    <template slot-scope="scope">
                      <div class="fw-700 fs-14 fc-4A4A4A">
                        {{ scope.row.category }} 
                      </div>
                      <div class="fw-400 fs-14 fc-9D9D9D">
                        {{ scope.row.repeats }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('questions.Audience')"
                    prop="audience"
                    width="130"
                  >
                    <template slot-scope="scope">
                      <div class="fw-700 fs-14 fc-4A4A4A">All</div>
                      <div class="fw-400 fs-14 fc-9D9D9D">
                        {{ scope.row.audience }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('questions.Action')"
                    prop="action"
                    header-align="center"
                    width="130"
                    min-width="65"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-button
                        v-if="
                          (scope.row.type == 'Multiple Choice' &&
                            scope.row.m_choice !== undefined &&
                            scope.row.m_choice.th.length === 2) ||
                          scope.row.type == 'Text Area Field' ||
                          scope.row.type == 'Multiple Choice(other)' ||
                          scope.row.custom_type == 'multiple_choice' ||
                          scope.row.type == 'Scale'
                        "
                        class="btnActionView fs-15 btn-gray-outline"
                        @click="openModal(scope.row)"
                        >{{ $t("questions.View") }}</el-button
                      >
                      <el-button v-else disabled style="background: #f4f4f5">{{
                        $t("questions.View")
                      }}</el-button>
                    </template>
                  </el-table-column>
                </el-table> -->
              </div>
            </div>
          </div>
        </el-dialog>
      </div>

      <div class="remove-padding-modal">
        <el-dialog :visible.sync="recipientsModal" top="12vh" width="360px">
          <div class="RecipientsModalStyle px-40">
            <div>
              <span class="fs-20 fw-700 fc-000000">{{
                "Question Recipients"
              }}</span>
            </div>
            <div class="mt-24">
              <span class="fs-18 fw-700 fc-000000"
                >{{
                  $utils(
                    "addCommasInNumber",
                    dynamicValidateForm.recipients
                      ? dynamicValidateForm.recipients.length
                      : allUsers.length
                  )
                }}
                {{ $t("powerUp.recipients") }}</span
              >
            </div>
            <div class="mt-4 pb-16">
              <span class="fc-6C30CC fs-14">{{
                $t("powerUp.based_on_your_selection")
              }}</span>
            </div>
          </div>
          <div class="divMembersRecipients thin-scrollbar px-40">
            <div
              v-for="item in dynamicValidateForm.recipients"
              :key="item.key"
              class="rowDataStyle"
            >
              <div>
                <div class="divProfile">
                  <div v-if="item.profilepic">
                    <img
                      v-lazy="item.profilepic"
                      :key="item.profilepic"
                      class="imgProfile flex-mid"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    />
                  </div>
                  <div v-else class="imgProfile"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div
                      class="flex-mid text-in-image"
                      style="width: 42px"
                      :class="[
                        `${
                          item === 0 ? 'text-in-image-44' : 'text-in-image-32'
                        }`,
                      ]"
                    >
                      {{
                        $utils("acronymName", {
                          firstName: item.firstname,
                          lastName: item.lastname,
                        })
                      }}
                    </div>
                  </div>

                  <div class="flex-column pl-16">
                    <span class="text-name"
                    :class="[ blurMode ?  'blurelement': '' ]"
                      >{{ item.firstname }} {{ item.lastname }}</span
                    >
                    <span class="text-email"
                    :class="[ blurMode ?  'blurelement': '' ]">{{ item.email }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <el-dialog
      class="txtHeaderModal"
      width="960px"
      :visible.sync="dialogOpenEnded"
      top="7vh"
    >
      <div class="flex">
        <div>
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
            }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break">{{
              quest_name
            }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{
              $t("questions.open_ended")
            }}</span>
          </div>
        </div>
        <div class="ml-auto flex-center" style="padding-top: 35px; gap: 12px;">
          <!-- Team Filter Dropdown -->
          <div class="flex-center drop-down-container" :class="`${selectedTeamFilter !== 'all' ? 'active' : ''}`">
            <el-dropdown trigger="click" @command="handleTeamFilterChange">
              <div class="text-drop-down flex-mid">
                <span v-if="selectedTeamFilter !== 'all'">
                  {{ (selectedTeamInfo && selectedTeamInfo.label) || 'Team' }}
                  <svg v-if="selectedTeamInfo && selectedTeamInfo.hasChildren" class="aggregation-indicator" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                    <title>Includes responses from child teams</title>
                    <path d="M8 2L2 8l6 6V10h6V6h-6V2z"/>
                  </svg>
                </span>
                <span v-else>All Teams</span>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="team-dropdown-header">
                  <span class="dropdown-header-title">Filter by Team</span>
                </div>
                <div class="team-search-container">
                  <el-input
                    v-model="teamSearchQuery"
                    placeholder="Search teams..."
                    prefix-icon="el-icon-search"
                    size="mini"
                    clearable
                  ></el-input>
                </div>
                <div class="team-dropdown-content">
                  <el-dropdown-item 
                    v-for="option in availableTeamOptions" 
                    :key="option.value"
                    :command="option.value"
                    :class="{ 'selected-team': selectedTeamFilter === option.value }"
                  >
                    <div class="team-option-content">
                      <div class="team-option-main">
                        <span class="team-name">{{ option.label }}</span>
                        <span class="team-response-count">({{ option.responseCount }})</span>
                      </div>
                    </div>
                  </el-dropdown-item>
                  <div v-if="availableTeamOptions.length === 1" class="no-teams-found">
                    <span>No teams found</span>
                  </div>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          
          <el-button type="text" @click="downloadExcel_Open_ended()" :disabled="loading">
            <div class="flex-mid">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-export">
                <path fill="currentColor"
                  d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
              </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />

      <div style="margin-top: 12px">
        <!-- Aggregation Info Message -->
        <div v-if="selectedTeamFilter !== 'all' && selectedTeamInfo && selectedTeamInfo.hasChildren" 
             class="aggregation-info-banner">
          <i class="el-icon-info"></i>
          <span>Showing combined responses from {{ selectedTeamInfo.label }} and its sub-teams</span>
        </div>

        <el-table
          id="openEndedTable"
          v-loading="loading"
          :data="filteredDataOpenEnd"
          :cell-style="{ padding: '6px 0px' }"
          :empty-text="loading ? ' ' : (selectedTeamFilter !== 'all' ? 'No responses available for selected team' : 'No responses available')"
          height="520"
        >
          <el-table-column :render-header="renderHeaderOpenEnded">
            <template slot-scope="scope">
              <!-- <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingFeedbackAI">
                <loading-even></loading-even>
              </div> -->
              <div
                v-if="scope.row.Summary"
                class="summaryLayout"
              >
                <div class="pt-16">
                  <span
                    class="txtHeaderSummary"
                    >Summary
                  </span>
                </div>
                <div class="divAllSummary pb-12">
                  <span
                    class="txtAllSummary"
                    :style="$utils('fontStyle', scope.row.Summary)"
                    >{{ scope.row.Summary }}
                  </span>
                </div>
                <div style="margin-bottom: 8px; max-height: 164px; flex-wrap: wrap" class="flex divAllSummary">
                  <div class="talkingPointsBox" v-for="(item,index) in scope.row.response_talking_points_show.slice(0, 20)" :key="index">
                    <el-tooltip effect="light" placement="top" class="custom-tooltip">
                      <div class="tooltipStyleTalkingPoints" slot="content">
                        <span class="fs-13 fw-700">{{ item.point.title }}</span>
                        <div v-if="item.point && item.point.specific_examples">
                          <div class="tooltip-items" v-for="(item_specific,index_specific) in item.point.specific_examples" :key="index+'_'+index_specific">
                            <div class="tooltip-item">
                              <div class="oi-circle">
                                <span class="fs-11">{{ index_specific+1 }}</span>
                              </div>
                              <p>
                                {{ item_specific }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-tag :class="`talking-points ${item.sentiment == 'positive'
                        ? 'GreenBoxStyle'
                        : item.sentiment == 'negative'
                          ? 'RedBoxStyle'
                          : 'GreyBoxStyle'
                        }`" v-bind:style="'margin-bottom: 8px;' +
                          $utils('fontStyle', item.point.title)
                          ">{{ truncateText(item.point.title) }}</el-tag>
                    </el-tooltip>
                  </div>
                </div>
                <div class="divAllSummary pb-16">
                  <span
                    class="txtRepeats"
                    >AI-generated from feedback shared within 3 months of the selected date
                  </span>
                </div>
              </div>
              <div v-else style="
                  padding: 24px 0;
                  background: rgba(0, 0, 0, 0.03);
                  align-items: flex-start;
                  display: flex;
                  flex-direction: column;
                ">
                <div class="feedback-team-label" v-if="scope.row.team" :class="getTeamColorClass(getTeamNameInfo(scope.row.team).teamId || scope.row.team)">
                  <span :class="[ blurMode ?  'blurelement': '' ]">
                    {{ getTeamNameInfo(scope.row.team).name }}
                  </span>
                </div>
                <span class="txtResponse" :style="$utils('fontStyle', scope.row.answer || scope.row)">{{ scope.row.answer || scope.row }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="txtHeaderModal"
      width="960px"
      :visible.sync="dialogYesNo"
      top="7vh"
    >
      <div class="flex">
        <div>
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
            }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break">{{
              quest_name
            }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{ $t("questions.Yes_or_No") }}</span>
          </div>
        </div>
        <div class="ml-auto" style="padding-top: 35px">
          <el-button
            type="text"
            @click="downloadExcel_YesorNO()"
            :disabled="loading"
          >
            <div class="flex-mid">
              <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />

      <div class="mt-12">
        <el-table
          id="yesNoTable"
          v-loading="loading"
          :data="datalist"
          :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'"
          ref="yesNoTable"
          style="width: 100%"
          height="520"
        >
          <el-table-tree-column
            file-icon="icon icon-folder"
            folder-icon="icon icon-folder"
            :allRemote="true"
            expandKey="extended"
            child-key="children"
            width="52"
            height="50"
          ></el-table-tree-column>

          <el-table-column :render-header="renderHeaderYesNo">
            <template slot-scope="scope">
              <div
                style="flex-direction: row; display: flex; margin: 5px 0;"
              >
                <div class="rowItem flex-center">
                  <div class="flex-column">
                  <span class="txtTeam"
                  :class="[ blurMode ?  'blurelement': '' ]"
                   :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                    {{ scope.row.team }}
                  </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]"
                      class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                      :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>
                <div v-if="scope.row.id" style="margin-left: 20px">
                  <div
                    class="flex"
                    style="width: 577px; border-radius: 4px; overflow: hidden"
                  >
                    <div
                      :class="
                        !yes ? 'bar-results color-4' : 'bar-results color-2'
                      "
                      v-if="scope.row.id"
                      :style="`${getColorPercent(getNoPercent(scope.row.id))}`"
                    >
                      <span v-if="getNoPercent(scope.row.id) > 5"
                        >{{ getNoPercent(scope.row.id) }}%</span
                      >
                    </div>
                    <div
                      v-if="scope.row.id"
                      :class="
                        yes ? 'bar-results color-4' : 'bar-results color-2'
                      "
                      :style="`${getColorPercent(getYesPercent(scope.row.id))}`"
                    >
                      <span v-if="getYesPercent(scope.row.id) > 5"
                        >{{ getYesPercent(scope.row.id) }}%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="txtHeaderModal"
      width="960px"
      :visible.sync="dialogScale"
      top="7vh"
    >
      <div class="flex">
        <div>
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
            }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break">{{
              quest_name
            }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{ $t("questions.Scale") }}</span>
          </div>
        </div>
        <div class="ml-auto" style="padding-top: 35px">
          <el-button
            type="text"
            @click="downloadExcel_Scale()"
            :disabled="loading"
          >
            <div class="flex-mid">
              <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />

      <div class="mt-12">
        <el-table
          id="scaleTable"
          v-loading="loading"
          :data="datalist"
          :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'"
          ref="scaleTable"
          style="width: 100%"
          height="520"
        >
          <el-table-tree-column
            file-icon="icon icon-folder"
            folder-icon="icon icon-folder"
            :allRemote="true"
            expandKey="extended"
            child-key="children"
            width="52"
            height="50"
          ></el-table-tree-column>

          <el-table-column :render-header="renderHeaderScale">
            <template slot-scope="scope">
              <div
                style="flex-direction: row; display: flex; margin: 5px 0;"
              >
                <div class="rowItem flex-center">
                  <div class="flex-column">
                  <span class="txtTeam"
                  :class="[ blurMode ?  'blurelement': '' ]"
                   :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                    {{ scope.row.team }}
                  </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]"
                      class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                      :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>
                <div
                  style="width: 40px"
                  class="ml-16 fs-17 fw-700 fc-000000 opa-07 flex-mid"
                >
                  <div
                    v-if="scope.row.id && datamultichoices[scope.row.id]"
                    class="ml-auto"
                  >
                    {{ datamultichoices[scope.row.id].avg }}
                  </div>
                </div>
                <div
                  v-if="scope.row.id && datamultichoices[scope.row.id]"
                  style="margin-left: 12px"
                >
                  <div class="flex" :style="`width: 537px; border-radius: 4px; overflow: hidden`">
                    <div
                      v-for="(item, index) in datamultichoices[scope.row.id]
                        .range"
                      :key="index"
                      :class="`bar-results color-` + getScaleColor(index)"
                      :style="`${getColorPercentForScale(
                        getScalePercent(scope.row.id, index)
                      )}`"
                    >
                      <span v-if="getScalePercent(scope.row.id, index) > 5"
                        >{{ getScalePercent(scope.row.id, index) }}%</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      class="txtHeaderModal"
      width="960px"
      :visible.sync="dialogMultipleOther"
      top="7vh"
    >
      <div class="flex">
        <div>
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
            }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break">{{
              quest_name
            }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{
              $t("questions.Multiple_Choice")
            }}</span>
          </div>
        </div>
        <div class="ml-auto" style="padding-top: 35px">
          <el-button
            type="text"
            @click="downloadExcel_MultipleChoice()"
            :disabled="loading"
          >
            <div class="flex-mid">
              <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />

      <div class="mt-12">
        <el-table
          id="otherTable"
          v-loading="loading"
          :data="datalist"
          :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'"
          ref="otherTable"
          style="width: 100%"
          height="520"
        >
          <el-table-tree-column
            file-icon="icon icon-folder"
            folder-icon="icon icon-folder"
            :allRemote="true"
            expandKey="extended"
            child-key="children"
            width="52"
            height="50"
          ></el-table-tree-column>

          <el-table-column :render-header="renderHeaderMultipleOther">
            <template slot-scope="scope">
              <div
                style="flex-direction: row; display: flex; margin: 5px 0;"
              >
                <div class="rowItem flex-center">
                  <div class="flex-column">
                  <span class="txtTeam"
                  :class="[ blurMode ?  'blurelement': '' ]"
                   :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                    {{ scope.row.team }}
                  </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]"
                      class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                      :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>
                <div v-if="scope.row.id" class="ml-20">
                  <div
                    class="flex"
                    style="width: 577px; border-radius: 4px; overflow: hidden;"
                  >
                    <div
                      v-for="(item, index) in datamultichoices[scope.row.id]"
                      :key="index"
                      :style="`width: ${getMultipleChoicePercent(scope.row.id, index)}%`"
                    >
                      <div
                        v-if="getMultipleChoicePercent(scope.row.id, index) > 6"
                        :class="
                          `bar-results color-` + getMultipleChoiceColor(index)
                        "
                        :style="`width: 100%;`"
                      >
                        <span
                          >{{
                            getMultipleChoicePercent(scope.row.id, index)
                          }}%</span
                        >
                      </div>
                      <el-tooltip
                        v-else-if="
                          getMultipleChoicePercent(scope.row.id, index)
                        "
                        :content="`${getMultipleChoicePercent(
                          scope.row.id,
                          index
                        )}%`"
                        placement="top"
                      >
                        <div
                          :class="
                            `bar-results color-` + getMultipleChoiceColor(index)
                          "
                          :style="`width: 100%;`"
                        >
                          &nbsp;
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- follow up question -->
    <el-dialog
    class="txtHeaderModal"
      width="720px"
      :visible.sync="follow_up_question"
      
    >
    <div class="flex-column">
      <div class="fs-20 fw-900">Add Follow-up Question</div>
      <div class="fs-18 fw-900 mt-24 mb-29" style="margin-bottom:29px">{{titleName}}</div>
      <div>

        <el-select
          v-model="selectquestionFollewUp"
          filterable
          placeholder="Select"
          class="input-style"
          style="width:500px;"
        >
          <el-option
            class="text-dropdown"
            v-for="item in questionFollewUp"
            :key="item.key"
            :label="item.question_en"
            :value="item.key"
          ></el-option>
        </el-select>
       
      </div>
      <div class="mt-32" style="margin-bottom:40px">
        <el-button
          type="primary"
          @click="addFollowUpQuestion"
          class="btn-add bigger">
          SUBMIT</el-button>
        <el-button
          @click="addFollowUpQuestion"
          class="btn-cancel bigger">
          CANCEL</el-button>
      </div>
    </div>
    </el-dialog>

  </div>
</template>

<script>
import format from "date-fns/format";
import endOfMonth from "date-fns/end_of_month";
import later from "later";
import Dateformat from "date-fns";
import draggable from "vuedraggable";

export default {
  name: "question",
  created() {
    this.$store.commit("authen/setActiveIndex", "4");
    this.setInitialTabFromRoute();
    this.initializeQuestionsView();
  },
  components: {
    draggable: draggable,
    standard: require("./questions/standard").default,
    custom: require("./questions/custom").default,
    loadingEven: require("./even/loading").default,
  },
  computed: {
    engonly() {
      return this.$store.getters["reward/engonly"];
    },
    user() {
      const user = this.$store.getters["authen/user"];
      return user;
    },
    optionsCategory() {
      return this.$store.getters["question/category"];
    },
    optionsScheduleOnetime() {
      return this.$store.getters["question/scheduleonetime"];
    },
    questions() {
      return this.$store.getters["question/questions"];
    },
    questionsAll() {
      return this.$store.getters["question/questionsall"];
    },
    questionsAllCustom() {
      return this.$store.getters["custom/questioncustomAll"];
    },
    loading() {
      return this.$store.getters["question/loading"];
    },
    loadingCalendar() {
      return this.$store.getters["question/loadingCalendar"];
    },
    loadingRowHeader() {
      return this.$store.getters["question/loadingRowHeader"];
    },
    datalist() {
      return this.$store.getters["question/datalist"];
    },
    optionTo() {
      // this.dynamicValidateForm.cascaderTo=this.optionTo.map((row) => [row.value]);
      // this.dynamicValidateForm.oldCascaderTo=this.optionTo.map((row) => [row.value]);
      return this.$store.getters["question/optionTo"];
    },
    allUsers() {
      return this.$store.getters["question/allUsers"];
    },
    cohortsUser() {
      return this.$store.getters["question/cohortsUser"];
    },
    _organization1level() {
      return this.$store.getters["question/organization1level"];
    },
    userTeam() {
      return this.$store.getters["question/userTeam"];
    },
    teamArr() {
      return this.$store.getters["question/teamArr"];
    },
    teamAll() {
      return this.$store.getters["question/teamAll"];
    },
    organizations() {
      return this.$store.getters["question/organizations"];
    },
    answerOpt() {
      return this.$store.getters["question/answerOpt"];
    },
    dateShow() {
      return this.$store.getters["question/dateShow"];
    },
    dateoptions() {
      return this.$store.getters["question/dateoptions"];
    },
    dataopenend() {
      return this.$store.getters["question/dataopenend"];
    },
    datamultichoices() {
      return this.$store.getters["question/datamultichoices"];
    },
    countmultichoices() {
      return this.$store.getters["question/countmultichoices"];
    },
    deletedTeam(){
      return this.$store.getters["question/deletedTeam"];
    },
    teamHeight(){
      return this.$store.getters["question/teamHeight"];
    },
    loadingFeedbackAI() {
      return this.$store.getters["question/loadingFeedbackAI"];
    },
    summaryDetail(){
      return this.$store.getters["question/summaryDetail"];
    },
    dataCompany(){
      return this.$store.getters["question/dataCompany"];
    },
    row_header: {
      get() {
        return this.$store.getters["question/row_header"];
      },
      set(value) {
        this.$store.commit("question/setRowHeader", value);
      },
    },
    questioncustomAll(){
      return this.$store.getters["custom/questioncustomAll"];
    },


    questionOrder: {
      get() {
        return this.$store.getters["question/questionOrder"];
      },
      set(value) {
        this.$store.commit("question/setquestionOrder", value);
      },
    },
    teamleadership(){
      
      return this.$store.getters["question/teamleadership"];
    },
    optionToleadership(){
      return this.$store.getters["question/optionToleadership"];
    },
    language() {
      return this.$store.getters["reward/language"];
    },
    getquestionLoading() {
      return this.$store.getters["custom/getquestionLoading"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    filteredDataOpenEnd() {
      if (this.selectedTeamFilter === 'all') {
        return this.dataopenend;
      }
      
      // Handle special 'organization' filter
      if (this.selectedTeamFilter === 'organization') {
        // Show all responses that don't have viable parent teams
        const teamIds = [...new Set(this.dataopenend
          .filter(item => !item.Summary && item.team)
          .map(item => item.team))];
        
        const organizationTeams = teamIds.filter(teamId => {
          const viableParent = this.findViableParentTeam(teamId);
          return viableParent && viableParent.teamId === 'organization';
        });
        
        return this.dataopenend.filter(item => {
          if (item.Summary) return true; // Always show summary
          return organizationTeams.includes(item.team);
        });
      }
      
      // Get selected team option to find child teams
      const selectedOption = this.availableTeamOptions.find(option => option.value === this.selectedTeamFilter);
      if (!selectedOption) return this.dataopenend;
      
      // Include the selected team and all its child teams (including those that don't meet threshold)
      const includeTeamIds = [this.selectedTeamFilter];
      if (selectedOption.childTeams) {
        includeTeamIds.push(...selectedOption.childTeams);
      }
      // Also include all descendants of the selected team
      includeTeamIds.push(...this.getAllDescendantTeams(this.selectedTeamFilter));
      
      return this.dataopenend.filter(item => {
        if (item.Summary) return true; // Always show summary
        return includeTeamIds.includes(item.team);
      });
    },
    availableTeamOptions() {
      const options = [{ value: 'all', label: 'All Teams', responseCount: this.dataopenend.filter(item => !item.Summary).length }];
      
      // Get unique teams from current dataset
      const teamIds = [...new Set(this.dataopenend
        .filter(item => !item.Summary && item.team)
        .map(item => item.team))];
      
      // Group teams by their viable parent (the closest ancestor that meets threshold)
      const viableTeams = new Map();
      
      teamIds.forEach(teamId => {
        const viableParent = this.findViableParentTeam(teamId);
        if (viableParent) {
          if (!viableTeams.has(viableParent.teamId)) {
            viableTeams.set(viableParent.teamId, {
              ...viableParent,
              childTeams: [],
              aggregatedResponses: 0
            });
          }
          
          const responseCount = this.getTeamResponseCount(teamId);
          viableTeams.get(viableParent.teamId).aggregatedResponses += responseCount;
          
          if (teamId !== viableParent.teamId) {
            viableTeams.get(viableParent.teamId).childTeams.push(teamId);
          }
        }
      });
      
      // Convert to options format
      viableTeams.forEach((teamData, teamId) => {
        // Only add teams that meet the threshold
        if (teamData.aggregatedResponses >= this.MIN_RESPONSES_FOR_TEAM_NAME) {
          options.push({
            value: teamId,
            label: teamData.label,
            responseCount: teamData.aggregatedResponses,
            memberCount: teamData.memberCount,
            meetsThreshold: true, // All teams in this list meet threshold
            hasChildren: teamData.childTeams.length > 0,
            depth: teamData.depth,
            childTeams: teamData.childTeams
          });
        }
      });
      
      // Filter by search query
      const filtered = options.filter(option => {
        if (option.value === 'all') return true;
        return option.label.toLowerCase().includes(this.teamSearchQuery.toLowerCase());
      });
      
      return filtered.sort((a, b) => {
        if (a.value === 'all') return -1;
        if (b.value === 'all') return 1;
        return a.label.localeCompare(b.label);
      });
    },
    selectedTeamInfo() {
      if (this.selectedTeamFilter === 'all') {
        return null;
      }
      return this.availableTeamOptions.find(option => option.value === this.selectedTeamFilter);
    },
    // Multi-language support
    isThaiLanguageSelected() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      return selectedLanguage === 'th';
    },
    
    isMalayLanguageSelected() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      return selectedLanguage === 'ms';
    },
    
    isChineseLanguageSelected() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      return selectedLanguage === 'zh-HK';
    },
    
    // Dynamic font class based on language selection
    questionFontClass() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      if (selectedLanguage === 'th') return 'font-kanit';
      if (selectedLanguage === 'zh-HK') return 'font-chinese';
      return 'font-lato';
    },
    
    localizedAnswerOptions() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      if (!this.currentQuestionData || !this.currentQuestionData.m_choice) {
        return this.answerOpt; // Fallback to store data
      }
      
      // Check for selected language first
      if (this.currentQuestionData.m_choice[selectedLanguage]) {
        // For Yes/No questions, check if we need to reverse the order
        // if (this.currentQuestionData.m_choice.weight && (this.currentQuestionData.m_choice.weight[0] === "0" || this.currentQuestionData.m_choice.weight[0] === 0)) {
        //   return [...this.currentQuestionData.m_choice[selectedLanguage]].reverse();
        // }
        return this.currentQuestionData.m_choice[selectedLanguage];
      }
      
      // Fallback to English
      if (this.currentQuestionData.m_choice.en) {
        // if (this.currentQuestionData.m_choice.weight && (this.currentQuestionData.m_choice.weight[0] === "0" || this.currentQuestionData.m_choice.weight[0] === 0)) {
        //   return [...this.currentQuestionData.m_choice.en].reverse();
        // }
        return this.currentQuestionData.m_choice.en;
      }
      
      return this.answerOpt; // Final fallback
    },
    localizedAnswerOptionsOther() {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      if (!this.currentQuestionData || !this.currentQuestionData.m_choice) {
        return this.answerOpt; // Fallback to store data
      }
      
      // Check for selected language first
      if (this.currentQuestionData.m_choice[selectedLanguage]) {
        // For Yes/No questions, check if we need to reverse the order
        // This must not be a special question. // weihth 0,1,1,0
        if (this.currentQuestionData.key !== '-L1FmpFO-v8IZc_B5EB7' && this.currentQuestionData.m_choice.weight && (this.currentQuestionData.m_choice.weight[0] === "0" || this.currentQuestionData.m_choice.weight[0] === 0)) {
          return [...this.currentQuestionData.m_choice[selectedLanguage]].reverse();
        }
        return this.currentQuestionData.m_choice[selectedLanguage];
      }
      
      // Fallback to English
      if (this.currentQuestionData.m_choice.en) {
        // This must not be a special question. // weihth 0,1,1,0
        if (this.currentQuestionData.key !== '-L1FmpFO-v8IZc_B5EB7' && this.currentQuestionData.m_choice.weight && (this.currentQuestionData.m_choice.weight[0] === "0" || this.currentQuestionData.m_choice.weight[0] === 0)) {
          return [...this.currentQuestionData.m_choice.en].reverse();
        }
        return this.currentQuestionData.m_choice.en;
      }
      
      return this.answerOpt; // Final fallback
    },
  },
  watch: {
    row_header() {
      
      this.dynamicValidateForm.report_card_label = this.row_header
    },
    selectedDay() {
      this.addDataToTableOfModal();
    },
    async activeName() {
      if (this.activeName != "") {
        const tab = this.activeName || "";
        this.renderedTabs[tab] = true;
        await this.initializeTab(tab);
        const paramsTab = this.$router.currentRoute.params.tab;
        if (paramsTab != tab) {
          this.$router.push({ name: "questions", params: { tab } });
        }
      }
    },
    dialogOpenEnded(newVal) {
      if (newVal) {
        // Clear cache when dialog opens
        this._teamNameCache = {};
        // Reset team filter
        this.selectedTeamFilter = 'all';
        // Clear team search
        this.teamSearchQuery = '';
      }
    },
    dataopenend() {
      // Clear cache when data changes
      this._teamNameCache = {};
    },
    async user(newUser) {
      if (newUser && !this.viewReady) {
        await this.initializeQuestionsView();
      }
    },
    language(){
      if(this.language.length>0){

       
        for(const i in this.language){
        // console.log('language',this.language[i].code)
        if(!this.dynamicValidateForm.questions[`${this.language[i].code}`]){
          this.dynamicValidateForm.questions[`${this.language[i].code}`] = ''
        }
        if(this.dynamicValidateForm.less_txts&&!this.dynamicValidateForm.less_txts[`${this.language[i].code}`]){
          this.dynamicValidateForm.less_txts[`${this.language[i].code}`] = ''
        }
        if(this.dynamicValidateForm.max_txt&&!this.dynamicValidateForm.max_txts[`${this.language[i].code}`]){
          this.dynamicValidateForm.max_txts[`${this.language[i].code}`] = ''
        }
        if(this.dynamicValidateForm.options_YN&&!this.dynamicValidateForm.options_YN[`${this.language[i].code}`]&&this.language[i].code!='en'&&this.language[i].code!='th'){
          const arr=[
          {
            key: 1,
            value: "",
            placeholder: "Yes",
            question_id:'',
          },
          {
            key: 2,
            value: "",
            placeholder: "No",
            question_id:'',
          },
        ]
        //this.$set(this.dynamicValidateForm.options_YN, this.language[i].code, JSON.parse(JSON.stringify(arr)));
        //this.dynamicValidateForm.options_YN[`${this.language[i].code}`]=arr;
          this.dynamicValidateForm.options_YN[`${this.language[i].code}`]=JSON.parse(JSON.stringify(arr));
          //this.dynamicValidateForm[`options_${this.language[i].code}`]=JSON.parse(JSON.stringify(arr));
        }
        //console.log("Ya",this.dynamicValidateForm)
        }

      }
      
    },
 
  },
  data() {
    return {
      activeName: "standard",
      anchor: {
        standard: "standard",
        custom: "custom",
      },
      renderComponent: true,
      mode: "",
      dialogFormVisible: false,
      calendarModal: false,
      isRefreshingCalendar: false,
      title_dialog: "",
      activeIndex: "en",
      formLabelWidthF: "105px",
      status: "Y",
      recipientsModal: false,
      dialogOpenEnded: false,
      dialogYesNo: false,
      dialogScale: false,
      dialogMultipleOther: false,
      quest_id: null,
      quest_name: null,
      organization1level: [],
      follow_up_question:false,
      selectquestionFollewUp:'',
      questionFollewUp:[],
      indexOption:0,
      // optionTo: [
      //   {
      //     label: "All teams and cohorts",
      //     value: "asdfqwrqw213",
      //   },
      //   {
      //     label: "Executive Board",
      //     value: "asd2qwr2q1w13",
      //   },
      //   {
      //     label: "Purchasing & Sourcing BU",
      //     value: "as3dfqw2rq3213",
      //   },
      //   {
      //     label: "Bulky Logistics Squad",
      //     value: "sdfqqwrdsqw213",
      //   },
      //   {
      //     label: "Happily Culture Builders",
      //     value: "a1d43q2wr2w213",
      //   },
      //   {
      //     label: "Super Outer",
      //     value: "a1d4fq2wq2w2113",
      //   },
      //   {
      //     label: "Superstar",
      //     value: "as1d3qwrqw113",
      //   },
      //   {
      //     label: "0 to 6mo",
      //     value: "as143q2w113",
      //   },
      //   {
      //     label: "10+ yrs",
      //     value: "as1d43rq2w1133",
      //   },
      //   {
      //     label: "2 to 5yrs",
      //     value: "as1d43rq2w11232",
      //   },
      //   {
      //     label: "5 to 10yrs",
      //     value: "as1d43rq2w11131",
      //   },
      // ],
      //cascaderTo: [["asdfqwrqw213"]], // add to obj : dynamicValidateForm
      //showResultsInDaily: true, // add to obj : dynamicValidateForm
      dynamicValidateForm: {
        cascaderTo: [["all_teams_and_cohorts"]],
        oldCascaderTo: [["all_teams_and_cohorts"]],
        recipients: [],
        showResultsInDaily: true,
        category: "",
        type: "",
        questions: {},
        question_en: "",
        question_th: "",
        coins: "1",
        frequency: "",
        dayofweek: "monday",
        schedule: "",
        feelingY: "Positive",
        feelingN: "Negative",
        powerSkill: null,
        options_YN:{},
        options_en: [
          {
            key: 1,
            value: "Yes",
            weight: "1",
            placeholder: "Yes",
            question_id:'',
          },
          {
            key: 2,
            value: "No",
            weight: "0",
            placeholder: "No",
            question_id:'',
          },
        ],
        options_th: [
          {
            key: 1,
            value: "ใช่",
            placeholder: "Yes",
            question_id:'',
          },
          {
            key: 2,
            value: "ไม่ใช่",
            placeholder: "No",
            question_id:'',
          },
        ],
        options: [
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Positive",
            question_id:'',
          },
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Neutral",
            question_id:'',
          },
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Negative",
            question_id:'',
          },
        ],
        less_txts: {},
        less_txt: "",
        less_txt_en: "",
        max_txts: {},
        max_txt: "",
        max_txt_en: "",
        max: 10,
        min: 0,
        rolling:false,
        report_card: false,
        report_card_label: "",
        culture_index: false,
        status: "Y",
      },
      options_quarterly: [],
      options_biannually: [],
      options_yearly: [],
      calendarShowing: {
        day: 1, // 1-31
        dayLabel: "Mon",
        month: 1, // 1-12
        monthLabel: "January",
        year: "2010",
        firstDayOfWeek: 0, // 1 - 7 (1 = Mon)
        lastDayOfPastMonth: 30,
        lastDayOfMonth: 30,
      },
      tableSelectedDay: [],
      selectedDay: null,
      calendarData: [],
      questionPreviewText: "",
      questionsPerMonth: {},
      dialogQuestionForm: false,
      refreshInput: true,
      propsCofig: { multiple: true },
      firstrun: true,
      disabledRowHeader: true,
      titleName:'',
      option_To:[],
      questions_text:'',
      // Anonymity thresholds - adjust these values as needed
      MIN_RESPONSES_FOR_TEAM_NAME: 5, // Minimum responses required for team visibility
      MIN_MEMBERS_FOR_TEAM_NAME: 5, // Minimum members (when member check is enabled)
      USE_MEMBER_COUNT_CHECK: false, // Set to true when member counts are available
      _teamNameCache: {},
      // Team filtering for modals
      selectedTeamFilter: 'all',
      teamFilterOptions: [],
      teamSearchQuery: '',
      // Store current question data for localization
      currentQuestionData: null,
      renderedTabs: {
        standard: false,
        custom: false,
      },
      tabReady: {
        standard: false,
        custom: false,
      },
      viewReady: false,
      audienceReady: false,
      formReady: false,
      detailReady: false,
      calendarReady: false,
      viewInitPromise: null,
      audiencePromise: null,
      formPromise: null,
      detailPromise: null,
      calendarPromise: null,
    };
  },
  mounted() {
    this.getDateData(new Date());
    const params = this.$router.currentRoute.params.tab;
    if (this.$route.query.welcome == "true") {
      this.$router.push({
        name: "questions",
        params: { tab: "standard" },
        query: { welcome: "false" },
      });
    }
    if (params && this.anchor[params] && !this.$route.query.welcome) {
      this.activeName = params;
    } else if (!this.$route.query.welcome) {
      const tab = this.activeName || "";
      if (params != tab) {
        this.$router.push({ name: "questions", params: { tab: tab } });
      }
    }
    this.$root.$on('changeTab', this.handleTabChange);
    
    // Listen for language changes
    this.$root.$on('languageChanged', this.handleLanguageChange);
  },
  
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('changeTab', this.handleTabChange);
    this.$root.$off('languageChanged', this.handleLanguageChange);
  },

  methods: {
    shouldRenderTab(tab) {
      return !!this.renderedTabs[tab];
    },
    setInitialTabFromRoute() {
      if (this.$route.query.welcome == "true") {
        this.activeName = "standard";
        this.renderedTabs.standard = true;
        return;
      }

      const params = this.$router.currentRoute.params.tab;
      if (params && this.anchor[params]) {
        this.activeName = params;
        this.renderedTabs[params] = true;
        return;
      }

      this.renderedTabs.standard = true;
    },
    async initializeQuestionsView() {
      if (!this.user) {
        return;
      }

      if (this.viewInitPromise) {
        return this.viewInitPromise;
      }

      this.viewInitPromise = (async () => {
        await this.initializeTab(this.activeName || "standard");
        this.viewReady = true;
      })();

      try {
        await this.viewInitPromise;
      } finally {
        this.viewInitPromise = null;
      }
    },
    async initializeTab(tab, { forceRefresh = false } = {}) {
      if (!this.user) {
        return;
      }

      if (this.tabReady[tab] && !forceRefresh) {
        return;
      }

      if (tab === "custom") {
        await Promise.all([
          this.$store.dispatch("question/getCategoryOptions"),
          this.ensureQuestionAudienceReady({ forceRefresh }),
        ]);
        await this.$store.dispatch("custom/getQuestionsCustom", {
          user: this.user,
          forceRefresh,
        });
        this.tabReady.custom = true;
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.ensureQuestionFormReady();
          });
        });
        return;
      }

      await Promise.all([
        this.$store.dispatch("question/getCategoryOptions"),
        this.$store.dispatch("question/getQuestions", {
          user: this.user,
          forceRefresh,
        }),
      ]);
      this.tabReady.standard = true;
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.ensureQuestionDetailReady();
        });
      });
    },
    async ensureQuestionAudienceReady({ forceRefresh = false } = {}) {
      if (this.audienceReady && !forceRefresh) {
        return;
      }

      if (this.audiencePromise && !forceRefresh) {
        return this.audiencePromise;
      }

      this.audiencePromise = (async () => {
        await this.$store.dispatch("question/getChildren", { forceRefresh });
        await this.$store.dispatch("question/getTeamAndCohort", { forceRefresh });
        this.audienceReady = true;
      })();

      try {
        await this.audiencePromise;
      } finally {
        this.audiencePromise = null;
      }
    },
    async ensureQuestionFormReady({ forceRefresh = false } = {}) {
      if (this.formReady && !forceRefresh) {
        return;
      }

      if (this.formPromise && !forceRefresh) {
        return this.formPromise;
      }

      this.formPromise = (async () => {
        await this.ensureQuestionAudienceReady({ forceRefresh });
        await this.$store.dispatch("question/getUser", { forceRefresh });
        await this.$store.dispatch("reward/checkEngOnly");
        await Promise.all([
          this.$store.dispatch("question/getDataCompany", { forceRefresh }),
          this.$store.dispatch("question/getCategoryOptions"),
        ]);
        this.$store.dispatch("question/getScheduleOptions", {
          end_row: "",
        });
        this.formReady = true;
      })();

      try {
        await this.formPromise;
      } finally {
        this.formPromise = null;
      }
    },
    async ensureQuestionDetailReady({ forceRefresh = false } = {}) {
      if (this.detailReady && !forceRefresh) {
        return;
      }

      if (this.detailPromise && !forceRefresh) {
        return this.detailPromise;
      }

      this.detailPromise = (async () => {
        await this.ensureQuestionAudienceReady({ forceRefresh });
        await Promise.all([
          this.$store.dispatch("question/getUser", { forceRefresh }),
          this.$store.dispatch("question/getTeamHeight", this.user),
          this.$store.dispatch("question/getDataOrganize", {
            user: this.user,
            forceRefresh,
          }),
        ]);
        this.detailReady = true;
      })();

      try {
        await this.detailPromise;
      } finally {
        this.detailPromise = null;
      }
    },
    async ensureCalendarReady({ forceRefresh = false, showLoader = true } = {}) {
      if (this.calendarReady && !forceRefresh) {
        return;
      }

      if (this.calendarPromise && !forceRefresh) {
        return this.calendarPromise;
      }

      this.calendarPromise = (async () => {
        if (showLoader) {
          this.$store.commit("question/setLoadingCalendar", true);
        }

        try {
          await this.ensureQuestionAudienceReady({ forceRefresh });
          await Promise.all([
            this.$store.dispatch("question/getQuestions", {
              user: this.user,
              forceRefresh,
            }),
            this.$store.dispatch("custom/getQuestionsCustom", {
              user: this.user,
              forceRefresh,
            }),
            this.$store.dispatch("question/getQuestionsOrder", {
              forceRefresh,
            }),
          ]);
          this.tabReady.standard = true;
          this.tabReady.custom = true;
          this.calendarReady = true;
        } finally {
          if (showLoader) {
            this.$store.commit("question/setLoadingCalendar", false);
          }
        }
      })();

      try {
        await this.calendarPromise;
      } finally {
        this.calendarPromise = null;
      }
    },
    handleTabChange(item) {
      if (item.path == "questions") {
        this.activeName = item.tab;
      }
    },
    getActiveOptions() {
      // console.log('getActiveOptions',this.activeIndex,this.dynamicValidateForm )
      
      //   return this.activeIndex === 'en' || this.activeIndex === 'th'
      // ? this.dynamicValidateForm[`options_${this.activeIndex}`]
      // : this.dynamicValidateForm.options_YN[this.activeIndex] 
      if (this.activeIndex === 'en' || this.activeIndex === 'th') {
      return this.dynamicValidateForm[`options_${this.activeIndex}`] || [];
    }
    if (!this.dynamicValidateForm.options_YN[this.activeIndex]) {
        this.$set(this.dynamicValidateForm.options_YN, this.activeIndex, [
          { key: 1, value: '', placeholder: 'Yes', question_id: '' },
          { key: 2, value: '', placeholder: 'No', question_id: '' },
        ]);
      }
      return this.dynamicValidateForm.options_YN[this.activeIndex];
    },
    
    isReadonly() {
      return this.activeIndex === 'en' || this.activeIndex === 'th';
    },
    updateOptionValue(index, value) {
      // console.log("updateOptionValue",this.dynamicValidateForm.options_YN[this.activeIndex][index].value)
      this.dynamicValidateForm.options_YN[this.activeIndex][index].value=value
      
    },
    truncateText(text) {
      let length = this.maxLength;
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    
    // Badge styling methods
    getQuestionTypeBadgeClass(type) {
      const typeMap = {
        'Multiple Choice': 'badge-multiple-choice',
        'Multiple Choice(other)': 'badge-multiple-choice',
        'Yes/No': 'badge-yes-no',
        'Scale': 'badge-scale',
        'Text Area Field': 'badge-text-area',
        'Follow-up': 'badge-follow-up'
      };
      return typeMap[type] || 'badge-default';
    },
    
    getFrequencyTagClass(frequency) {
      if (!frequency) return '';
      const freq = frequency.toLowerCase();
      if (freq.includes('bi-annual') || freq.includes('bi-weekly')) return 'tag-biannual';
      if (freq.includes('quarterly') || freq === 'quarterly') return 'tag-biannual';
      if (freq.includes('month') || freq === 'monthly') return 'tag-biannual';
      if (freq.includes('year') || freq === 'yearly') return 'tag-yearly';
      if (freq.includes('week') || freq === 'weekly') return 'tag-yearly';
      if (freq.includes('daily')) return 'tag-yearly';
      if (freq.includes('follow')) return 'tag-follow-up';
      if (freq.includes('one-time')) return 'tag-default';
      return 'tag-default';
    },
    
    async openModal(elm) {
      this.quest_id = elm.key;
      this.quest_name = elm.question_en;
      this.currentQuestionData = elm; // Store current question data for localization
      let splitDate = elm.date.split("/");
      let date = splitDate[2]+'-'+splitDate[1]+'-'+splitDate[0];
      await this.ensureQuestionDetailReady();
      this.$store.commit("question/setLoading", true);
      if (elm.type === "Multiple Choice") {
        if (elm.custom_type === "multiple_choice") {
          this.$store.commit("question/setCountMultiChoices", 0);
          this.$store.commit("question/setDataMultiChoices", []);
          this.dialogMultipleOther = true;
          this.$store.dispatch("question/getDateDetail", {
            quest_id: elm.key,
            type: elm.type,
            custom_type: elm.custom_type,
            date: date,
          });
        } else {
          if (elm.m_choice.weight[0] === "0" || elm.m_choice.weight[0] === 0) {
            this.yes = false;
          } else {
            this.yes = true;
          }
          this.$store.commit("question/setDataMultiChoices", []);
          this.$store.commit("question/setCountMultiChoices", 0);
          this.dialogYesNo = true;
          this.$store.dispatch("question/getDateDetail", {
            quest_id: elm.key,
            type: elm.type,
            date: date,
          });
        }
      } else if (elm.type === "Scale") {
        this.$store.commit("question/setCountMultiChoices", 0);
        this.$store.commit("question/setDataMultiChoices", []);
        this.dialogScale = true;
        this.$store.dispatch("question/getDateDetail", {
          quest_id: elm.key,
          type: elm.type,
          date: date,
        });
      } else {
        this.$store.commit("question/setDataOpenEnd", []);
        this.dialogOpenEnded = true;
        this.$store.dispatch("question/getDateDetail", {
          quest_id: elm.key,
          type: elm.type,
          date: date,
        });
      }
    },
    async downloadExcel_Open_ended() {
      var date_data = format(this.dateShow, "YYYYMMDD");
      var question = "";

      this.quest_name
        .trim()
        .split(" ")
        .map((value, i) => {
          if (i < 5) {
            question = question + "_" + value;
          }
        });
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Open-ended";
      ws.getCell("B6").value = this.dateShow;

      // Use filtered data for count
      const dataToExport = this.filteredDataOpenEnd.filter(item => !item.Summary);
      let countMessage = dataToExport.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      
      // Add team filter info if applied
      let filterInfo = countMessage + " " + responses;
      if (this.selectedTeamFilter !== 'all') {
        const teamInfo = this.selectedTeamInfo;
        filterInfo += ` (filtered by: ${teamInfo ? teamInfo.label : 'Unknown Team'})`;
      }
      
      ws.getCell("B7").value = filterInfo;
      ws.getCell("B8").value = "";
      ws.getColumn("A").width = 5;
      ws.getColumn("B").width = 25; // Team name column
      ws.getColumn("C").width = 80; // Response column
      
      // Add headers
      ws.getCell("B9").value = "Team";
      ws.getCell("C9").value = "Response";
      ws.getCell("B9").font = { bold: true };
      ws.getCell("C9").font = { bold: true };
      
      // Add data with team names
      _.forEach(dataToExport, (item, key) => {
        const teamInfo = this.getTeamNameInfo(item.team);
        let _tmp = ["", teamInfo.name, item.answer || item];
        ws.addRow(_tmp);
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = date_data + "_opened-ended" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async downloadExcel_YesorNO() {
     
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
        let total = 0;
        let resY = 0;
        let resN = 0;
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          total =
            this.datamultichoices[value.key][0] +
            this.datamultichoices[value.key][1];
          resY = this.datamultichoices[value.key][0];
          resN = this.datamultichoices[value.key][1];
        }
        team.push({
          ...value,
          parent_name: parent_name,
          percentYes: this.getYesPercent(value.key),
          percentNo: this.getNoPercent(value.key),
          resY: resY,
          resN: resN,
          total_res: total,
        });
      });
      if(Object.keys(this.deletedTeam).length > 0){
        let index = 1;
        for(const keyId in this.deletedTeam){
          let total = 0;
          let resY = 0;
          let resN = 0;
          let parent_name =
            this.teamArr[this.teamHeight] !== undefined
              ? this.teamArr[this.teamHeight].name
              : "noun";
          if (this.datamultichoices[keyId]) {
            total =
              this.datamultichoices[keyId][0] +
              this.datamultichoices[keyId][1];
            resY = this.datamultichoices[keyId][0];
            resN = this.datamultichoices[keyId][1];
          }
          team.push({
            key: keyId,
            name: 'Deleted Team ' + index,
            parent: this.teamHeight,
            parent_name: parent_name,
            percentYes: this.getYesPercent(keyId),
            percentNo: this.getNoPercent(keyId),
            resY: resY,
            resN: resN,
            total_res: total,
          });
          index++
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;
      
      const teams = organizations[level0[0].key];
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
            // dispatch('getTeamOfParent', value.parent)
          }
        });
      } else {
        organization1level[level0[0].key] = true;
      }
      if(Object.keys(this.deletedTeam).length > 0){
        for(const keyId2 in this.deletedTeam){
          organization1level[keyId2] = true;
        }
      }
      _.forEach(organization1level, (value, team_id) => {
        let _temp = _.find(team, ["key", team_id]);
        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYYMMDD");
      var question = "";
      this.quest_name
        .trim()
        .split(" ")
        .map((value, i) => {
          if (i < 5) {
            question = question + "_" + value;
          }
        });
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Yes/No";
      ws.getCell("B6").value = this.dateShow;

      const countMessage = this.dataopenend.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Option",
        "Value",
        "Responses",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        let _tmp = [
          "",
          item.name,
          item.parent_name,
          "Yes",
          item.percentYes,
          item.resY,
          item.total_res,
        ];
        ws.addRow(_tmp);
        let _tmp1 = ["", "", "", "No", item.percentNo, item.resN];
        ws.addRow(_tmp1);
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = date_data + "_Yes-No" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async downloadExcel_Scale() {
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
        let total = 0;
        let avg = {};
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          for (
            var i = 0;
            i < this.datamultichoices[value.key]["range"].length;
            i++
          ) {
            total += this.datamultichoices[value.key]["range"][i];
          }
          avg = this.datamultichoices[value.key].avg;
        }
        team.push({
          ...value,
          parent_name: parent_name,
          total_res: total,
          avg: avg,
          range0to6: this.getScalePercent(value.key, 0),
          range7to8: this.getScalePercent(value.key, 1),
          range9to10: this.getScalePercent(value.key, 2),
        });
      });
      if(Object.keys(this.deletedTeam).length > 0){
        let index = 1
        for(const keyId in this.deletedTeam){
          let total = 0;
          let avg = {};
          let parent_name =
            this.teamArr[this.teamHeight] !== undefined
              ? this.teamArr[this.teamHeight].name
              : "noun";
          if (this.datamultichoices[keyId]) {
            for (
              var i = 0;
              i < this.datamultichoices[keyId]["range"].length;
              i++
            ) {
              total += this.datamultichoices[keyId]["range"][i];
            }
            avg = this.datamultichoices[keyId].avg;
          }
          team.push({
            key: keyId,
            name: 'Deleted Team ' + index,
            parent: this.teamHeight,
            parent_name: parent_name,
            total_res: total,
            avg: avg,
            range0to6: this.getScalePercent(keyId, 0),
            range7to8: this.getScalePercent(keyId, 1),
            range9to10: this.getScalePercent(keyId, 2),
          });
          index++
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;
      const teams = organizations[level0[0].key];
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
          }
        });
      } else {
        organization1level[level0[0].key] = true;
      }
      if(Object.keys(this.deletedTeam).length > 0){
        for(const keyId2 in this.deletedTeam){
          organization1level[keyId2] = true;
        }
      }
      _.forEach(organization1level, (value, team_id) => {
        let _temp = _.find(team, ["key", team_id]);
        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYYMMDD");
      var question = "";
      this.quest_name
        .trim()
        .split(" ")
        .map((value, i) => {
          if (i < 5) {
            question = question + "_" + value;
          }
        });
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Multiple Choice";
      ws.getCell("B6").value = this.dateShow;

      const countMessage = this.dataopenend.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Average Rating",
        "0-6 (%)",
        "7-8 (%)",
        "	9-10 (%)",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        let _tmp = [
          "",
          item.name,
          item.parent_name,
          item.avg,
          item.range0to6,
          item.range7to8,
          item.range9to10,
          item.total_res,
        ];
        ws.addRow(_tmp);
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = date_data + "_Scale" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async downloadExcel_MultipleChoice() {
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
        let total = 0;
        let option = {};
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          for (var i = 0; i < this.datamultichoices[value.key].length; i++) {
            total += this.datamultichoices[value.key][i];
            option[`precent${i+1}`] = this.getMultipleChoicePercent(value.key,this.answerOpt.length - i - 1);
            option[`res${i+1}`] = this.datamultichoices[value.key][this.answerOpt.length - i - 1];
            option[`options${i+1}`] = this.answerOpt[i];
            option['optionCount'] = option['optionCount']?option['optionCount']+1:1
          }
        }
        team.push({
          ...value,
          parent_name: parent_name,
          total_res: total,
          ...option,
        });
      });
      if(Object.keys(this.deletedTeam).length > 0){
        let index = 1
        for(const keyId in this.deletedTeam){
          this.teamAll.map((value) => {
            let total = 0;
            let option = {};
            let parent_name =
              this.teamArr[this.teamHeight] !== undefined
                ? this.teamArr[this.teamHeight].name
                : "noun";
            if (this.datamultichoices[keyId]) {
              for (var i = 0; i < this.datamultichoices[keyId].length; i++) {
                total += this.datamultichoices[keyId][i];
                option[`precent${i+1}`] = this.getMultipleChoicePercent(keyId,this.answerOpt.length - i - 1);
                option[`res${i+1}`] = this.datamultichoices[keyId][this.answerOpt.length - i - 1];
                option[`options${i+1}`] = this.answerOpt[i];
                option['optionCount'] = option['optionCount']?option['optionCount']+1:1
              }
            }
            team.push({
              key: keyId,
              name: 'Deleted Team ' + index,
              parent: this.teamHeight,
              parent_name: parent_name,
              total_res: total,
              ...option,
            });
          });
          index++
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;
      const teams = organizations[level0[0].key];
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
          }
        });
      } else {
        organization1level[level0[0].key] = true;
      }
      if(Object.keys(this.deletedTeam).length > 0){
        for(const keyId2 in this.deletedTeam){
          organization1level[keyId2] = true;
        }
      }
      _.forEach(organization1level, (value, team_id) => {
        let _temp = _.find(team, ["key", team_id]);
        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYYMMDD");
      var question = "";
      this.quest_name
        .trim()
        .split(" ")
        .map((value, i) => {
          if (i < 5) {
            question = question + "_" + value;
          }
        });
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Multiple Choice";
      ws.getCell("B6").value = this.dateShow;

      const countMessage = this.dataopenend.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Option",
        "Value",
        "Responses",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        if(item.optionCount && item.optionCount > 0){
          for (var i = 0; i < item.optionCount; i++) {
            if(i == 0){
              let _tmp = [
                "",
                item.name,
                item.parent_name,
                item.options1,
                item.percent1,
                item.res1,
                item.total_res,
              ];
              ws.addRow(_tmp);
            }else{
              let _tmp1 = ['', '', '', item[`options${i+1}`], item[`options${i+1}`], item[`res${i+1}`]];
              ws.addRow(_tmp1);
            }
          }
        }else{
          let _tmp = [
            "",
            item.name,
            item.parent_name,
            item.options1,
            item.percent1,
            item.res1,
            item.total_res,
          ];
          ws.addRow(_tmp);
          ws.addRow();
        }
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = date_data + "_Multiple-Choice" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    renderDropdown() {
      if (this.dateoptions.length > 1) {
        return (
          <i
            style="margin-left: 16px; color: #000000;"
            class="el-icon-arrow-down"
          ></i>
        );
      }
    },
    renderHeaderOpenEnded(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      let countMessage = this.dataopenend.length;
      if (countMessage && countMessage > 0 && this.summaryDetail.Summary) {
        countMessage = countMessage - 1
      }
      
      // Use filtered data for count when team filter is applied
      if (this.selectedTeamFilter !== 'all') {
        countMessage = this.filteredDataOpenEnd.filter(item => !item.Summary).length;
      }
      
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      return (
        <div class="headerOpenEnded">
          <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
            <span class="txtDropdown">
              {this.dateShow}
              {this.renderDropdown()}
            </span>

            <el-dropdown-menu slot="dropdown">
              <div style="max-height: 200px; width: 200px; overflow:auto;">
                {components}
              </div>
            </el-dropdown-menu>
          </el-dropdown>

          <span class="txtTotalResponse">
            {countMessage} {responses}
            {this.selectedTeamFilter !== 'all' && <span class="filtered-indicator"> (filtered)</span>}
          </span>
        </div>
      );
    },
    renderHeaderYesNo(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      let classForNo = !this.yes ? "box color-4 mr-8" : "box color-2 mr-8";
      let classForYes = this.yes ? "box color-4 mr-8" : "box color-2 mr-8";
      return (
        <div>
          <div class="flex-between mt-10 mb-2">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>
              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="txtTotalResponse">
              {this.$utils("addCommasInNumber", countMessage)} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-12 mt-10">
              <div class="flex ml-20">
                <div class={classForYes}></div>
                <div>{this.localizedAnswerOptions[0] || 'Yes'}</div>
              </div>
              <div class="flex ml-20">
                <div class={classForNo}></div>
                <div>{this.localizedAnswerOptions[1] || 'No'}</div>
              </div>
            </div>
          </div>
        </div>
      );
    },
    getMultipleChoiceColor(index) {
      if (this.answerOpt.length > 0) {
        let orderColor = [];
        if (this.answerOpt.length == 2) {
          orderColor = [2, 4];
        } else if (this.answerOpt.length == 3) {
          orderColor = [2, 3, 4];
        } else if (this.answerOpt.length == 4) {
          orderColor = [2, 3, 4, 5];
        } else {
          let no = 1;
          for (var i = 0; i < this.answerOpt.length; i++) {
            orderColor.push(no);
            no = no + 1;
          }
        }
        return orderColor[index];
      }
    },
    getScaleColor(index) {
      let orderColor = [2, 3, 4];
      return orderColor[index];
    },
    renderHeaderScale(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      return (
        <div>
          <div class="flex-between mt-10 mb-2">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>
              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="txtTotalResponse">
              {this.$utils("addCommasInNumber", countMessage)} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-13 mt-10">
              <div class="flex ml-20">
                <div class="box color-4 mr-8"></div>
                <div class="fc-000000 opa-06">9-10</div>
              </div>
              <div class="flex ml-20">
                <div class="box color-3 mr-8"></div>
                <div class="fc-000000 opa-06">7-8</div>
              </div>
              <div class="flex ml-20">
                <div class="box color-2 mr-8"></div>
                <div class="fc-000000 opa-06">0-6</div>
              </div>
            </div>
          </div>
        </div>
      );
    },
    renderHeaderMultipleOther(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      let components_answer = [];
      if (this.localizedAnswerOptionsOther.length > 0) {
        let orderColor = [];
        if (this.localizedAnswerOptionsOther.length == 2) {
          orderColor = [4, 2];
        } else if (this.localizedAnswerOptionsOther.length == 3) {
          orderColor = [4, 3, 2];
        } else if (this.localizedAnswerOptionsOther.length == 4) {
          orderColor = [5, 4, 3, 2];
        } else {
          let no = this.localizedAnswerOptionsOther.length;
          for (var i = this.localizedAnswerOptionsOther.length; i > 0; i--) {
            orderColor.push(no);
            no = no - 1;
          }
        }
        for (var i = 0; i < this.localizedAnswerOptionsOther.length; i++) {
          components_answer.push(
            <div class="flex ml-20">
              <div class={"box color-" + orderColor[i] + " mr-8"}></div>
              <div>{this.localizedAnswerOptionsOther[i]}</div>
            </div>
          );
        }
      }
      return (
        <div>
          <div class="flex-between mt-10 mb-2">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>
              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="txtTotalResponse">
              {this.$utils("addCommasInNumber", countMessage)} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-12 mt-10">
              {components_answer}
            </div>
          </div>
        </div>
      );
    },
    handleDateCommand(date) {
      if (date) {
        for (const x in this.dateoptions) {
          if (this.dateoptions[x].date === date) {
            this.$store.commit(
              "question/setDateShow",
              this.dateoptions[x]["show"]
            );
          }
        }
      }
      this.$store.commit("question/setLoading", true);
      if (this.dialogYesNo) {
        this.$store.dispatch("question/getDataMultiChoices", {
          date,
          quest_id: this.quest_id,
        });
      } else if (this.dialogMultipleOther) {
        this.$store.dispatch("question/getDataMultiChoicesOther", {
          date,
          quest_id: this.quest_id,
        });
      } else if (this.dialogScale) {
        this.$store.dispatch("question/getDataScale", {
          date,
          quest_id: this.quest_id,
        });
      } else {
        this.$store.dispatch("question/getDataOpenEnd", {
          date,
          quest_id: this.quest_id,
        });
      }
    },
    getScalePercent(id, index) {
      if (this.datamultichoices[id]) {
        let total = 0;
        for (var i = 0; i < this.datamultichoices[id]["range"].length; i++) {
          total += this.datamultichoices[id]["range"][i];
        }
        if (total !== 0) {
          let results = Math.round(
            (this.datamultichoices[id]["range"][index] * 100) / total
          );
          return results;
        } else {
          return 0;
        }
      }
    },
    getColorPercentForScale(value) {
      if (value) {
        return `width: ${Math.round((537 / 100) * value)}px;`;
      } else {
        return;
      }
    },
    getYesPercent(id) {
      if (this.datamultichoices[id]) {
        const total =
          this.datamultichoices[id][0] + this.datamultichoices[id][1];
        if (total !== 0)
          return Math.round((this.datamultichoices[id][0] * 100) / total);
        else return 0;
      }
    },
    getNoPercent(id) {
      if (this.datamultichoices[id]) {
        const total =
          this.datamultichoices[id][0] + this.datamultichoices[id][1];
        if (total !== 0)
          return Math.round((this.datamultichoices[id][1] * 100) / total);
        else return 0;
      }
    },
    getMultipleChoicePercent(id, index) {
      if (this.datamultichoices[id]) {
        let total = 0;
        if (this.answerOpt.length > 0) {
          for (var i = 0; i < this.datamultichoices[id].length; i++) {
            total += this.datamultichoices[id][i];
          }
          if (total !== 0) {
            let results = Math.round(
              (this.datamultichoices[id][index] * 100) / total
            );
            return results;
          } else {
            return 0;
          }
        }
      }
    },
    getColorPercent(value) {
      if (value) {
        return `width: ${Math.round((577 / 100) * value)}px;`;
      } else {
        return;
      }
    },
    getTotalResponses(id) {
      if (!this.datamultichoices[id]) return 0;

      // For Scale type (has 'range' property)
      if (this.datamultichoices[id].range) {
        return this.datamultichoices[id].range.reduce((sum, current) => sum + current, 0);
      }

      // For Yes/No type (array with 2 values)
      if (Array.isArray(this.datamultichoices[id]) && this.datamultichoices[id].length === 2) {
        return this.datamultichoices[id][0] + this.datamultichoices[id][1];
      }

      // For Multiple Choice (array with multiple values)
      if (Array.isArray(this.datamultichoices[id])) {
        return this.datamultichoices[id].reduce((sum, current) => sum + current, 0);
      }

      return 0;
    },
    async getTeamOfParent(item) {
      const organization1level = this.organization1level;
      _.forEach(item, (value) => {
        organization1level[value.team_id] = true;
        if (value.parent) {
          this.getTeamOfParent(value.parent);
          // dispatch('getTeamOfParent', value.parent)
        }
      });
    },
    openRecipientsDialog() {
      this.recipientsModal = true;
    },
    changeDataToCascader(value) {
      let recipients = [];
      let cascaderTo = [];
      let oldcascaderTo = [];
      let diffcascaderTo = {};
      let diffoldcascaderTo = {};
      
      let team = [];
      let alluser = _.find(
        this.dynamicValidateForm.cascaderTo,
        function (value) {
          return value[0] == "all_teams_and_cohorts";
        }
      );

      let oldalluser = _.find(
        this.dynamicValidateForm.oldCascaderTo,
        function (value) {
          return value[0] == "all_teams_and_cohorts";
        }
      );

      if (alluser) {
        this.dynamicValidateForm.oldCascaderTo =
          this.dynamicValidateForm.cascaderTo;
        this.dynamicValidateForm.recipients = this.allUsers;
      } else {
        if (this.dynamicValidateForm.cascaderTo) {
          this.dynamicValidateForm.cascaderTo.map((value) => {
            
            cascaderTo.push(value[0]);
          });
        }
        if (this.dynamicValidateForm.oldCascaderTo) {
          this.dynamicValidateForm.oldCascaderTo.map((value) => {
            oldcascaderTo.push(value[0]);
          });
        }

        let diff = _.xor(cascaderTo, oldcascaderTo);

        if (diff) {
          diff.map((data) => {
            if (data) {
              let diffolddata = _.filter(
                this.dynamicValidateForm.oldCascaderTo,
                function (value) {
                  return value[0] == data;
                }
              );
              if (diffolddata[0]) {
                diffoldcascaderTo[diffolddata[0]] = true;
              }
            }
          });
        }

        //cohorts
        if (this.dynamicValidateForm.cascaderTo) {
          this.dynamicValidateForm.cascaderTo.map((value) => {
            if (
              this.cohortsUser[value[0]] &&
              this.cohortsUser[value[0]].users
            ) {
              team.push(value[0]);
              for (let data in this.cohortsUser[value[0]].users) {
                let user = _.find(this.allUsers, function (v) {
                  return v.key == data;
                });
                if (user) {
                  recipients.push(user);
                }
              }
              //cohorts=====================
            } else {
              if (this._organization1level[value]) {
                for (let teamId in this._organization1level[value]) {
                  if (!diffoldcascaderTo[teamId]) {
                    if (this.userTeam[teamId]) {
                      recipients.push(...this.userTeam[teamId]);
                    }
                    let uniq = _.find(team, function (value) {
                      return value == teamId;
                    });
                    if (!uniq) {
                      team.push(teamId);
                    }
                  }
                }
              } else {
                if (this.userTeam[value]) {
                  recipients.push(...this.userTeam[value]);
                }
                let uniq = _.find(team, function (_value) {
                  return _value == value;
                });
                if (!uniq) {
                  team.push(value);
                }
              }
            }
          });
        }

        recipients = _.uniqBy(recipients, "email");
        this.dynamicValidateForm.recipients = recipients;

        this.dynamicValidateForm.oldCascaderTo =
          this.dynamicValidateForm.cascaderTo;
      }
    },
    increase(index) {
      return index + 1;
    },
    onChangeQuestionsType(value) {
      if(this.dynamicValidateForm.report_card == true){
        document.getElementById("report_card").click();
      }

      if(value == 'Text Area Field'){
        this.disabledRowHeader = true
      }else{
        this.disabledRowHeader = false
      }
    },
    onChangeY(value) {
      if (value === "Negative") {
        this.dynamicValidateForm.feelingN = "Positive";
      } else if (value === "Neutral") {
        this.dynamicValidateForm.feelingN = "Neutral";
      } else {
        this.dynamicValidateForm.feelingN = "Negative";
      }
    },
    onChangeN(value) {
      if (value === "Negative") {
        this.dynamicValidateForm.feelingY = "Positive";
      } else if (value === "Neutral") {
        this.dynamicValidateForm.feelingY = "Neutral";
      } else {
        this.dynamicValidateForm.feelingY = "Negative";
      }
    },
    async addQuestion() {
      //console.log('addQuestion')
      await this.ensureQuestionFormReady();
      this.title_dialog = this.$t("questions.add_a_question");
      this.mode = "";
      this.cancelAdd();
      this.changeDataToCascader();
    },
    cancelAdd() {
      this.activeIndex = "en";
      this.dialogFormVisible = true;
      this.option_To=this.teamleadership!=''?this.optionToleadership:this.optionTo
      this.questions_text=''
      this.dynamicValidateForm = {
        to: [],
        cascaderTo:this.teamleadership!=''?[this.teamleadership]:[["all_teams_and_cohorts"]],
        oldCascaderTo:this.teamleadership!=''?[this.teamleadership]:[["all_teams_and_cohorts"]],
        showResultsInDaily: true,
        category: "",
        type: "",
        questions:{},
        question_en: "",
        question_th: "",
        coins: "1",
        frequency: "",
        dayofweek: "monday",
        schedule: "",
        status: "Y",
        feelingY: "Positive",
        feelingN: "Negative",
        options_YN:{},
        options_en: [
          {
            key: 1,
            value: "Yes",
            weight: "1",
            placeholder: "Yes",
            question_id:''
          },
          {
            key: 2,
            value: "No",
            weight: "0",
            placeholder: "No",
            question_id:''
          },
        ],
        options_th: [
          {
            key: 1,
            value: "ใช่",
            placeholder: "Yes",
            question_id:''
          },
          {
            key: 2,
            value: "ไม่ใช่",
            placeholder: "No",
            question_id:''
          },
        ],
        options: [
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Positive",
            question_id:''
          },
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Neutral",
            question_id:''
          },
          {
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Negative",
            question_id:''
          },
        ],
        less_txt: "",
        less_txts: {},
        less_txt_en: "",
        max_txts:{},
        max_txt: "",
        max_txt_en: "",
        max: 10,
        min: 0,
        rolling:false,
        report_card: false,
        report_card_label: "",
        culture_index: false
      };
      if(this.language.length>0){
        for(const i in this.language){
     
          if(this.dynamicValidateForm.options_YN&&!this.dynamicValidateForm.options_YN[`${this.language[i].code}`]&&this.language[i].code!='en'&&this.language[i].code!='th'){
          const arr=[
          {
            key: 1,
            value: "",
            placeholder: "Yes",
            question_id:'',
          },
          {
            key: 2,
            value: "",
            placeholder: "No",
            question_id:'',
          },
        ]
        //this.dynamicValidateForm.options_YN[`${this.language[i].code}`]=JSON.parse(JSON.stringify(arr));
        this.dynamicValidateForm[`options_${this.language[i].code}`]=JSON.parse(JSON.stringify(arr));
        }
      }

      }

      this.disabledRowHeader = true
      this.changeDataToCascader();
    },
    retrunTypName(keyDimation) {
      const dimension = _.filter(this.optionsCategory, {
        key: keyDimation,
      }).map((v) => v.category);
      const imageList = [
        {
          imageName: "email-header-ambassardorship",
          name: "Ambassadorship",
        },
        {
          imageName: "email-header-companyalignment",
          name: "Company Alignment",
        },
        {
          imageName: "email-header-feedback",
          name: "Feedback",
        },
        {
          imageName: "email-header-happiness",
          name: "Happiness",
        },
        {
          imageName: "email-header-introspection",
          name: "Introspection",
        },
        {
          imageName: "email-header-recognition",
          name: "Recognition",
        },
        {
          imageName: "email-header-relationshipwithcolleagues",
          name: "Relationship with Colleagues",
        },
        {
          imageName: "email-header-relationshipmanager",
          name: "Relationship with Manager",
        },
        {
          imageName: "email-header-satisfaction",
          name: "Satisfaction",
        },
        {
          imageName: "email-header-wellness",
          name: "Wellness",
        },
        {
          imageName: "email-header-personalgrowth",
          name: "Personal Growth",
        },
      ];
      const pic = _.filter(imageList, { name: dimension[0] }).map(
        (v) => v.imageName
      );
      const images = require.context(
        "@/assets/images/questions/",
        false,
        /\.png$/
      );
      return images("./" + pic[0] + ".png");
    },
    saveQuestion() {
      var option_other = [];
      if(this.dynamicValidateForm.report_card == true) {
        if(!this.dynamicValidateForm.report_card_label.replace(/ /g, "")){
          this.$message({
            showClose: true,
            message: "Please include a Row Header for your question",
            type: "error",
          });
          return false;
        }
      }
      if (this.dynamicValidateForm.type === "Multiple Choice(other)") {

        for(const i in this.dynamicValidateForm.options){
          // console.log('i',i)
          // console.log('this.dynamicValidateForm.options[i]',this.dynamicValidateForm.options[i])
          for(const j in this.language){
            if(this.dynamicValidateForm.options[i][this.language[j].code]){
              if(!this.dynamicValidateForm.options[i][this.language[j].code].replace(/ /g, "")){
                this.$message({
                  showClose: true,
                  message: `Please input Option ${this.language[j].text}`,
                  type: "error",
                });
                return false;
              }
            }else{
              this.$message({
                showClose: true,
                message: `Please input Option ${this.language[j].text}`,
                type: "error",
              });
              return false;
            }

          }
        }



        // option_other = _.filter(
        //   this.dynamicValidateForm.options,
        //   function (currentObject) {
        //     return (
        //       !currentObject.en.replace(/ /g, "") ||
        //       !currentObject.th.replace(/ /g, "")
        //     );
        //   }
        // );
        // console.log('option_other',option_other)
      }
      if(this.dynamicValidateForm.questions){
        for(const i in this.language){

        if ( !this.dynamicValidateForm.questions[this.language[i].code] || 
        !this.dynamicValidateForm.questions[this.language[i].code].trim()) {
          this.$message({
            showClose: true,
            message: `Please include a ${this.language[i].text} version for your question`,
            type: "error",
          });
          return false;
        }
        }

      }
  
      if (!this.dynamicValidateForm.category.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Please select Dimension",
          type: "error",
        });
        return false;
      } else if (!this.dynamicValidateForm.type.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Please select Question Format",
          type: "error",
        });
        return false;
      } 
      // else if (!this.dynamicValidateForm.questions.en.replace(/ /g, "")) {
      //   this.$message({
      //     showClose: true,
      //     message: "Please input question",
      //     type: "error",
      //   });
      //   return false;
      // } else if (!this.engonly &&(!this.dynamicValidateForm.question_th.replace(/ /g, ""))) {
      //   this.$message({
      //     showClose: true,
      //     message: "Please include a Thai version for your question",
      //     type: "error",
      //   });
      //   return false;
      // } 
      else if (!this.dynamicValidateForm.coins.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Please input Coins",
          type: "error",
        });
        return false;
      } else if (!this.dynamicValidateForm.frequency.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Please select Frequency",
          type: "error",
        });
        return false;
      } else if (!this.dynamicValidateForm.dayofweek.replace(/ /g, "")&&!this.dynamicValidateForm.frequency=='Follow-up') {
        this.$message({
          showClose: true,
          message: "Please select Day of Week",
          type: "error",
        });
        return false;
      } else if (!this.dynamicValidateForm.schedule.replace(/ /g, "")&&!this.dynamicValidateForm.frequency=='Follow-up') {
        this.$message({
          showClose: true,
          message: "Please select Schedule",
          type: "error",
        });
        return false;
      } else if (this.dynamicValidateForm.type === "Multiple Choice") {
        if (
          (this.dynamicValidateForm.feelingY == "Positive" &&
            this.dynamicValidateForm.feelingN == "Negative") ||
          (this.dynamicValidateForm.feelingY == "Negative" &&
            this.dynamicValidateForm.feelingN == "Positive") ||
          (this.dynamicValidateForm.feelingY == "Neutral" &&
            this.dynamicValidateForm.feelingN == "Neutral")
        ) {
          this.$store.dispatch("custom/CreateUpdateQuestion", {
            form: this.dynamicValidateForm,
          });
          this.cancelAdd();
          this.$message({
            type: "success",
            message: "Your custom question has been created",
          });
        } else {
          this.$message({
            showClose: true,
            message:
              'Yes or No questions must have either a Positive & Negative assignment to either "Yes" or "No" options OR a Neutral assignment for both options.',
            type: "error",
          });
          return false;
        }
      } else if (this.dynamicValidateForm.type === "Multiple Choice(other)") {
        var negative = _.filter(
          this.dynamicValidateForm.options,
          function (currentObject) {
            return currentObject.feeling === "Negative";
          }
        );
        var positive = _.filter(
          this.dynamicValidateForm.options,
          function (currentObject) {
            return currentObject.feeling === "Positive";
          }
        );
        var neutral = _.filter(
          this.dynamicValidateForm.options,
          function (currentObject) {
            return currentObject.feeling === "Neutral";
          }
        );
        var feelingisEmtry = _.filter(
          this.dynamicValidateForm.options,
          function (currentObject) {
            return !currentObject.feeling.replace(/ /g, "");
          }
        );
        if (feelingisEmtry.length > 0) {
          this.$message({
            showClose: true,
            message:
              "Multiple choice questions must have at least one Positive & one Negative assignment OR a Neutral assignment for all options.",
            type: "error",
          });
          return false;
        } else {
          if (
            neutral.length === this.dynamicValidateForm.options.length &&
            neutral.length > 0
          ) {
            this.$store.dispatch("custom/CreateUpdateQuestion", {
              form: this.dynamicValidateForm,
            });
            this.cancelAdd();
            this.$message({
              type: "success",
              message: "Your custom question has been created",
            });
          } else if (positive.length > 0 && negative.length > 0) {
            this.$store.dispatch("custom/CreateUpdateQuestion", {
              form: this.dynamicValidateForm,
            });
            this.cancelAdd();
            this.$message({
              type: "success",
              message: "Your custom question has been created",
            });
          } else {
            this.$message({
              showClose: true,
              message:
                "Multiple choice questions must have at least one Positive & one Negative assignment OR a Neutral assignment for all options.",
              type: "error",
            });
            return false;
          }
        }
      } else if (this.dynamicValidateForm.type === "Scale") {
        // if (
        //   !this.engonly &&
        //   (!this.dynamicValidateForm.less_txt.replace(/ /g, "") ||
        //     !this.dynamicValidateForm.less_txt_en.replace(/ /g, "") ||
        //     !this.dynamicValidateForm.max_txt.replace(/ /g, "") ||
        //     !this.dynamicValidateForm.max_txt_en.replace(/ /g, ""))
        // ) {
        //   this.$message({
        //     showClose: true,
        //     message: "Please include a Thai version for your question",
        //     type: "error",
        //   });
        //   return false;
        // }
        for(const i in this.language){
          
          if (!this.dynamicValidateForm.less_txts[this.language[i].code] || 
          !this.dynamicValidateForm.less_txts[this.language[i].code].trim()||
          !this.dynamicValidateForm.max_txts[this.language[i].code] || 
          !this.dynamicValidateForm.max_txts[this.language[i].code].trim()){
            this.$message({
            showClose: true,
            message: "Please input min/max Label",
            type: "error",
            });
            return false;
          }
        }
        this.$store.dispatch("custom/CreateUpdateQuestion", {
            form: this.dynamicValidateForm,
          });
          this.cancelAdd();
          this.$message({
            type: "success",
            message: "Your custom question has been created",
          });


        // if (!this.dynamicValidateForm.less_txts.en.replace(/ /g, "") ||
        //     !this.dynamicValidateForm.max_txts.en.replace(/ /g, "")
        // ) {
        //   this.$message({
        //     showClose: true,
        //     message: "Please input min/max Label",
        //     type: "error",
        //   });
        //   return false;
        // } else if (!this.engonly && (!this.dynamicValidateForm.less_txt.replace(/ /g, "") ||
        //     !this.dynamicValidateForm.max_txt.replace(/ /g, ""))){
        //   this.$message({
        //     showClose: true,
        //     message: "Please input min/max Label in Thai version",
        //     type: "error",
        //   });
        //   return false;
        // } else {
        //   this.$store.dispatch("custom/CreateUpdateQuestion", {
        //     form: this.dynamicValidateForm,
        //   });
        //   this.cancelAdd();
        //   this.$message({
        //     type: "success",
        //     message: "Your custom question has been created",
        //   });
        // }
      } else {
        this.$store.dispatch("custom/CreateUpdateQuestion", {
          form: this.dynamicValidateForm,
        });
        this.cancelAdd();
        this.$message({
          type: "success",
          message: "Your custom question has been created",
        });
      }
    },
    addOptions() {
      if (this.dynamicValidateForm.options.length < 6) {
        if (this.dynamicValidateForm.options.length === 2) {
          this.dynamicValidateForm.options.push({
            key: this.$utils("mockingID", 15),
            feeling: "Negative",
            en: "",
            th: "",
            question_id:'',
          });
        } else {
          this.dynamicValidateForm.options.push({
            key: this.$utils("mockingID", 15),
            feeling: "",
            en: "",
            th: "",
            question_id:'',
          });
        }
      }
    },
    deleteOptions(value) {
      this.dynamicValidateForm.options = _.filter(
        this.dynamicValidateForm.options,
        function (currentObject) {
          return currentObject.key !== value.key;
        }
      );
    },
    cancelDialog() {
      this.dialogFormVisible = false;
      this.$refs["dynamicValidateForm"].clearValidate();
      this.$store.commit("question/setPageOT", 1);
      this.$store.dispatch("question/getScheduleOptions", {
        end_row: "",
      });
    },
    handleSelect(key, keyPath) {
      this.activeIndex = key;
    },
    scheduleChange() {
      if (this.dynamicValidateForm.frequency == "onetime") {
        this.$store.dispatch("question/getScheduleOptions", {
          end_row: "",
          dayofweek: this.dynamicValidateForm.dayofweek,
        });
        this.dynamicValidateForm.schedule = "";
      } else if (this.dynamicValidateForm.frequency == "weekly") {
        this.dynamicValidateForm.schedule = this.dynamicValidateForm.dayofweek;
      } else if (this.dynamicValidateForm.frequency == "monthly") {
        this.dynamicValidateForm.schedule = "";
      } else if (this.dynamicValidateForm.frequency == "quarterly") {
        let day =
          this.dynamicValidateForm.dayofweek.charAt(0).toUpperCase() +
          this.dynamicValidateForm.dayofweek.slice(1);
        this.options_quarterly = [
          {
            label: "First month of the quarter",
            options: [
              {
                value: "1_week1",
                label: "First " + day + " of the first month of the quarter",
              },
              {
                value: "1_week2",
                label: "Second " + day + " of the first month of the quarter",
              },
              {
                value: "1_week3",
                label: "Third " + day + " of the first month of the quarter",
              },
              {
                value: "1_week4",
                label: "Fourth " + day + " of the first month of the quarter",
              },
            ],
          },
          {
            label: "Second month of the quarter",
            options: [
              {
                value: "2_week1",
                label: "First " + day + " of the second month of the quarter",
              },
              {
                value: "2_week2",
                label: "Second " + day + " of the second month of the quarter",
              },
              {
                value: "2_week3",
                label: "Third " + day + " of the second month of the quarter",
              },
              {
                value: "2_week4",
                label: "Fourth " + day + " of the second month of the quarter",
              },
            ],
          },
          {
            label: "Third month of the quarter",
            options: [
              {
                value: "3_week1",
                label: "First " + day + " of the third month of the quarter",
              },
              {
                value: "3_week2",
                label: "Second " + day + " of the third month of the quarter",
              },
              {
                value: "3_week3",
                label: "Third " + day + " of the third month of the quarter",
              },
              {
                value: "3_week4",
                label: "Fourth " + day + " of the third month of the quarter",
              },
            ],
          },
        ];
        this.dynamicValidateForm.schedule = "";
      } else if (this.dynamicValidateForm.frequency == "biannually") {
        let day =
          this.dynamicValidateForm.dayofweek.charAt(0).toUpperCase() +
          this.dynamicValidateForm.dayofweek.slice(1);
          this.options_biannually = [
          {
            label: "First month of the Q1 and Q3",
            options: [
              {
                value: "1_week1_q1_q3",
                label: "First " + day + " of the first month of Q1 and Q3",
              },{
                value: "1_week2_q1_q3",
                label: "Second " + day + " of the first month of Q1 and Q3",
              },{
                value: "1_week3_q1_q3",
                label: "Third " + day + " of the first month of Q1 and Q3",
              },{
                value: "1_week4_q1_q3",
                label: "Forth " + day + " of the first month of Q1 and Q3",
              },{
                value: "1_week5_q1_q3",
                label: "Fifth " + day + " of the first month of Q1 and Q3",
              },
            ],
          },{
            label: "Second month of the Q1 and Q3",
            options: [
              {
                value: "2_week1_q1_q3",
                label: "First " + day + " of the second month of Q1 and Q3",
              },{
                value: "2_week2_q1_q3",
                label: "Second " + day + " of the second month of Q1 and Q3",
              },{
                value: "2_week3_q1_q3",
                label: "Third " + day + " of the second month of Q1 and Q3",
              },{
                value: "2_week4_q1_q3",
                label: "Forth " + day + " of the second month of Q1 and Q3",
              },{
                value: "2_week5_q1_q3",
                label: "Fifth " + day + " of the second month of Q1 and Q3",
              },
            ],
          },{
            label: "Third month of the Q1 and Q3",
            options: [
              {
                value: "3_week1_q1_q3",
                label: "First " + day + " of the third month of Q1 and Q3",
              },{
                value: "3_week2_q1_q3",
                label: "Second " + day + " of the third month of Q1 and Q3",
              },{
                value: "3_week3_q1_q3",
                label: "Third " + day + " of the third month of Q1 and Q3",
              },{
                value: "3_week4_q1_q3",
                label: "Forth " + day + " of the third month of Q1 and Q3",
              },{
                value: "3_week5_q1_q3",
                label: "Fifth " + day + " of the third month of Q1 and Q3",
              },
            ],
          },{
            label: "First month of the Q2 and Q4",
            options: [
              {
                value: "1_week1_q2_q4",
                label: "First " + day + " of the first month of Q2 and Q4",
              },{
                value: "1_week2_q2_q4",
                label: "Second " + day + " of the first month of Q2 and Q4",
              },{
                value: "1_week3_q2_q4",
                label: "Third " + day + " of the first month of Q2 and Q4",
              },{
                value: "1_week4_q2_q4",
                label: "Forth " + day + " of the first month of Q2 and Q4",
              },{
                value: "1_week5_q2_q4",
                label: "Fifth " + day + " of the first month of Q2 and Q4",
              },
            ],
          },{
            label: "Second month of the Q2 and Q4",
            options: [
              {
                value: "2_week1_q2_q4",
                label: "First " + day + " of the second month of Q2 and Q4",
              },{
                value: "2_week2_q2_q4",
                label: "Second " + day + " of the second month of Q2 and Q4",
              },{
                value: "2_week3_q2_q4",
                label: "Third " + day + " of the second month of Q2 and Q4",
              },{
                value: "2_week4_q2_q4",
                label: "Forth " + day + " of the second month of Q2 and Q4",
              },{
                value: "2_week5_q2_q4",
                label: "Fifth " + day + " of the second month of Q2 and Q4",
              },
            ],
          },{
            label: "Third month of the Q2 and Q4",
            options: [
              {
                value: "3_week1_q2_q4",
                label: "First " + day + " of the third month of Q2 and Q4",
              },{
                value: "3_week2_q2_q4",
                label: "Second " + day + " of the third month of Q2 and Q4",
              },{
                value: "3_week3_q2_q4",
                label: "Third " + day + " of the third month of Q2 and Q4",
              },{
                value: "3_week4_q2_q4",
                label: "Forth " + day + " of the third month of Q2 and Q4",
              },{
                value: "3_week5_q2_q4",
                label: "Fifth " + day + " of the third month of Q2 and Q4",
              },
            ],
          },
        ]
        this.dynamicValidateForm.schedule = "";
      } else if (this.dynamicValidateForm.frequency == "yearly") {
        let day =
          this.dynamicValidateForm.dayofweek.charAt(0).toUpperCase() +
          this.dynamicValidateForm.dayofweek.slice(1);
          this.options_yearly = []
          for(let i = 1; i < 13; i++){
            let month = format(`2023-${i}-01`, 'MMMM')
            this.options_yearly.push({
              label: month,
              options: [
                {
                  value: month + "_week1",
                  label: "First " + day + " of " + month,
                },{
                  value: month + "_week2",
                  label: "Second " + day + " of " + month,
                },{
                  value: month + "_week3",
                  label: "Third " + day + " of " + month,
                },{
                  value: month + "_week4",
                  label: "Forth " + day + " of " + month,
                },{
                  value: month + "_week5",
                  label: "Fifth " + day + " of " + month,
                },
              ],
            })
          }
          this.dynamicValidateForm.schedule = "";
      }
    },
    moreOptionClick() {
      this.$store.dispatch("question/nextOnetimeSchedule", {
        dayofweek: this.dynamicValidateForm.dayofweek,
      });
    },
    onInputQuestionEn(text) {
      if (this.engonly) {
        this.dynamicValidateForm.question_th = text;
      }
    },
    async openCalendarModal() {
      if (this.calendarModal) {
        this.calendarModal = false;
        return;
      }

      this.calendarModal = true;
      await this.ensureCalendarReady();
      this.getQuestionPerMonth();
      this.addDataToArr();
    },
    async refreshCalendar() {
      if (this.isRefreshingCalendar) return; // Prevent multiple clicks

      this.isRefreshingCalendar = true;

      // Fetch fresh data in background without showing loading spinner
      await this.ensureCalendarReady({
        forceRefresh: true,
        showLoader: false,
      });

      // Navigate to current month/year
      this.getDateData(new Date());

      // Refresh question data
      this.getQuestionPerMonth();
      this.addDataToArr();

      this.isRefreshingCalendar = false;
    },
    addDataToArr() {
      let firstDayOfWeek = this.calendarShowing.firstDayOfWeek;
      this.calendarData = [];
      let dayOfPastMonth =
        this.calendarShowing.lastDayOfPastMonth - firstDayOfWeek + 1;
      if (firstDayOfWeek != 1) {
        for (let i = 1; i < firstDayOfWeek; i++) {
          this.calendarData.push({
            dayOfMonth: dayOfPastMonth + i,
            id: this.$utils("mockingID", 15),
            month: this.calendarShowing.month - 1,
            questionList: [],
            openEndedCount: 0,
          });
        }
      }

      for (let i = 0; i < this.calendarShowing.lastDayOfMonth; i++) {
        let mockId = this.$utils("mockingID", 15);
        if (i + 1 == this.calendarShowing.day) {
          this.selectedDay = `${this.calendarShowing.day}_${mockId}`;
          this.addDataToTableOfModal();
        }

        let question = [];
        let questionsShowing = [];
        this.questionsPerMonth.map((value) => {
          var qusetionData = _.find(value.schedule, function (data) {
            let day = data.split("/");
            return day != null && parseInt(day) == i + 1;
          });
          if (qusetionData !== undefined) {
            question.push({
              category: value.category_name,
              questionsType: value.type_name,
              audience: value.company === "main" ? "Standard" : "Custom",
              id: value.key,
              key: value.key,
              question_en: value.question_en,
              status: value.block_status,
              notblock: value.notblock,
              repeats: value.frequency,
              power_skill: value.power_skill?value.power_skill:'',
              powerskill: value.power_skill?`${value.power_skill.slice(0,2)})`:'',
              type: (value.type) ? value.type : '',
              m_choice: (value.m_choice) ? value.m_choice : {},
              custom_type: (value.custom_type) ? value.custom_type : '',
              date: qusetionData,
              optionToName: value.optionToName,
              repeat_every: value.repeat_every,
            });
            if (value.block_status) {
              questionsShowing.push({
                category: value.category_name,
                questionsType: value.type_name,
                audience: value.company === "main" ? "Standard" : "Custom",
                id: value.key,
                key: value.key,
                question_en: value.question_en,
                status: value.block_status,
                notblock: value.notblock,
                repeats: value.frequency,
                power_skill:value.power_skill?value.power_skill:'',
                powerskill: value.power_skill?`${value.power_skill.slice(0,2)})`:'',
                type: (value.type) ? value.type : '',
                m_choice: (value.m_choice) ? value.m_choice : {},
                custom_type: (value.custom_type) ? value.custom_type : '',
                date: qusetionData,
                optionToName: value.optionToName,
                repeat_every: value.repeat_every,
              });
            }
          }
        });
       
        for(const i in questionsShowing){
          
          const date_selected = questionsShowing[i].date.replace(/\//g,'-')
          if(this.questionOrder[date_selected]){
            if(this.questionOrder[date_selected][questionsShowing[i].id]){
              questionsShowing[i]['order']=this.questionOrder[date_selected][questionsShowing[i].id].order
            }else {
              questionsShowing[i]['order']=questionsShowing[i].length
            }
          }else{
            if(questionsShowing[i].question_en=="How do you feel today?"){
              questionsShowing[i]['order']=1
            }else if(questionsShowing[i].audience=="Standard"){
              questionsShowing[i]['order']=2
            }else{
              questionsShowing[i]['order']=3
            }
          }


        }


        for(const i in question){
          
          const date_selected = question[i].date.replace(/\//g,'-')
          if(this.questionOrder[date_selected]){
            if(this.questionOrder[date_selected][question[i].id]){
              question[i]['order']=this.questionOrder[date_selected][question[i].id].order
            }else {
              question[i]['order']=question[i].length
            }
          }else{
            if(question[i].question_en=="How do you feel today?"){
              question[i]['order']=1
            }else if(question[i].audience=="Standard"){
              question[i]['order']=2
            }else{
              question[i]['order']=3
            }
          }

        }

        // Count open-ended questions for warning marker
        const openEndedCount = questionsShowing.filter(q => q.questionsType === 'Open-ended').length;

        if(this.dataCompany.alldays==false){
          const day=format(new Date(`${this.calendarShowing.year}-${this.calendarShowing.month}-${i+1}`), 'ddd')

          if(day=='Sat'||day=='Sun'){
            this.calendarData.push({
                dayOfMonth: i + 1,
                id: mockId,
                month: this.calendarShowing.month,
                year: this.calendarShowing.year,
                questionList: [],
                openEndedCount: 0,
            });

          }else{

            this.calendarData.push({
                dayOfMonth: i + 1,
                id: mockId,
                month: this.calendarShowing.month,
                year: this.calendarShowing.year,
                questionsShowing: _.orderBy(questionsShowing,'order'),
                questionList: _.orderBy(question,'order'),
                openEndedCount: openEndedCount,

            });

          }


        }else{

          this.calendarData.push({
          dayOfMonth: i + 1,
          id: mockId,
          month: this.calendarShowing.month,
          year: this.calendarShowing.year,
          questionsShowing: _.orderBy(questionsShowing,'order'),
          questionList: _.orderBy(question,'order'),
          openEndedCount: openEndedCount,
         });

        }
        
      }     
      let maxDay = Math.ceil(this.calendarData.length / 7) * 7;
      let oldValueMaxDay = this.calendarData.length;
      for (let i = oldValueMaxDay; i < maxDay; i++) {

        this.calendarData.push({
          dayOfMonth: i + 1 - oldValueMaxDay,
          id: this.$utils("mockingID", 15),
          month: this.calendarShowing.month + 1,
          year: this.calendarShowing.year,
          questionList: [],
          openEndedCount: 0,
        });
      }
    },
    getDateFromWeek(repeattimes, value) {
      const month =
        this.calendarShowing.month >= 10
          ? this.calendarShowing.month.toString()
          : "0" + this.calendarShowing.month;
      var week_every = [];
      for (var i = 0; i < repeattimes.length; i++) {
        if (
          format(repeattimes[i], "MM") === month &&
          format(repeattimes[i], "YYYY") ===
            this.calendarShowing.year.toString()
        ) {
          {
            var mday = format(repeattimes[i], "D");
            if (
              mday * 1 >= 1 &&
              mday * 1 <= 7 &&
              value.repeat_weeks.week1 == "Y"
            ) {
              week_every.push(format(repeattimes[i], "DD/MM/YYYY"));
            } else if (
              mday * 1 >= 8 &&
              mday * 1 <= 14 &&
              value.repeat_weeks.week2 == "Y"
            ) {
              week_every.push(format(repeattimes[i], "DD/MM/YYYY"));
            } else if (
              mday * 1 >= 15 &&
              mday * 1 <= 21 &&
              value.repeat_weeks.week3 == "Y"
            ) {
              week_every.push(format(repeattimes[i], "DD/MM/YYYY"));
            } else if (
              mday * 1 >= 22 &&
              mday * 1 <= 28 &&
              value.repeat_weeks.week4 == "Y"
            ) {
              week_every.push(format(repeattimes[i], "DD/MM/YYYY"));
            } else if (
              mday * 1 >= 29 &&
              mday * 1 <= 31 &&
              value.repeat_weeks.week5 == "Y"
            ) {
              week_every.push(format(repeattimes[i], "DD/MM/YYYY"));
            }
          }
        }
      }
      return week_every;
    },
    getQuestionPerMonth() {
      let questionsAll = this.questionsAll.concat(this.questionsAllCustom);
      //optionToName
      let questionslist = [];
      const month =
        this.calendarShowing.month >= 10
          ? this.calendarShowing.month.toString()
          : "0" + this.calendarShowing.month;
      var date = format(this.calendarShowing.year + month + "01", "YYYY-MM-DD");
      let nextMonth = format(Dateformat.addMonths(date, 1), "YYYY-MM-DD");
      let lastMonth = format(Dateformat.subMonths(date, 1), "YYYY-MM");
      nextMonth = nextMonth.split("-");
      lastMonth = lastMonth.split("-");
      questionsAll.map((value) => {
        var _day = [];
        var week_every = [];
        let repeattimes;
        let  week_2 = 'Y';
        let  week_4 = 'Y';
        let  week_1 = 'Y';
        let  week_3 = 'Y';
        let  week_5 = 'Y';
        let sched;
        let date_weekly = [];
        if (value.repeats != "onetime" && value.repeats) {
          if (value.repeat_days.Sun == "Y") {
            _day.push(1);
          }
          if (value.repeat_days.Mon == "Y") {
            _day.push(2);
          }
          if (value.repeat_days.Tue == "Y") {
            _day.push(3);
          }
          if (value.repeat_days.Wed == "Y") {
            _day.push(4);
          }
          if (value.repeat_days.Thu == "Y") {
            _day.push(5);
          }
          if (value.repeat_days.Fri == "Y") {
            _day.push(6);
          }
          if (value.repeat_days.Sat == "Y") {
            _day.push(7);
          }
        }
        switch (value.repeats) {
          case "onetime":
            let stratOn = value.starton.split("/");
            if (
              parseInt(stratOn[1]) === parseInt(this.calendarShowing.month) &&
              stratOn[2] === this.calendarShowing.year.toString()
            ) {
              questionslist.push({
                ...value,
                schedule: [value.starton],
              });
            }
            break;
          case "weekly":
            if (value.repeat_every > 1) {
              if (value.start_weeks == "2") {
                week_every = [2, 4, 6];
                week_2 = 'Y';
                week_4 = 'Y';
                week_1 = 'N';
                week_3 = 'N';
                week_5 = 'N';
              } else {
                week_every = [1, 3, 5];
                week_2 = 'N';
                week_4 = 'N';
                week_1 = 'Y';
                week_3 = 'Y';
                week_5 = 'Y';
              }
            } else {
              week_every = [1, 2, 3, 4, 5];
              week_2 = 'Y';
              week_4 = 'Y';
              week_1 = 'Y';
              week_3 = 'Y';
              week_5 = 'Y';
            }
            sched = {
              schedules: [
                {
                  dw: _day,
                },
              ],
            }; //, wm: week_every
            repeattimes = later
              .schedule(sched)
              .next(
                36,
                new Date(
                  lastMonth[0] +
                    "," +
                    lastMonth[1] +
                    "," +
                    this.calendarShowing.lastDayOfPastMonth
                ),
                new Date(nextMonth[0] + "," + nextMonth[1] + "," + nextMonth[2])
              );


             



              
            repeattimes.map((data) => {

              var mday = format(data, "D")
              if((mday*1)>=1 && (mday*1)<=7  && week_1 == 'Y'){
                if (
                format(data, "MM") === month &&
                format(data, "YYYY") === this.calendarShowing.year.toString()
              ) {
                date_weekly.push(format(data, "DD/MM/YYYY"));
              }
                    
                }else if((mday*1)>=8 && (mday*1)<=14 && week_2 == 'Y'){
                  if (
                format(data, "MM") === month &&
                format(data, "YYYY") === this.calendarShowing.year.toString()
              ) {
                date_weekly.push(format(data, "DD/MM/YYYY"));
              }
                   
                }else if((mday*1)>=15 && (mday*1)<=21 && week_3 == 'Y'){
                  if (
                format(data, "MM") === month &&
                format(data, "YYYY") === this.calendarShowing.year.toString()
              ) {
                date_weekly.push(format(data, "DD/MM/YYYY"));
              }
                   
                }else if((mday*1)>=22 &&  (mday*1)<=28 && week_4 == 'Y'){
                  if (
                format(data, "MM") === month &&
                format(data, "YYYY") === this.calendarShowing.year.toString()
              ) {
                date_weekly.push(format(data, "DD/MM/YYYY"));
              }
                  
                }else if((mday*1)>=29 &&  (mday*1)<=31 && week_5 == 'Y'){
                  if (
                format(data, "MM") === month &&
                format(data, "YYYY") === this.calendarShowing.year.toString()
              ) {
                date_weekly.push(format(data, "DD/MM/YYYY"));
              }
                 
                }
              
              
            });
            date_weekly = _.uniqBy(date_weekly, function (e) {
              return e;
            });
            // console.log("date_weekly",date_weekly)
            questionslist.push({ ...value, schedule: date_weekly });

            break;
          case "monthly":
            var month_every = [];
            const result = month % 2 == 0 ? "even" : "odd";
            let check = false;
            if (value.repeat_every > 1) {
              if (value.start_month == "even") {
                month_every = [2, 4, 6, 8, 10, 12];
                if (result == value.start_month) {
                  check = true;
                }
              } else {
                month_every = [1, 3, 5, 7, 9, 11];
                if (result == value.start_month) {
                  check = true;
                }
              }
            } else {
              check = true;
              month_every = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            }
            sched = {
              schedules: [
                {
                  dw: _day,
                  M: month_every,
                },
              ],
            };
            repeattimes = later
              .schedule(sched)
              .next(
                36,
                new Date(
                  lastMonth[0] +
                    "," +
                    lastMonth[1] +
                    "," +
                    this.calendarShowing.lastDayOfPastMonth
                ),
                new Date(nextMonth[0] + "," + nextMonth[1] + "," + nextMonth[2])
              );
            if (check) {
              week_every = this.getDateFromWeek(repeattimes, value);
              questionslist.push({ ...value, schedule: week_every });
            }
            break;
          case "biannually":
          case "quarterly":
            var quarter_every = [];
            const quarters = {
              Q1:
                value.repeat_quarters === undefined
                  ? "Y"
                  : value.repeat_quarters.Q1,
              Q2:
                value.repeat_quarters === undefined
                  ? "Y"
                  : value.repeat_quarters.Q2,
              Q3:
                value.repeat_quarters === undefined
                  ? "Y"
                  : value.repeat_quarters.Q3,
              Q4:
                value.repeat_quarters === undefined
                  ? "Y"
                  : value.repeat_quarters.Q4,
            };

            if (quarters.Q1 == "Y") {
              if (value.repeat_quarter == 1) {
                quarter_every.push(1);
              } else if (value.repeat_quarter == 2) {
                quarter_every.push(2);
              } else if (value.repeat_quarter == 3) {
                quarter_every.push(3);
              }
            }

            if (quarters.Q2 == "Y") {
              if (value.repeat_quarter == 1) {
                quarter_every.push(4);
              } else if (value.repeat_quarter == 2) {
                quarter_every.push(5);
              } else if (value.repeat_quarter == 3) {
                quarter_every.push(6);
              }
            }

            if (quarters.Q3 == "Y") {
              if (value.repeat_quarter == 1) {
                quarter_every.push(7);
              } else if (value.repeat_quarter == 2) {
                quarter_every.push(8);
              } else if (value.repeat_quarter == 3) {
                quarter_every.push(9);
              }
            }

            if (quarters.Q4 == "Y") {
              if (value.repeat_quarter == 1) {
                quarter_every.push(10);
              } else if (value.repeat_quarter == 2) {
                quarter_every.push(11);
              } else if (value.repeat_quarter == 3) {
                quarter_every.push(12);
              }
            }

            sched = {
              schedules: [
                {
                  dw: _day,
                  M: quarter_every,
                },
              ],
            };

            repeattimes = later
              .schedule(sched)
              .next(
                36,
                new Date(
                  lastMonth[0] +
                    "," +
                    lastMonth[1] +
                    "," +
                    this.calendarShowing.lastDayOfPastMonth
                ),
                new Date(nextMonth[0] + "," + nextMonth[1] + "," + nextMonth[2])
              );
            week_every = this.getDateFromWeek(repeattimes, value);
            if (week_every.length > 0) {
              questionslist.push({ ...value, schedule: week_every });
            }
            break;
          default:
            if (this.calendarShowing.monthLabel === value.repeat_months) {
              sched = {
                schedules: [{ dw: _day, M: [this.calendarShowing.month] }],
              };
              repeattimes = later
                .schedule(sched)
                .next(
                  36,
                  new Date(
                    lastMonth[0] +
                      "," +
                      lastMonth[1] +
                      "," +
                      this.calendarShowing.lastDayOfPastMonth
                  ),
                  new Date(
                    nextMonth[0] + "," + nextMonth[1] + "," + nextMonth[2]
                  )
                );
              week_every = this.getDateFromWeek(repeattimes, value);
              if (week_every.length > 0) {
                questionslist.push({ ...value, schedule: week_every });
              }
            }
            break;
        }
      });

      this.questionsPerMonth = questionslist;
    },
    addDataToTableOfModal() {
      let id = this.selectedDay.split("_");
      let selected = new _.find(this.calendarData, {
        id: id[1],
      });
      const date_selected = format(new Date(`${selected.year}-${selected.month}-${selected.dayOfMonth}`), "YYYY-MM-DD"); ;
      for(let i in selected.questionList){
        if(this.questionOrder[date_selected]){
          if(this.questionOrder[date_selected][selected.questionList[i].id]){
            selected.questionList[i]['order']=this.questionOrder[date_selected][selected.questionList[i].id].order
          }else {
            selected.questionList[i]['order']=selected.questionList.length
          }
        }else{
          if(selected.questionList[i].question_en=="How do you feel today?"){
            selected.questionList[i]['order']=1
          }else if(selected.questionList[i].audience=="Standard"){
            selected.questionList[i]['order']=2
          }else{
            selected.questionList[i]['order']=3
        }

        }
        if(selected.questionList[i].optionToName){
          for(let j in selected.questionList[i].optionToName){
            if(j==0){
              selected.questionList[i].delivery=selected.questionList[i].optionToName[j]
            }else{
              selected.questionList[i].delivery+=','+selected.questionList[i].optionToName[j]
            }
            
          }
        }else{
            selected.questionList[i].delivery="All"
          }
       
      }
      selected.questionList=_.sortBy(selected.questionList, ['order']);

      this.tableSelectedDay = selected.questionList; // month
    
      let date = new Date(
        this.calendarShowing.year,
        selected.month - 1,
        selected.dayOfMonth
      );
      let dayLabel = format(date, "dddd");
      let monthLabel = format(date, "MMMM");
      this.questionPreviewText = `Question Preview for ${dayLabel}, ${monthLabel} ${selected.dayOfMonth}, ${this.calendarShowing.year}`;
    },
    async updateCradList(event) {
      const currentPosition = event.newIndex;
      const questionOrder=this.questionOrder
      const month=this.calendarShowing.month>=10?this.calendarShowing.month:'0'+this.calendarShowing.month
      const dateData=this.calendarShowing.year+'-'+month+'-'+this.selectedDay.split("_")[0]
      if(!questionOrder[dateData]){
        questionOrder[dateData]={}
      }
      for(const i in this.tableSelectedDay){
        this.tableSelectedDay[i].order = Number(i)+1
        if(!questionOrder[dateData][this.tableSelectedDay[i].id]){
          questionOrder[dateData][this.tableSelectedDay[i].id]={}
        }
        questionOrder[dateData][this.tableSelectedDay[i].id]={order:Number(i)+1,quest_id:this.tableSelectedDay[i].id,question:this.tableSelectedDay[i].question_en}
      }
      this.questionOrder=questionOrder
      this.$store.dispatch("question/updateCard",{data:this.tableSelectedDay,day:this.selectedDay.split("_")[0],month:this.calendarShowing.month,year:this.calendarShowing.year});
      //  console.log(' this.tableSelectedDay', this.tableSelectedDay)
      
    },
    anotherMonthData(value) {
      let month = this.calendarShowing.month - 1;
      let year = this.calendarShowing.year;
      this.clearCalendarData();
      if (month + value < 0) {
        this.getDateData(new Date(year - 1, 11, 1));
      } else {
        this.getDateData(new Date(year, month + value, 1));
      }
      this.getQuestionPerMonth();
      this.addDataToArr();
    },
    clearCalendarData() {
      this.calendarShowing = {
        day: 1,
        dayLabel: "Mon",
        month: 1,
        monthLabel: "January",
        year: "2010",
        firstDayOfWeek: 0,
        lastDayOfPastMonth: 30,
        lastDayOfMonth: 30,
      };
      this.tableSelectedDay = [];
      this.selectedDay = null;
      this.calendarData = [];
      this.questionPreviewText = "";
    },
    getDateData(date) {
      let month = parseInt(format(date, "M")) - 1;
      let pastMonth = month - 1;
      let year = parseInt(format(date, "YYYY"));
      let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));

      let firstDayOfWeek = parseInt(format(new Date(year, month, 1), "d"));
      if (firstDayOfWeek == 0) {
        firstDayOfWeek = 7;
      }
      this.calendarShowing.firstDayOfWeek = firstDayOfWeek;
      this.calendarShowing.day = format(date, "D");
      this.calendarShowing.dayLabel = format(date, "dddd");
      this.calendarShowing.month = parseInt(format(date, "M"));
      this.calendarShowing.monthLabel = format(date, "MMMM");
      this.calendarShowing.year = parseInt(format(date, "YYYY"));
      this.calendarShowing.lastDayOfPastMonth = parseInt(
        format(dateOfPastMont, "D")
      );
      this.calendarShowing.lastDayOfMonth = parseInt(
        format(endOfMonth(date), "D")
      );
    },
    generateRowHeader(form){
      if(form.report_card == true){
        this.$store.dispatch("question/generateRowHeader", form);
      }
    },
    handleBlock(item) {
      if (item.status === false) {
        if (item.audience === "Custom") {
          this.$store.dispatch("custom/blockQuestion", item.key);
        } else {
          this.$store.dispatch("question/blockQuestion", item.key);
        }
      } else {
        if (item.audience === "Custom") {
          this.$store.dispatch("custom/unblockQuestion", item.key);
        } else {
          this.$store.dispatch("question/unblockQuestion", item.key);
        }
      }

      this.calendarData.map((value, i) => {
        let selected = _.find(value.questionList, {
          id: item.id,
        });

        if (item.status && selected !== undefined) {
          value.questionsShowing.push(item);
        } else if (selected !== undefined) {
          value.questionsShowing = _.filter(
            value.questionList,
            function (currentObject) {
              return (
                currentObject.id !== item.id && currentObject.status == true
              );
            }
          );
        }
      });
    },
    questionPlaceholder(type, lang) {
      let placeholder = "Question";
      if (type == "Multiple Choice") {
        placeholder = "Question";
      } else if (type == "Multiple Choice(other)") {
        placeholder = "Question";
      } else if (type == "Scale") {
        placeholder = "On a scale of 0 to 10…";
      } else if (type == "Text Area Field") {
        placeholder = "Question";
      }
      return placeholder + " " + lang;
    },
    previewOptionsText(options) {
      let text = "";
      let firstText = true;
      if (options.length > 1) {
        const length = options.length;
        for (let i = 0; i < length; i++) {
          if (options[i].feeling == "Positive") {
            if (firstText) {
              firstText = false;
              text = "“" + options[i].en;
            } else {
              text = text + "” or “" + options[i].en;
            }
          }
        }
        text = text + "”";
        if (text.length < 3) {
          text = "“" + options[0].en + "”";
        }
      } else if (options) {
        text = options[0].en;
      }
      if (text.length > 3) {
        return text;
      } else {
        return "“Option...”";
      }
    },
    filterToFunction(node, keyword) {
      let space = keyword.split(" ");
      let comma = keyword.split(",");
      let commaAndSpace = keyword.split(", ");
      let keywordArr = comma;
      if (space.length > comma.length) {
        keywordArr = space;
      } else if (
        commaAndSpace.length > comma.length ||
        commaAndSpace.length > space.length
      ) {
        keywordArr = commaAndSpace;
      }
      if (keywordArr.length > 1) {
        for (let i = 0; i < keywordArr.length; i++) {
          if (node.data.toType == "user") {
            if (
              node.data.firstname
                .toLowerCase()
                .indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname
                .toLowerCase()
                .indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (keywordArr[i].trim() === node.data.email) {
              this.dynamicValidateForm.cascaderTo.push([
                "user_" + node.data.email,
              ]);
              this.changeDataTo(this.dynamicValidateForm.cascaderTo);
              this.refreshInput = false;
              setTimeout(() => {
                this.refreshInput = true;
              }, i * 75);
            }
          }
        }
        setTimeout(() => {
          this.$refs.refTo.inputValue = "";
          this.$refs.refTo.dropDownVisible = false;
        }, keywordArr.length * 75);
        this.$refs.refTo.handleClear();
      } else {
        if (node.data.toType == "user") {
          if (
            node.data.firstname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (
            node.data.lastname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (keyword.trim() === node.data.email) {
            this.dynamicValidateForm.cascaderTo.push([
              "user_" + node.data.email,
            ]);
            this.refreshInput = false;
            this.changeDataTo(this.dynamicValidateForm.cascaderTo);
            setTimeout(() => {
              this.refreshInput = true;
            }, 100);
            this.$refs.refTo.inputValue = "";
            this.$refs.refTo.dropDownVisible = false;
            this.$refs.refTo.handleClear();
          }
        } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
        }
      }
    },
    getfollow_up_question(index,options){
      let label='option '+(index+1)
      if(options){
        if(options.value){
          label=options.value
        }else if(options.en){
          label=options.en
        }
        if(options.question_id){
          this.selectquestionFollewUp = options.question_id
        }
      }else{
        this.selectquestionFollewUp = '';
      }
      this.titleName=`If person responds "{${label}}" then follow up with this question:`
      this.follow_up_question=true
      this.indexOption=index
      const follow_up =_.filter(this.questioncustomAll,(o)=>{return o.frequency == 'Follow-up';})
      this.questionFollewUp=follow_up
    },
    addFollowUpQuestion(){
      
      if(this.dynamicValidateForm.type == 'Multiple Choice'){
        
        this.dynamicValidateForm.options_en[this.indexOption].question_id=this.selectquestionFollewUp
        this.dynamicValidateForm.options_th[this.indexOption].question_id=this.selectquestionFollewUp  
      }else {
        this.dynamicValidateForm.options[this.indexOption].question_id=this.selectquestionFollewUp
      }
      this.selectquestionFollewUp=''
      this.follow_up_question=false
    },
    getstylefollowUp(option){
      if(option.question_id==''){
        return 'background-color:#E0E0E0;color:black;'

      }else {
        return 'background-color:#6C30CC;color:white;'
      }
    },
    async genQuestion() {
      const response = await this.$store.dispatch("custom/getOpenai", {
          questions: this.questions_text,
          languages:this.language
        })
        // console.log('response',response)
        this.putToform(response)

    },
    putToform(data) {
      const item=_.clone(data)
      item.repeats=data.frequency.toLowerCase()
      item.repeat_days=data.schedule.dayOfWeek.toLowerCase()
      const dimension =_.filter(this.optionsCategory,(o)=>{return o.category == data.type.dimension;}) 

      item.category=dimension[0].key
      item.type=data.type.questionType
      
      item.custom_type=data.type.questionType.toLowerCase()
      

      if(data.type.questionType=="Multiple Choice"){
        
        if(item.options){
          if(item.options.length>2){
            item.type="Multiple Choice"
            item.custom_type="multiple_choice"
          }
        }
      }else if(data.type.questionType=='Open-ended'){
        item.type_name=data.type.questionType      
        item.custom_type=data.type.questionType.toLowerCase()
        item.type="Text Area Field"
      }
      this.id = item.key;
      let schedule = "";
      let day = '';
      let option = [];
      if (item.repeats == "weekly") {
        day = item.repeat_days.toLowerCase();
        schedule="Every "+data.schedule.dayOfWeek
      } else if (item.repeats == "monthly") {
        day=item.repeat_days.toLowerCase()
        schedule = "week"+data.schedule.weekOfMonth
      } else if (item.repeats == "quarterly") {
        day=item.repeat_days.toLowerCase()
        // let dayKey = _.invert(item.repeat_days)["Y"];
        // if (dayKey == "Mon") {
        //   day = "monday";
        // } else if (dayKey == "Tue") {
        //   day = "tuesday";
        // } else if (dayKey == "Wed") {
        //   day = "wednesday";
        // } else if (dayKey == "Thu") {
        //   day = "thursday";
        // } else if (dayKey == "Fri") {
        //   day = "friday";
        // } else if (dayKey == "Sat") {
        //   day = "saturday";
        // } else if (dayKey == "Sun") {
        //   day = "sunday";
        // }
        let dayName = day.charAt(0).toUpperCase() + day.slice(1);
        this.options_quarterly = [
          {
            label: "First month of the quarter",
            options: [
              {
                value: "1_week1",
                label:
                  "First " + dayName + " of the first month of the quarter",
              },
              {
                value: "1_week2",
                label:
                  "Second " + dayName + " of the first month of the quarter",
              },
              {
                value: "1_week3",
                label:
                  "Third " + dayName + " of the first month of the quarter",
              },
              {
                value: "1_week4",
                label:
                  "Fourth " + dayName + " of the first month of the quarter",
              },
            ],
          },
          {
            label: "Second month of the quarter",
            options: [
              {
                value: "2_week1",
                label:
                  "First " + dayName + " of the second month of the quarter",
              },
              {
                value: "2_week2",
                label:
                  "Second " + dayName + " of the second month of the quarter",
              },
              {
                value: "2_week3",
                label:
                  "Third " + dayName + " of the second month of the quarter",
              },
              {
                value: "2_week4",
                label:
                  "Fourth " + dayName + " of the second month of the quarter",
              },
            ],
          },
          {
            label: "Third month of the quarter",
            options: [
              {
                value: "3_week1",
                label:
                  "First " + dayName + " of the third month of the quarter",
              },
              {
                value: "3_week2",
                label:
                  "Second " + dayName + " of the third month of the quarter",
              },
              {
                value: "3_week3",
                label:
                  "Third " + dayName + " of the third month of the quarter",
              },
              {
                value: "3_week4",
                label:
                  "Fourth " + dayName + " of the third month of the quarter",
              },
            ],
          },
        ];
        let week = 'week'+data.schedule.weekOfMonth//_.invert(item.repeat_weeks)["Y"];
        schedule = data.schedule.monthOfQuarter+ "_" + week;
      } else if (item.repeats == "biannually") {
        const quarter1=data.schedule.quarterPair.substring(0, 2);
        const quarter2=data.schedule.quarterPair.substring(2, 4);
        day=item.repeat_days.toLowerCase()
        let dayName = day.charAt(0).toUpperCase() + day.slice(1);
          this.options_biannually = [
          {
            label: "First month of the Q1 and Q3",
            options: [
              {
                value: "1_week1_q1_q3",
                label: "First " + dayName + " of the first month of Q1 and Q3",
              },{
                value: "1_week2_q1_q3",
                label: "Second " + dayName + " of the first month of Q1 and Q3",
              },{
                value: "1_week3_q1_q3",
                label: "Third " + dayName + " of the first month of Q1 and Q3",
              },{
                value: "1_week4_q1_q3",
                label: "Forth " + dayName + " of the first month of Q1 and Q3",
              },{
                value: "1_week5_q1_q3",
                label: "Fifth " + dayName + " of the first month of Q1 and Q3",
              },
            ],
          },{
            label: "Second month of the Q1 and Q3",
            options: [
              {
                value: "2_week1_q1_q3",
                label: "First " + dayName + " of the second month of Q1 and Q3",
              },{
                value: "2_week2_q1_q3",
                label: "Second " + dayName + " of the second month of Q1 and Q3",
              },{
                value: "2_week3_q1_q3",
                label: "Third " + dayName + " of the second month of Q1 and Q3",
              },{
                value: "2_week4_q1_q3",
                label: "Forth " + dayName + " of the second month of Q1 and Q3",
              },{
                value: "2_week5_q1_q3",
                label: "Fifth " + dayName + " of the second month of Q1 and Q3",
              },
            ],
          },{
            label: "Third month of the Q1 and Q3",
            options: [
              {
                value: "3_week1_q1_q3",
                label: "First " + dayName + " of the third month of Q1 and Q3",
              },{
                value: "3_week2_q1_q3",
                label: "Second " + dayName + " of the third month of Q1 and Q3",
              },{
                value: "3_week3_q1_q3",
                label: "Third " + dayName + " of the third month of Q1 and Q3",
              },{
                value: "3_week4_q1_q3",
                label: "Forth " + dayName + " of the third month of Q1 and Q3",
              },{
                value: "3_week5_q1_q3",
                label: "Fifth " + dayName + " of the third month of Q1 and Q3",
              },
            ],
          },{
            label: "First month of the Q2 and Q4",
            options: [
              {
                value: "1_week1_q2_q4",
                label: "First " + dayName + " of the first month of Q2 and Q4",
              },{
                value: "1_week2_q2_q4",
                label: "Second " + dayName + " of the first month of Q2 and Q4",
              },{
                value: "1_week3_q2_q4",
                label: "Third " + dayName + " of the first month of Q2 and Q4",
              },{
                value: "1_week4_q2_q4",
                label: "Forth " + dayName + " of the first month of Q2 and Q4",
              },{
                value: "1_week5_q2_q4",
                label: "Fifth " + dayName + " of the first month of Q2 and Q4",
              },
            ],
          },{
            label: "Second month of the Q2 and Q4",
            options: [
              {
                value: "2_week1_q2_q4",
                label: "First " + dayName + " of the second month of Q2 and Q4",
              },{
                value: "2_week2_q2_q4",
                label: "Second " + dayName + " of the second month of Q2 and Q4",
              },{
                value: "2_week3_q2_q4",
                label: "Third " + dayName + " of the second month of Q2 and Q4",
              },{
                value: "2_week4_q2_q4",
                label: "Forth " + dayName + " of the second month of Q2 and Q4",
              },{
                value: "2_week5_q2_q4",
                label: "Fifth " + dayName + " of the second month of Q2 and Q4",
              },
            ],
          },{
            label: "Third month of the Q2 and Q4",
            options: [
              {
                value: "3_week1_q2_q4",
                label: "First " + dayName + " of the third month of Q2 and Q4",
              },{
                value: "3_week2_q2_q4",
                label: "Second " + dayName + " of the third month of Q2 and Q4",
              },{
                value: "3_week3_q2_q4",
                label: "Third " + dayName + " of the third month of Q2 and Q4",
              },{
                value: "3_week4_q2_q4",
                label: "Forth " + dayName + " of the third month of Q2 and Q4",
              },{
                value: "3_week5_q2_q4",
                label: "Fifth " + dayName + " of the third month of Q2 and Q4",
              },
            ],
          },
        ];
        let week ="week"+data.schedule.weekOfMonth
        
        schedule = data.schedule.monthOfQuarter + "_" + week + "_" + quarter1.toLowerCase() + "_" + quarter2.toLowerCase();
      } else if (item.repeats == "yearly") {
        day=item.repeat_days.toLowerCase()
        let dayName = day.charAt(0).toUpperCase() + day.slice(1);
        this.options_yearly = []
        for(let i = 1; i < 13; i++){
          let month = format(`2023-${i}-01`, 'MMMM')
          this.options_yearly.push({
            label: month,
            options: [
              {
                value: month + "_week1",
                label: "First " + dayName + " of " + month,
              },{
                value: month + "_week2",
                label: "Second " + dayName + " of " + month,
              },{
                value: month + "_week3",
                label: "Third " + dayName + " of " + month,
              },{
                value: month + "_week4",
                label: "Forth " + dayName + " of " + month,
              },{
                value: month + "_week5",
                label: "Fifth " + dayName + " of " + month,
              },
            ],
          })
        }
        let week ="week"+data.schedule.weekOfMonth
        let nameMonth = format(`2023-${data.schedule.monthOfYear}-01`, 'MMMM')
        schedule = nameMonth + "_" + week;
      } 
      const lang={}
      for(const i in this.language){
          if(!lang[this.language[i].code]){
            lang[this.language[i].code]=''
          }
      }
      if (item.custom_type == "multiple_choice") {

        for(const i in data.options){

          option.push({
            key: this.$utils("mockingID", 15),
            th: data.options[i].content.th?data.options[i].content.th:data.options[i].content.en,
            en: data.options[i].content.en,
            feeling:data.options[i].sentiment,
            question_id:''
          })

        }
       
        // item.m_choice.en.map((value, i) => {
        //   for(const key in lang){
       
        //       if(item.m_choice[key]&&item.m_choice[key][i]){
        //         lang[key]=item.m_choice[key]?item.m_choice[key][i]:''
        //       }
        //   }
         
        //   option.push({
        //     ...lang,
        //     key: this.$utils("mockingID", 15),
        //     th: item.m_choice.th[i],
        //     en: value,
        //     feeling: item.m_choice.feeling[i],
        //     question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[i]:'',
        //   });
        // });
        
      } else {
        option = [
          {
            ...lang,
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Positive",
            question_id:'',
          },
          {
            ...lang,
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Neutral",
            question_id:'',
          },
          {
            ...lang,
            key: this.$utils("mockingID", 15),
            th: "",
            en: "",
            feeling: "Negative",
            question_id:'',
          },
        ];
      }

      item.questions=data.question
     
       
      
      let cascaderTo = [];
      if (!item.teams && !item.cohorts) {
        cascaderTo.push(["all_teams_and_cohorts"]);
      } else {
        if (item.teams) {
          item.teams.map((value) => {
            cascaderTo.push([value]);
          });
        }
        if (item.cohorts) {
          item.cohorts.map((value) => {
            cascaderTo.push([value]);
          });
        }
      }
      this.dynamicValidateForm = {
        cascaderTo: cascaderTo,
        showResultsInDaily: true,
        category: item.category,
        type:
          item.custom_type == "multiple_choice"
            ? "Multiple Choice(other)"
            : item.type,
        question_en: item.question_en,
        question_th: item.question,
        questions:item.questions,
        coins:item.reward.toString(),
        frequency: item.repeats,
        schedule: schedule,
        status: "Y",
        feelingY: item.custom_type == "yes_no" ? item.m_choice.feeling[0] : "",
        feelingN: item.custom_type == "yes_no" ? item.m_choice.feeling[1] : "",
        options_YN:{},
        options_en: [
          { key: 1, value: "Yes", weight: "1", placeholder: "Yes",question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[0]:''},
          { key: 2, value: "No", weight: "0", placeholder: "No",question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[1]:'' },
        ],
        options_th: [
          { key: 1, value: "ใช่", placeholder: "Yes",question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[0]:'' },
          { key: 2, value: "ไม่ใช่", placeholder: "No",question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[1]:'' },
        ],
        options: option,
        dayofweek: day,
        less_txts: item.less_txts,
        less_txt: item.less_txt,
        less_txt_en: item.less_txt_en,
        max_txts: item.max_txts,
        max_txt: item.max_txt,
        max_txt_en: item.max_txt_en,
        custom_type: item.custom_type,
        powerSkill: item.powerSkill,
        max: 10,
        min: 0,
        rolling:item.rolling,
        report_card: (item.report_card && item.report_card == 'Y') ? true : false,
        report_card_label: item.report_card_label ? item.report_card_label : '',
        culture_index: item.culture_index ? item.culture_index : false
      };
     
      
      if(item.custom_type == "yes_no"){
        for(const key in lang){
          if(key!='en'&&key!='th'){
   
              const arr=[
                { key: 1, value: item.m_choice[key]?item.m_choice[key][0]:'', placeholder: 'Yes', question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[0]:'' },
                { key: 2, value: item.m_choice[key]?item.m_choice[key][1]:'', placeholder: 'No', question_id:item.m_choice&&item.m_choice.quest_id?item.m_choice.quest_id[1]:'' },
              ]
              if(this.dynamicValidateForm.options_YN&&!this.dynamicValidateForm.options_YN[key]){
                this.dynamicValidateForm.options_YN[key]=JSON.parse(JSON.stringify(arr));
                this.dynamicValidateForm[`options_${key}`]=JSON.parse(JSON.stringify(arr));
              //   this.$set(this.dynamicValidateForm.options_YN, key, [
              //   { key: 1, value: item.m_choice[key]?item.m_choice[key][0]:'', placeholder: 'Yes', question_id: '' },
              //   { key: 2, value: item.m_choice[key]?item.m_choice[key][1]:'', placeholder: 'No', question_id: '' },
              // ]);
              }
              
          }
        }
     

      }

     
      if(item.frequency == "Follow-up"){
        this.dynamicValidateForm.frequency = item.frequency
      }
      if(item.type == 'Text Area Field'){
        this.disabledRowHeader = true
      }else{
        this.disabledRowHeader = false
      }
      if(item.report_card_label){
        this.$store.commit("question/setRowHeader", item.report_card_label);
      }else{
        this.$store.commit("question/setRowHeader", '');
      }

  
    },
    truncateText(text) {
      let length = 50; // Maximum length for truncated text
      return text && text.length > length ? text.slice(0, length) + "..." : text;
    },
    getTeamNameInfo(teamId) {
      // Cache the result to avoid repeated calculations
      if (!this._teamNameCache) {
        this._teamNameCache = {};
      }
      
      if (!this._teamNameCache[teamId]) {
        this._teamNameCache[teamId] = this.getAnonymousTeamName(teamId);
      }
      
      return this._teamNameCache[teamId];
    },
    getAnonymousTeamName(teamId, responseCount = 1, isCheckingParent = false) {
      // Use configurable thresholds
      const MIN_RESPONSES = this.MIN_RESPONSES_FOR_TEAM_NAME;
      const MIN_MEMBERS = this.MIN_MEMBERS_FOR_TEAM_NAME;
      
      if (!teamId) {
        return { name: 'Organization', isCascaded: false, teamId: 'organization' };
      }
      
      const team = this.teamArr[teamId];
      if (!team) {
        // If team not found in teamArr, check if it's a deleted team
        if (this.deletedTeam && this.deletedTeam[teamId]) {
          return { name: 'Organization', isCascaded: false, teamId: 'organization' };
        }
        return { name: 'Organization', isCascaded: false, teamId: 'organization' };
      }
      
      // Check if this team is viable (same logic as dropdown)
      if (this.isTeamViable(teamId)) {
        return { name: team.name || team.team_name || 'Team', isCascaded: false, teamId: teamId };
      }
      
      // If not viable, find the viable parent
      const viableParent = this.findViableParentTeam(teamId);
      if (viableParent && viableParent.teamId !== 'organization') {
        const parentTeam = this.teamArr[viableParent.teamId];
        if (parentTeam) {
          return { name: parentTeam.name || parentTeam.team_name || 'Team', isCascaded: true, teamId: viableParent.teamId };
        }
      }
      
      // If no viable parent found, return generic label with consistent ID
      return { name: 'Organization', isCascaded: false, teamId: 'organization' };
    },
    isTeamViable(teamId) {
      // Check if a team meets privacy thresholds
      const responseCount = this.getAggregatedTeamResponseCount(teamId);
      const memberCount = this.getAggregatedTeamMemberCount(teamId);
      return responseCount >= this.MIN_RESPONSES_FOR_TEAM_NAME && 
             (!this.USE_MEMBER_COUNT_CHECK || memberCount >= this.MIN_MEMBERS_FOR_TEAM_NAME);
    },
    getTeamResponseCount(teamId) {
      // Count responses for this team in current dataset
      if (!this.dataopenend || !Array.isArray(this.dataopenend)) return 0;
      
      return this.dataopenend.filter(item => 
        item.team === teamId && !item.Summary
      ).length;
    },
    getTeamMemberCount(teamId) {
      // Get member count from allUsers data
      if (!this.allUsers || !Array.isArray(this.allUsers)) {
        console.log('No allUsers data available');
        return 0;
      }
      
      // Debug: Check what the user data looks like
      const teamUsers = this.allUsers.filter(user => user.team === teamId);
      if (teamUsers.length > 0) {
        console.log(`Sample user for team ${teamId}:`, teamUsers[0]);
      }
      
      // Try different status field names
      return this.allUsers.filter(user => 
        user.team === teamId && (user.status === 'active' || user.status === 'Y' || !user.status)
      ).length;
    },
    getAllDescendantTeams(teamId, descendants = [], visited = new Set()) {
      // Prevent infinite recursion by tracking visited teams
      if (visited.has(teamId)) {
        console.warn(`Circular reference detected for team ${teamId}`);
        return descendants;
      }
      
      visited.add(teamId);
      
      // Recursively get all child teams
      for (const [childId, childTeam] of Object.entries(this.teamArr)) {
        if (childTeam && childTeam.parent === teamId && !visited.has(childId)) {
          descendants.push(childId);
          this.getAllDescendantTeams(childId, descendants, visited);
        }
      }
      return descendants;
    },
    getAggregatedTeamResponseCount(teamId) {
      // Get response count including all child teams
      const allTeams = [teamId, ...this.getAllDescendantTeams(teamId)];
      
      if (!this.dataopenend || !Array.isArray(this.dataopenend)) return 0;
      
      return this.dataopenend.filter(item => 
        allTeams.includes(item.team) && !item.Summary
      ).length;
    },
    getAggregatedTeamMemberCount(teamId) {
      // Get member count including all child teams
      const allTeams = [teamId, ...this.getAllDescendantTeams(teamId)];
      
      if (!this.allUsers || !Array.isArray(this.allUsers)) return 0;
      
      return this.allUsers.filter(user => 
        allTeams.includes(user.team) && user.status === 'active'
      ).length;
    },
    handleTeamFilterChange(teamId) {
      this.selectedTeamFilter = teamId;
    },
    getSelectedTeamInfo() {
      if (this.selectedTeamFilter === 'all') {
        return null;
      }
      
      const selectedOption = this.availableTeamOptions.find(option => option.value === this.selectedTeamFilter);
      return selectedOption;
    },
    getTeamDepth(teamId, depth = 0, visited = new Set()) {
      // Prevent infinite recursion by tracking visited teams
      if (visited.has(teamId)) {
        console.warn(`Circular reference detected in getTeamDepth for team ${teamId}`);
        return depth;
      }
      
      visited.add(teamId);
      
      const team = this.teamArr[teamId];
      if (!team || !team.parent || !this.teamArr[team.parent]) {
        return depth;
      }
      return this.getTeamDepth(team.parent, depth + 1, visited);
    },
    getTeamColorClass(teamId) {
      if (!teamId) return 'team-color-default';
      
      // Special handling for organization fallback
      if (teamId === 'organization') {
        return 'team-color-default';
      }
      
      // Get the first-level child of the root parent for consistent branch coloring
      const branchParent = this.getBranchParentTeam(teamId);
      
      // Create a deterministic color based on branch parent ID
      const colorClasses = [
        'team-color-0', // Blue
        'team-color-1', // Purple
        'team-color-2', // Green  
        'team-color-3', // Orange
        'team-color-4'  // Pink
      ];
      
      // Use a simple hash of the branch parent ID to determine color
      let hash = 0;
      for (let i = 0; i < branchParent.length; i++) {
        hash = ((hash << 5) - hash) + branchParent.charCodeAt(i);
        hash = hash & hash; // Convert to 32bit integer
      }
      
      const colorIndex = Math.abs(hash) % colorClasses.length;
      return colorClasses[colorIndex];
    },
    getBranchParentTeam(teamId) {
      // Find the direct child of the root parent (the branch this team belongs to)
      const rootParent = this.getRootParentTeam(teamId);
      
      // If this team IS the root parent, use its ID
      if (teamId === rootParent) {
        return rootParent;
      }
      
      // Walk up the hierarchy to find the direct child of root parent
      let currentTeamId = teamId;
      let branchParent = teamId;
      
      while (currentTeamId) {
        const team = this.teamArr[currentTeamId];
        if (!team || !team.parent) break;
        
        // If the parent is the root parent, then current team is the branch parent
        if (team.parent === rootParent) {
          branchParent = currentTeamId;
          break;
        }
        
        // If the parent doesn't exist in teamArr, this might be the branch parent
        if (!this.teamArr[team.parent]) {
          branchParent = currentTeamId;
          break;
        }
        
        currentTeamId = team.parent;
      }
      
      return branchParent;
    },
    getRootParentTeam(teamId) {
      // Find the topmost parent team
      let currentTeamId = teamId;
      let rootTeam = teamId;
      const visited = new Set();
      
      while (currentTeamId) {
        // Prevent infinite loop
        if (visited.has(currentTeamId)) {
          console.warn(`Circular reference detected in getRootParentTeam for team ${currentTeamId}`);
          break;
        }
        visited.add(currentTeamId);
        
        const team = this.teamArr[currentTeamId];
        if (!team || !team.parent || !this.teamArr[team.parent]) {
          rootTeam = currentTeamId;
          break;
        }
        currentTeamId = team.parent;
      }
      
      return rootTeam;
    },
    findViableParentTeam(teamId) {
      // Find the closest parent team (including self) that meets privacy thresholds
      let currentTeamId = teamId;
      const visited = new Set();
      
      while (currentTeamId) {
        // Prevent infinite loop
        if (visited.has(currentTeamId)) {
          console.warn(`Circular reference detected in findViableParentTeam for team ${currentTeamId}`);
          break;
        }
        visited.add(currentTeamId);
        
        const team = this.teamArr[currentTeamId];
        if (!team) break;
        
        const responseCount = this.getAggregatedTeamResponseCount(currentTeamId);
        const memberCount = this.getAggregatedTeamMemberCount(currentTeamId);
        const meetsThreshold = responseCount >= this.MIN_RESPONSES_FOR_TEAM_NAME && 
                             (!this.USE_MEMBER_COUNT_CHECK || memberCount >= this.MIN_MEMBERS_FOR_TEAM_NAME);
        
        if (meetsThreshold) {
          return {
            teamId: currentTeamId,
            label: team.name || team.team_name || 'Team',
            responseCount,
            memberCount,
            depth: this.getTeamDepth(currentTeamId)
          };
        }
        
        // Move up to parent
        currentTeamId = team.parent;
      }
      
      // If no viable parent found, return Organization level
      return {
        teamId: 'organization',
        label: 'Organization',
        responseCount: this.getTeamResponseCount(teamId),
        memberCount: 0,
        depth: 0
      };
    },
    getLocalizedQuestionText(question) {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      // Check for selected language translation
      if (question.questions && question.questions[selectedLanguage]) {
        return question.questions[selectedLanguage];
      }
      
      // Fallback to English
      return question.question_en;
    },
    hasFollowUpQuestions(question) {
      // Check if question has follow-up questions assigned
      if (!question.m_choice) return false;
      
      // Check quest_id array for Yes/No questions
      if (question.m_choice.quest_id && Array.isArray(question.m_choice.quest_id)) {
        return question.m_choice.quest_id.some(id => id && id.trim() !== '');
      }
      
      // Check question_id field in options for Multiple Choice questions
      const languages = ['en', 'th', 'ms']; // Add other languages as needed
      for (const lang of languages) {
        if (question.m_choice[lang] && Array.isArray(question.m_choice[lang])) {
          for (const option of question.m_choice[lang]) {
            if (option && option.question_id && option.question_id.trim() !== '') {
              return true;
            }
          }
        }
      }
      
      return false;
    },
    getFollowUpQuestionsText(question) {
      try {
        if (!question.m_choice) return [];
        
        // Get questions from both stores to ensure we have all available questions
        const standardQuestions = this.$store.state.question.questions || [];
        const customQuestions = this.$store.state.custom.questions || [];
        const allQuestions = [...standardQuestions, ...customQuestions];
        const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
        const followUpMap = new Map(); // Use Map to group identical questions
        
        // Handle Yes/No questions (quest_id array)
        if (question.m_choice.quest_id && Array.isArray(question.m_choice.quest_id)) {
          // Get localized Yes/No labels
          const yesNoOptions = question.m_choice[selectedLanguage] || question.m_choice.en || ['No', 'Yes'];
          
          // Handle weight reversal
          let finalOptions = [...yesNoOptions];
          // if (question.m_choice.weight && (question.m_choice.weight[0] === "0" || question.m_choice.weight[0] === 0)) {
          //   finalOptions = [...yesNoOptions].reverse();
          // }
          
          question.m_choice.quest_id.forEach((id, index) => {
            if (id && id.trim() !== '') {
              const followUpQuestion = allQuestions.find(q => q.key === id);
              if (followUpQuestion) {
                const questionText = this.getLocalizedQuestionText(followUpQuestion);
                const optionText = finalOptions[index] || `Option ${index + 1}`;
                
                // Group identical questions
                if (followUpMap.has(questionText)) {
                  followUpMap.get(questionText).options.push(optionText);
                } else {
                  followUpMap.set(questionText, {
                    text: questionText,
                    options: [optionText]
                  });
                }
              }
            }
          });
        }
        
        // Handle Multiple Choice questions (question_id in options)
        const optionLanguages = [selectedLanguage, 'en', 'th', 'ms'];
        for (const lang of optionLanguages) {
          if (question.m_choice[lang] && Array.isArray(question.m_choice[lang])) {
            question.m_choice[lang].forEach((option) => {
              if (option && option.question_id && option.question_id.trim() !== '') {
                const followUpQuestion = allQuestions.find(q => q.key === option.question_id);
                if (followUpQuestion) {
                  const questionText = this.getLocalizedQuestionText(followUpQuestion);
                  const optionText = option[selectedLanguage] || option.en || option.th || 'Option';
                  
                  // Group identical questions
                  if (followUpMap.has(questionText)) {
                    followUpMap.get(questionText).options.push(optionText);
                  } else {
                    followUpMap.set(questionText, {
                      text: questionText,
                      options: [optionText]
                    });
                  }
                }
              }
            });
            break; // Only process first available language to avoid duplicates
          }
        }
        
        // Convert Map to array and remove duplicate options
        return Array.from(followUpMap.values()).map(item => ({
          text: item.text,
          options: [...new Set(item.options)] // Remove duplicate options
        }));
      } catch (error) {
        console.error('Error in getFollowUpQuestionsText:', error);
        return [];
      }
    },
    handleLanguageChange(langCode) {
      // Force component re-render when language changes
      this.$forceUpdate();
      
      // If a modal is open, refresh the question name
      if (this.currentQuestionData) {
        this.quest_name = this.getLocalizedQuestionText(this.currentQuestionData);
      }
    },
    
    // Font detection and styling methods
    getQuestionFontClass(text) {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      // Language-based font selection
      if (selectedLanguage === 'th') {
        return 'font-kanit';
      }
      if (selectedLanguage === 'zh-HK') {
        return 'font-chinese';
      }
      
      // Character-based detection as fallback
      if (text && text.match(/[ก-๙]/)) {
        return 'font-kanit';
      }
      if (text && text.match(/[\u4e00-\u9fff\u3400-\u4dbf]/)) {
        return 'font-chinese';
      }
      
      return 'font-lato';
    },
    
    getQuestionFontStyle(text) {
      const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';
      
      // Language-based font selection
      if (selectedLanguage === 'th') {
        return "font-family: 'Kanit', sans-serif";
      }
      if (selectedLanguage === 'zh-HK') {
        return "font-family: 'Noto Sans TC', sans-serif";
      }
      
      // Character-based detection as fallback
      if (text && text.match(/[ก-๙]/)) {
        return "font-family: 'Kanit', sans-serif";
      }
      if (text && text.match(/[\u4e00-\u9fff\u3400-\u4dbf]/)) {
        return "font-family: 'Noto Sans TC', sans-serif";
      }
      
      return "font-family: 'Lato', sans-serif";
    },
  },
  
};
</script>

<style lang="scss">
.flex.card {
  margin-left: 70px;
}
.divProfile {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.imgProfile {
  width: 42px;
  height: 42px;
  background: #dbdbdb;
  border-radius: 21px;
  object-fit: cover;
}
.rowDataStyle {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-top: 8px;
  padding-bottom: 8px;
  padding: 8px 40px;
  transition: 0.3s;
  &:hover {
    background: #f5f5f5;
  }
}
.RecipientsModalStyle {
  box-shadow: 0px 6px 6px #00000014;
}
.divMembersRecipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 0 24px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
}
.containerTitle {
  display: flex;
  height: 36px;
  align-items: center;
  margin-top: 28px;
}

.divContentMembers {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  margin-left: 32px;
  margin-top: 32px;
  margin-right: 32px;
}

.btnAddQuestion {
  width: 172px;
  height: 52px;
  font-size: 18px;
  font-weight: 700;
  padding: 0 0px;
}

.el-button--primary {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

.el-button--primary:hover,
.el-button--primary:focus {
  color: #fff;
  background-color: #1da4b6;
  border-color: #1da4b6;
  opacity: 1;
}

.el-button--primary:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

.txtHeaderModal {
  font-size: 20px;
  color: #2f2f2f;
  font-weight: 800;
}

.styleMoreOption {
  cursor: pointer;
  display: flex;
  justify-content: center;
  color: #4a4a4a;
  font-size: 18px;
  font-weight: 800;
  padding-top: 5px;
  padding-bottom: 3px;
}
.iconminus {
  font-size: 0.8rem;
  padding: 4px;
}
.btnAddOption {
  color: #fff;
  background-color: #6c30cc;
  border-color: #6c30cc;
}
.calendar-modal {
  width: 52px;
  height: 52px;
  background-color: #e0e0e0;
  transition: background-color 0.3s ease;
}

.calendar-modal:hover {
  background-color: #d0d0d0;
}

.refresh-calendar-btn {
  transition: opacity 0.2s ease;
}

.refresh-calendar-btn.refreshing {
  opacity: 0.5;
  pointer-events: none;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.grid-2-section {
  display: grid;
  grid-template-columns: 402px auto;
}
.grid-left {
  background-color: #11223d;
  min-height: 750px;
  .header {
    background-color: #6c30cc;
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    padding: 18px 24px;
  }
  .body {
    padding-top: 47px;
    .image-type {
      width: 52px;
      height: 52px;
      border-radius: 52px;
    }
    .question-card {
      margin-top: 50px;
      min-height: 240px;
      width: 200px;
      background-color: #fff;
      border-radius: 12px;
      > .card-header {
        min-height: 76px;
        background-color: #27bc6c;
        border-radius: 12px 12px 0 0;
      }
    }
  }
}
.grid-right {
  background-color: #f8f8f8;
  padding: 32px;
  .el-form-item__label {
    font-weight: 700;
  }
}
.title-input-form {
  font-weight: 700;
}
.recipients-count {
  font-weight: 700;
  color: #6c30cc;
  font-size: 12px;
  height: 0px;
  text-align: right;
  position: relative;
  .top-header {
    position: absolute;
    bottom: -20px;
    right: 0;
    text-decoration: underline;
  }
}
.txtResponse {
  font-weight: 700;
  font-size: 15px;
  color: #505050;
  margin: 0 24px;
  word-wrap: normal;
  word-break: normal;
}
.txtAllSummary {
  font-weight: 700;
  font-size: 15px;
  color: #505050;
  word-wrap: normal;
  word-break: normal;
}
.txtRepeats {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) 13px/16px var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal normal 13px/16px Lato;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.6;
}
.divAllSummary {
  margin: 0 24px;
}
.txtHeaderStrategic {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-15)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal bold 15px/18px Lato;
  letter-spacing: 0px;
  color: #000000;
  // margin: 0 0 0 24px;
}
.txtHeaderSummary {
  margin: 0 24px;
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-15)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal bold 15px/18px Lato;
  letter-spacing: 0px;
  color: #6C30CC;
  opacity: 1;
}

.txtTotalResponse {
  font-weight: 700;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.3);
  margin-right: 20px;
}
.txtDropdown {
  font-weight: 700;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}
.shadowBottom {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 10px 6px -6px;
  height: 16px;
  background: #fff;
  margin-left: -20px;
  margin-right: -20px;
}
.txtTeam {
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  color: #505050;
  width: 170px;
  padding-top: 2px;
}
.rowItem {
  height: 50px;
  width: 260px;
  background: #f7f7f7;
}
.headerYesNo {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 2px;
}
.headerOpenEnded {
  display: flex;
  justify-content: space-between;
}
.icon-export {
  color: #000;
  cursor: pointer;
  margin-right: 10px;
}
.summaryLayout {
  background: #6C30CC08 0% 0% no-repeat padding-box;
  border: 1px solid #6C30CC;
  border-radius: 7px;
  opacity: 1;
}

div.el-table__body-wrapper.is-scrolling-none {
  height: 520px;
}
.talkingPointsBox {
  height: 40px;
}
.talking-points {
  border-width: 0;
  border-radius: 16px;
  font-weight: 700;
  // box-shadow: 0px 2px 4px #00000029;
  transition: 0.2s;
  margin: 8px 8px 0 0;

  &:hover {
    margin-top: 5px;
    // box-shadow: 0px 5px 6px #00000019;
    margin-bottom: 3px;
  }
}
.tooltipStyleTalkingPoints {
  width: 375px;
  padding: 8px;
}
.tooltip-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.tooltip-item {
  display: flex;
  align-items: flex-start;
  padding-top : 11px;
}

.tooltip-item p {
  margin: 0;
  font-size: 12px;
}
.oi-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  background-color: rgba(108, 48, 204, 0.2); /* สีพื้นหลัง */
  // opacity: 0.2;
  color: #6C30CC; /* สีตัวอักษร */
  font-weight: bold;
  margin-right: 12px;
}
.GreenBoxStyle {
  color: #249d2a;
  background-color: #edffee;
}

.RedBoxStyle {
  color: #f44336;
  background-color: #ffedeb;
}

.GreyBoxStyle {
  color: #484848;
  // border-color: #b2b2b2;
  background-color: #f0f0f0;
}
</style>
<style lang="scss">
#question #questions_form_modal {
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-menu {
    background-color: transparent;
  }
  .el-date-editor .el-range-separator {
    width: 6%;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
  .el-form-item__error {
    font-size: 10px;
    padding-top: 0px;
  }
  .el-form-item__label {
    line-height: 40px;
  }
  .el-cascader__tags .el-tag:not(.is-hit) {
    border-color: #6c30cc;
    background-color: #6c30cc24;
    color: #6c30cc;
    font-size: 15px;
    height: 30px;
    .el-tag .el-icon-close {
      background-color: #6c30cc;
      color: #6c30cc;
    }
  }
}
#question .el-tabs__item {
  height: 52px;
  line-height: 52px;
  width: 200px;
  text-align: center;
}

#question .el-tabs__header {
  margin: 0px;
}

#question .el-menu--horizontal > .el-menu-item {
  color: rgba(0, 0, 0, 0.62);
  font-size: 16px;
  font-weight: 400;
  height: 52px;
}

#question .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus .el-menu-item:hover {
  background-color: transparent;
  color: #6c30cc;
}

#question .el-menu--horizontal > .el-menu-item.is-active {
  background-color: transparent;
  border-bottom: 2px solid #6c30cc;
  color: #6c30cc;
  font-weight: 700;
}

#question .el-form-item__label {
  padding-right: 24px;
}

#question .el-dialog__body {
  padding-top: 0px;
  padding-bottom: 8px;
}

#question .el-dialog__header {
  padding-top: 32px;
  padding-left: 32px;
  padding-bottom: 0px;
}

/* Making the close button the same size across different modal windows */
#question i.el-dialog__close.el-icon.el-icon-close {
  font-size: 26px;
  margin-top: 12px;
  margin-right: 12px;
}
#question i.el-select__caret.el-input__icon.el-icon-arrow-up {
  color: #000;
  font-size: 16px;
  font-weight: bold;
}
#question i.el-icon-caret-right {
  margin-top: 20px;
}
#question .bar-results {
  height: 50px;
  text-align: center;
  color: #fff;
  padding-top: 16px;
  font-size: 16px;
}
#question .box {
  height: 20px;
  width: 20px;
  border-radius: 4px;
}
.box.color-1,
#question .bar-results.color-1 {
  background-color: #d33e3e;
}
.box.color-2,
#question .bar-results.color-2 {
  background-color: #ff4e4e;
}
.box.color-3,
#question .bar-results.color-3 {
  background-color: #eed24e;
}
.box.color-4,
#question .bar-results.color-4 {
  background-color: #76ca7d;
}
.box.color-5,
#question .bar-results.color-5 {
  background-color: #00b383;
}
.box.color-6,
#question .bar-results.color-6 {
  background-color: #068462;
}
#otherTable div.el-table__body-wrapper.is-scrolling-none,
#scaleTable div.el-table__body-wrapper.is-scrolling-none,
#yesNoTable div.el-table__body-wrapper.is-scrolling-none {
  height: 420px !important;

  // thin-scrollbar
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e0e0e0;
    border-radius: 4px;
  }
}

#otherTable div.el-table__expand-icon,
#scaleTable div.el-table__expand-icon,
#yesNoTable div.el-table__expand-icon {
  color: #ffffff;
}

#otherTable i.el-icon-caret-bottom,
#scaleTable i.el-icon-caret-bottom,
#yesNoTable i.el-icon-caret-bottom {
  color: #000000;
  margin-bottom: 4px;
  cursor: pointer;
}

#otherTable i.el-icon-caret-right,
#scaleTable i.el-icon-caret-right,
#yesNoTable i.el-icon-caret-right {
  color: #000000;
  margin-bottom: 20px;
  cursor: pointer;
}

#question #calendarModal {
  .el-dialog__header {
    padding-top: 40px;
    padding-left: 40px;

    > .el-dialog__title {
      font-size: 20px;
      color: #000;
    }
  }

  .el-dialog__body {
    padding-bottom: 40px;
    padding-left: 40px;

    .line-shadow {
      width: calc(900px + 60px);
      box-shadow: 0px 6px 6px #00000014;
      margin-left: -40px;
      margin-top: -7px;
      height: 6px;
    }

    .calendar-container {
      display: grid;
      grid-template-columns: 150px 150px 150px 150px 150px 68px 68px;

      .day-of-week-title {
        font-size: 16px;
        font-weight: 700;
        color: #000;
        text-align: center;
        padding: 24px 14px 16px;
      }

      .day-box {
        position: relative;
        height: 84px;
        border: 1px solid rgba(0, 0, 0, 0.07);
        padding: 12px;
        transition: 0.2s;

        .title {
          font-size: 13px;
          font-weight: 400;
          color: #000000;
          opacity: 0.5;
        }

        .questions-card {
          background-color: rgba(0, 0, 0, 0.07);
          color: #000000;
          border-radius: 2px;
          font-size: 10px;
          padding: 3px 7px;
          margin-bottom: 1px;
          font-weight: 700;

          > img {
            margin-right: 5px;
          }
        }
      }
      .day-box.more-than-five {
        // box-shadow: inset 0 0 5px rgba(255, 0, 0, 0.6);
      }
      .more-than-five .questions-card, .more-than-five .legend-box {
        background-color: rgba(255, 115, 0, 0.1);
      }
      .less-than-four .questions-card, .less-than-four .legend-box {
        background-color: rgba(0, 255, 136, 0.1);
      }

      input[type="radio"]:checked + label > .day-box {
        border-color: #d1d1d1;
        background-color: #efe5ff;

        .title {
          color: #6c30cc;
          font-weight: 700;
          opacity: 1;
        }

        .questions-card {
          background-color: #6c30cc;
          color: #ffffff;
          user-select: none;
          > span {
            opacity: 1;
          }
        }
      }

      input[type="radio"] {
        display: none;
      }
    }
  }
}
.legend-container {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.legend-box {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  margin-right: 6px;
  display: inline-block;
}
.legend-item {
  display: flex;
  align-items: center;
}
.legend-item-label {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.more-than-five .legend-box {
  background-color: rgba(255, 115, 0, 0.2);
}
.less-than-four .legend-box {
  background-color: rgba(0, 255, 136, 0.2);
}

// Open-ended count badge styles
.open-ended-count-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  height: 16px;
  padding: 1px 4px 1px 3px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
  z-index: 10;
  user-select: none;

  .badge-icon {
    width: 9px;
    height: 9px;
    flex-shrink: 0;
    opacity: 0.4;
  }

  .badge-count {
    font-size: 10px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.5);
    line-height: 1;
  }

  &.count-warning {
    // height: 18px;
    padding: 1px 7px 1px 5px;
    background-color: #F7B924;
    border: none;
    border-radius: 10px;
    gap: 3px;

    .badge-icon {
      width: 10px;
      height: 10px;
      opacity: 0.8;
    }

    .badge-count {
      font-size: 11px;
      font-weight: 600;
      color: #00000080;
    }
  }
}

.legend-count-badge {
  height: 16px;
  padding: 2px 5px 2px 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-right: 6px;
  flex-shrink: 0;

  .legend-badge-icon {
    width: 9px;
    height: 9px;
    opacity: 0.6;
  }

  .legend-badge-count {
    font-size: 10px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.65);
    line-height: 1;
  }

  &.warning {
    height: 18px;
    padding: 2px 6px 2px 4px;
    background-color: #F7B924;
    border: none;
    border-radius: 10px;
    gap: 3px;

    .legend-badge-icon {
      width: 10px;
      height: 10px;
      opacity: 1;
    }

    .legend-badge-count {
      font-size: 11px;
      font-weight: 600;
      color: #ffffff;
    }
  }
}

.open-ended-count,
.open-ended-warning {
  display: flex;
  align-items: center;
}

#yesNoTable .el-table__body tr > td.el-table__cell,
#scaleTable .el-table__body tr > td.el-table__cell,
#otherTable .el-table__body tr > td.el-table__cell {
  &:first-of-type {
    border-radius: 6px 0 0 6px;
  }
  &:last-of-type {
    border-radius: 0 6px 6px 0;
  }
  transition: 0.3s;
  .el-icon-caret-bottom,
  .el-icon-caret-right,
  .rowItem {
    transition: 0.3s;
    .txtTeam {
      transition: 0.3s;
    }
  }
}
#yesNoTable.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell,
#scaleTable.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell,
#otherTable.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: #e4d2ff;
  &:first-of-type {
    border-radius: 6px 0 0 6px;
  }
  &:last-of-type {
    border-radius: 0 6px 6px 0;
  }
  .rowItem {
    background-color: #e4d2ff;
    .txtTeam {
      color: #333;
    }
  }
  .fc-000000 .ml-auto,
  .el-icon-caret-bottom,
  .el-icon-caret-right {
    color: #333;
  }
  .opa-07 {
    opacity: 1;
  }
}
#openEndedTable div.el-table__body-wrapper.is-scrolling-none {
  height: 470px !important;
}
.custom-textarea .el-textarea__inner {
  width: 584px;
  height: 104px;
  font-size: 16px;
  resize: none;
  word-wrap:break-word;
  word-break:keep-all;
  padding-top: 16px;
}
.custom-textarea .el-textarea__inner:focus {
  border-color: #6c30cc;
}
.generate-question {
  background-color: #6c30cc !important;
  border-color:#6c30cc !important;
  width: 126px;
  height: 27px;
  font-size: 12px;
  display: flex;
  justify-content: center; 
  align-items: center;   
  padding: 0 16px;       
  text-align: center;    
}

/* Team Filter Dropdown Styles */
.drop-down-container {
  margin-left: 12px;
  height: 40px;
  border-radius: 4px;
  padding: 0 8px 0 12px;
  min-width: 90px;
}

.drop-down-container.active {
  margin-left: 10px;
  background-color: rgba(#32C2D5, 0.1);
  padding: 0 6px 0 10px;
}

.text-drop-down {
  color: #00ACC1;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  
  .aggregation-indicator {
    margin-left: 6px;
    opacity: 0.7;
    vertical-align: text-bottom;
  }
}

.team-dropdown-header {
  padding: 12px 16px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
  font-size: 13px;
  font-weight: 700;
  color: #626262;
}

.team-search-container {
  padding: 8px 12px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fff;
}

.team-dropdown-content {
  max-height: 280px;
  overflow-y: auto;
}

.team-option-content {
  padding: 4px 0;
  min-height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.team-option-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 8px;
}

.team-name {
  font-weight: 600;
  color: #333;
  flex: 1;
  text-align: left;
  margin-right: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.team-response-count {
  font-size: 12px;
  color: #626262;
  font-weight: 400;
  margin-left: 8px;
  white-space: nowrap;
}

.selected-team {
  background-color: rgba(50, 194, 213, 0.1) !important;
}

.no-teams-found {
  padding: 16px;
  text-align: center;
  color: #909399;
  font-size: 13px;
  font-style: italic;
}

.feedback-team-label {
  align-self: flex-start;
  margin: 0 24px 8px 24px;
  padding: 4px 12px;
  background-color: #f0f0f0;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #626262;
  display: inline-block;
  
  // Color coding for different team hierarchy levels
  &.team-color-0 {
    background-color: #e3f2fd;
    color: #1976d2;
    border: 1px solid #bbdefb;
  }
  
  &.team-color-1 {
    background-color: #f3e5f5;
    color: #7b1fa2;
    border: 1px solid #ce93d8;
  }
  
  &.team-color-2 {
    background-color: #e8f5e8;
    color: #388e3c;
    border: 1px solid #a5d6a7;
  }
  
  &.team-color-3 {
    background-color: #fff3e0;
    color: #f57c00;
    border: 1px solid #ffcc02;
  }
  
  &.team-color-4 {
    background-color: #fce4ec;
    color: #c2185b;
    border: 1px solid #f8bbd9;
  }
  
  &.team-color-default {
    background-color: #f5f5f5;
    color: #616161;
    border: 1px solid #e0e0e0;
  }
}

.aggregation-info-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #f0fafb;
  border: 1px solid #32c2d5;
  border-radius: 4px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #00ACC1;
  
  i {
    font-size: 16px;
  }
}

.filtered-indicator {
  color: #32c2d5;
  font-size: 14px;
  font-weight: 600;
}

.txtResponse {
  font-weight: 700;
  font-size: 15px;
  color: #505050;
  margin: 0 24px;
  word-wrap: normal;
  word-break: normal;
  text-align: left;
  line-height: 1.5;
}

.headerOpenEnded {
  display: flex;
  justify-content: space-between;
}

.txtTotalResponse {
  font-weight: 700;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.3);
  margin-right: 20px;
}

.txtDropdown {
  font-weight: 700;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}

.shadowBottom {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 10px 6px -6px;
  height: 16px;
  background: #fff;
  margin-left: -20px;
  margin-right: -20px;
}

.summaryLayout {
  background: #6C30CC08 0% 0% no-repeat padding-box;
  border: 1px solid #6C30CC;
  border-radius: 7px;
  opacity: 1;
}

.talkingPointsBox {
  height: 40px;
}

.talking-points {
  border-width: 0;
  border-radius: 16px;
  font-weight: 700;
  transition: 0.2s;
  margin: 8px 8px 0 0;

  &:hover {
    margin-top: 5px;
    margin-bottom: 3px;
  }
}

.tooltipStyleTalkingPoints {
  width: 375px;
  padding: 8px;
}

.tooltip-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tooltip-item {
  display: flex;
  align-items: flex-start;
  padding-top: 11px;
}

.tooltip-item p {
  margin: 0;
  font-size: 12px;
}

.oi-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  background-color: rgba(108, 48, 204, 0.2);
  color: #6C30CC;
  font-weight: bold;
  margin-right: 12px;
}

.GreenBoxStyle {
  color: #249d2a;
  background-color: #edffee;
}

.RedBoxStyle {
  color: #f44336;
  background-color: #ffedeb;
}

.GreyBoxStyle {
  color: #484848;
  background-color: #f0f0f0;
}

.txtHeaderSummary {
  margin: 0 24px;
  font: normal normal bold 15px/18px Lato;
  letter-spacing: 0px;
  color: #6C30CC;
  opacity: 1;
}

.txtAllSummary {
  font-weight: 700;
  font-size: 15px;
  color: #505050;
  word-wrap: normal;
  word-break: normal;
}

.txtRepeats {
  font: normal normal normal 13px/16px Lato;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.6;
}

.divAllSummary {
  margin: 0 24px;
}

.icon-export {
  color: #000;
  margin-right: 10px;
}

/* Question Meta Badges */
.question-meta-badges {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
}

.question-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.badge-multiple-choice {
  background-color: rgba(33, 150, 243, 0.15) !important;
  color: rgba(13, 71, 161, 0.9) !important;
}

.badge-yes-no {
  background-color: rgba(76, 175, 80, 0.15) !important;
  color: rgba(27, 94, 32, 0.9) !important;
}

.badge-scale {
  background-color: rgba(156, 39, 176, 0.15) !important;
  color: rgba(74, 20, 140, 0.9) !important;
}

.badge-text-area {
  background-color: rgba(158, 158, 158, 0.15) !important;
  color: rgba(66, 66, 66, 0.9) !important;
}

.badge-follow-up {
  background-color: rgba(255, 152, 0, 0.15) !important;
  color: rgba(230, 81, 0, 0.9) !important;
}

.badge-default {
  background-color: rgba(158, 158, 158, 0.15) !important;
  color: rgba(97, 97, 97, 0.9) !important;
}

/* Power Skill Badge */
.power-skill-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background-color: rgba(247, 117, 17, 0.15) !important;
  color: rgba(183, 69, 0, 0.9) !important;
  line-height: 1.2;
  white-space: nowrap;
}

/* Frequency Tags */
.frequency-tag {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 1.3;
  white-space: nowrap;
}

.tag-biannual {
  background-color: rgba(239, 108, 0, 0.15) !important;
  color: rgba(191, 54, 12, 0.9) !important;
}

.tag-yearly {
  background-color: rgba(0, 150, 136, 0.15) !important;
  color: rgba(0, 77, 64, 0.9) !important;
}

.tag-follow-up {
  background-color: rgba(158, 158, 158, 0.15) !important;
  color: rgba(97, 97, 97, 0.9) !important;
}

.tag-default {
  background-color: rgba(84, 110, 122, 0.15) !important;
  color: rgba(38, 50, 56, 0.9) !important;
}
</style>
